export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** Text content with rich formatting capabilities using a Prismic format called Structured Text. */
  PrismicStructuredText: any;
};

export type AvifOptions = {
  quality?: InputMaybe<Scalars['Int']>;
  lossless?: InputMaybe<Scalars['Boolean']>;
  speed?: InputMaybe<Scalars['Int']>;
};

export type BlurredOptions = {
  /** Width of the generated low-res preview. Default is 20px */
  width?: InputMaybe<Scalars['Int']>;
  /** Force the output format for the low-res preview. Default is to use the same format as the input. You should rarely need to change this */
  toFormat?: InputMaybe<ImageFormat>;
};

export type BooleanQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
};

export type DateQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Date']>;
  ne?: InputMaybe<Scalars['Date']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
};

export type Directory = Node & {
  sourceInstanceName: Scalars['String'];
  absolutePath: Scalars['String'];
  relativePath: Scalars['String'];
  extension: Scalars['String'];
  size: Scalars['Int'];
  prettySize: Scalars['String'];
  modifiedTime: Scalars['Date'];
  accessTime: Scalars['Date'];
  changeTime: Scalars['Date'];
  birthTime: Scalars['Date'];
  root: Scalars['String'];
  dir: Scalars['String'];
  base: Scalars['String'];
  ext: Scalars['String'];
  name: Scalars['String'];
  relativeDirectory: Scalars['String'];
  dev: Scalars['Int'];
  mode: Scalars['Int'];
  nlink: Scalars['Int'];
  uid: Scalars['Int'];
  gid: Scalars['Int'];
  rdev: Scalars['Int'];
  ino: Scalars['Float'];
  atimeMs: Scalars['Float'];
  mtimeMs: Scalars['Float'];
  ctimeMs: Scalars['Float'];
  atime: Scalars['Date'];
  mtime: Scalars['Date'];
  ctime: Scalars['Date'];
  /** @deprecated Use `birthTime` instead */
  birthtime?: Maybe<Scalars['Date']>;
  /** @deprecated Use `birthTime` instead */
  birthtimeMs?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type DirectoryModifiedTimeArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectoryAccessTimeArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectoryChangeTimeArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectoryBirthTimeArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectoryAtimeArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectoryMtimeArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type DirectoryCtimeArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type DirectoryConnection = {
  totalCount: Scalars['Int'];
  edges: Array<DirectoryEdge>;
  nodes: Array<Directory>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<DirectoryGroupConnection>;
};


export type DirectoryConnectionDistinctArgs = {
  field: DirectoryFieldsEnum;
};


export type DirectoryConnectionMaxArgs = {
  field: DirectoryFieldsEnum;
};


export type DirectoryConnectionMinArgs = {
  field: DirectoryFieldsEnum;
};


export type DirectoryConnectionSumArgs = {
  field: DirectoryFieldsEnum;
};


export type DirectoryConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: DirectoryFieldsEnum;
};

export type DirectoryEdge = {
  next?: Maybe<Directory>;
  node: Directory;
  previous?: Maybe<Directory>;
};

export enum DirectoryFieldsEnum {
  sourceInstanceName = 'sourceInstanceName',
  absolutePath = 'absolutePath',
  relativePath = 'relativePath',
  extension = 'extension',
  size = 'size',
  prettySize = 'prettySize',
  modifiedTime = 'modifiedTime',
  accessTime = 'accessTime',
  changeTime = 'changeTime',
  birthTime = 'birthTime',
  root = 'root',
  dir = 'dir',
  base = 'base',
  ext = 'ext',
  name = 'name',
  relativeDirectory = 'relativeDirectory',
  dev = 'dev',
  mode = 'mode',
  nlink = 'nlink',
  uid = 'uid',
  gid = 'gid',
  rdev = 'rdev',
  ino = 'ino',
  atimeMs = 'atimeMs',
  mtimeMs = 'mtimeMs',
  ctimeMs = 'ctimeMs',
  atime = 'atime',
  mtime = 'mtime',
  ctime = 'ctime',
  birthtime = 'birthtime',
  birthtimeMs = 'birthtimeMs',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type DirectoryFilterInput = {
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type DirectoryGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<DirectoryEdge>;
  nodes: Array<Directory>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<DirectoryGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type DirectoryGroupConnectionDistinctArgs = {
  field: DirectoryFieldsEnum;
};


export type DirectoryGroupConnectionMaxArgs = {
  field: DirectoryFieldsEnum;
};


export type DirectoryGroupConnectionMinArgs = {
  field: DirectoryFieldsEnum;
};


export type DirectoryGroupConnectionSumArgs = {
  field: DirectoryFieldsEnum;
};


export type DirectoryGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: DirectoryFieldsEnum;
};

export type DirectorySortInput = {
  fields?: InputMaybe<Array<InputMaybe<DirectoryFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type DuotoneGradient = {
  highlight: Scalars['String'];
  shadow: Scalars['String'];
  opacity?: InputMaybe<Scalars['Int']>;
};

export type File = Node & {
  sourceInstanceName: Scalars['String'];
  absolutePath: Scalars['String'];
  relativePath: Scalars['String'];
  extension: Scalars['String'];
  size: Scalars['Int'];
  prettySize: Scalars['String'];
  modifiedTime: Scalars['Date'];
  accessTime: Scalars['Date'];
  changeTime: Scalars['Date'];
  birthTime: Scalars['Date'];
  root: Scalars['String'];
  dir: Scalars['String'];
  base: Scalars['String'];
  ext: Scalars['String'];
  name: Scalars['String'];
  relativeDirectory: Scalars['String'];
  dev: Scalars['Int'];
  mode: Scalars['Int'];
  nlink: Scalars['Int'];
  uid: Scalars['Int'];
  gid: Scalars['Int'];
  rdev: Scalars['Int'];
  ino: Scalars['Float'];
  atimeMs: Scalars['Float'];
  mtimeMs: Scalars['Float'];
  ctimeMs: Scalars['Float'];
  atime: Scalars['Date'];
  mtime: Scalars['Date'];
  ctime: Scalars['Date'];
  /** @deprecated Use `birthTime` instead */
  birthtime?: Maybe<Scalars['Date']>;
  /** @deprecated Use `birthTime` instead */
  birthtimeMs?: Maybe<Scalars['Float']>;
  blksize?: Maybe<Scalars['Int']>;
  blocks?: Maybe<Scalars['Int']>;
  /** Copy file to static directory and return public url to it */
  publicURL?: Maybe<Scalars['String']>;
  /** Returns all children nodes filtered by type ImageSharp */
  childrenImageSharp?: Maybe<Array<Maybe<ImageSharp>>>;
  /** Returns the first child node of type ImageSharp or null if there are no children of given type on this node */
  childImageSharp?: Maybe<ImageSharp>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type FileModifiedTimeArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FileAccessTimeArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FileChangeTimeArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FileBirthTimeArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FileAtimeArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FileMtimeArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type FileCtimeArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type FileConnection = {
  totalCount: Scalars['Int'];
  edges: Array<FileEdge>;
  nodes: Array<File>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<FileGroupConnection>;
};


export type FileConnectionDistinctArgs = {
  field: FileFieldsEnum;
};


export type FileConnectionMaxArgs = {
  field: FileFieldsEnum;
};


export type FileConnectionMinArgs = {
  field: FileFieldsEnum;
};


export type FileConnectionSumArgs = {
  field: FileFieldsEnum;
};


export type FileConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: FileFieldsEnum;
};

export type FileEdge = {
  next?: Maybe<File>;
  node: File;
  previous?: Maybe<File>;
};

export enum FileFieldsEnum {
  sourceInstanceName = 'sourceInstanceName',
  absolutePath = 'absolutePath',
  relativePath = 'relativePath',
  extension = 'extension',
  size = 'size',
  prettySize = 'prettySize',
  modifiedTime = 'modifiedTime',
  accessTime = 'accessTime',
  changeTime = 'changeTime',
  birthTime = 'birthTime',
  root = 'root',
  dir = 'dir',
  base = 'base',
  ext = 'ext',
  name = 'name',
  relativeDirectory = 'relativeDirectory',
  dev = 'dev',
  mode = 'mode',
  nlink = 'nlink',
  uid = 'uid',
  gid = 'gid',
  rdev = 'rdev',
  ino = 'ino',
  atimeMs = 'atimeMs',
  mtimeMs = 'mtimeMs',
  ctimeMs = 'ctimeMs',
  atime = 'atime',
  mtime = 'mtime',
  ctime = 'ctime',
  birthtime = 'birthtime',
  birthtimeMs = 'birthtimeMs',
  blksize = 'blksize',
  blocks = 'blocks',
  publicURL = 'publicURL',
  childrenImageSharp = 'childrenImageSharp',
  childrenImageSharp___fixed___base64 = 'childrenImageSharp___fixed___base64',
  childrenImageSharp___fixed___tracedSVG = 'childrenImageSharp___fixed___tracedSVG',
  childrenImageSharp___fixed___aspectRatio = 'childrenImageSharp___fixed___aspectRatio',
  childrenImageSharp___fixed___width = 'childrenImageSharp___fixed___width',
  childrenImageSharp___fixed___height = 'childrenImageSharp___fixed___height',
  childrenImageSharp___fixed___src = 'childrenImageSharp___fixed___src',
  childrenImageSharp___fixed___srcSet = 'childrenImageSharp___fixed___srcSet',
  childrenImageSharp___fixed___srcWebp = 'childrenImageSharp___fixed___srcWebp',
  childrenImageSharp___fixed___srcSetWebp = 'childrenImageSharp___fixed___srcSetWebp',
  childrenImageSharp___fixed___originalName = 'childrenImageSharp___fixed___originalName',
  childrenImageSharp___fluid___base64 = 'childrenImageSharp___fluid___base64',
  childrenImageSharp___fluid___tracedSVG = 'childrenImageSharp___fluid___tracedSVG',
  childrenImageSharp___fluid___aspectRatio = 'childrenImageSharp___fluid___aspectRatio',
  childrenImageSharp___fluid___src = 'childrenImageSharp___fluid___src',
  childrenImageSharp___fluid___srcSet = 'childrenImageSharp___fluid___srcSet',
  childrenImageSharp___fluid___srcWebp = 'childrenImageSharp___fluid___srcWebp',
  childrenImageSharp___fluid___srcSetWebp = 'childrenImageSharp___fluid___srcSetWebp',
  childrenImageSharp___fluid___sizes = 'childrenImageSharp___fluid___sizes',
  childrenImageSharp___fluid___originalImg = 'childrenImageSharp___fluid___originalImg',
  childrenImageSharp___fluid___originalName = 'childrenImageSharp___fluid___originalName',
  childrenImageSharp___fluid___presentationWidth = 'childrenImageSharp___fluid___presentationWidth',
  childrenImageSharp___fluid___presentationHeight = 'childrenImageSharp___fluid___presentationHeight',
  childrenImageSharp___gatsbyImageData = 'childrenImageSharp___gatsbyImageData',
  childrenImageSharp___original___width = 'childrenImageSharp___original___width',
  childrenImageSharp___original___height = 'childrenImageSharp___original___height',
  childrenImageSharp___original___src = 'childrenImageSharp___original___src',
  childrenImageSharp___resize___src = 'childrenImageSharp___resize___src',
  childrenImageSharp___resize___tracedSVG = 'childrenImageSharp___resize___tracedSVG',
  childrenImageSharp___resize___width = 'childrenImageSharp___resize___width',
  childrenImageSharp___resize___height = 'childrenImageSharp___resize___height',
  childrenImageSharp___resize___aspectRatio = 'childrenImageSharp___resize___aspectRatio',
  childrenImageSharp___resize___originalName = 'childrenImageSharp___resize___originalName',
  childrenImageSharp___id = 'childrenImageSharp___id',
  childrenImageSharp___parent___id = 'childrenImageSharp___parent___id',
  childrenImageSharp___parent___parent___id = 'childrenImageSharp___parent___parent___id',
  childrenImageSharp___parent___parent___children = 'childrenImageSharp___parent___parent___children',
  childrenImageSharp___parent___children = 'childrenImageSharp___parent___children',
  childrenImageSharp___parent___children___id = 'childrenImageSharp___parent___children___id',
  childrenImageSharp___parent___children___children = 'childrenImageSharp___parent___children___children',
  childrenImageSharp___parent___internal___content = 'childrenImageSharp___parent___internal___content',
  childrenImageSharp___parent___internal___contentDigest = 'childrenImageSharp___parent___internal___contentDigest',
  childrenImageSharp___parent___internal___description = 'childrenImageSharp___parent___internal___description',
  childrenImageSharp___parent___internal___fieldOwners = 'childrenImageSharp___parent___internal___fieldOwners',
  childrenImageSharp___parent___internal___ignoreType = 'childrenImageSharp___parent___internal___ignoreType',
  childrenImageSharp___parent___internal___mediaType = 'childrenImageSharp___parent___internal___mediaType',
  childrenImageSharp___parent___internal___owner = 'childrenImageSharp___parent___internal___owner',
  childrenImageSharp___parent___internal___type = 'childrenImageSharp___parent___internal___type',
  childrenImageSharp___children = 'childrenImageSharp___children',
  childrenImageSharp___children___id = 'childrenImageSharp___children___id',
  childrenImageSharp___children___parent___id = 'childrenImageSharp___children___parent___id',
  childrenImageSharp___children___parent___children = 'childrenImageSharp___children___parent___children',
  childrenImageSharp___children___children = 'childrenImageSharp___children___children',
  childrenImageSharp___children___children___id = 'childrenImageSharp___children___children___id',
  childrenImageSharp___children___children___children = 'childrenImageSharp___children___children___children',
  childrenImageSharp___children___internal___content = 'childrenImageSharp___children___internal___content',
  childrenImageSharp___children___internal___contentDigest = 'childrenImageSharp___children___internal___contentDigest',
  childrenImageSharp___children___internal___description = 'childrenImageSharp___children___internal___description',
  childrenImageSharp___children___internal___fieldOwners = 'childrenImageSharp___children___internal___fieldOwners',
  childrenImageSharp___children___internal___ignoreType = 'childrenImageSharp___children___internal___ignoreType',
  childrenImageSharp___children___internal___mediaType = 'childrenImageSharp___children___internal___mediaType',
  childrenImageSharp___children___internal___owner = 'childrenImageSharp___children___internal___owner',
  childrenImageSharp___children___internal___type = 'childrenImageSharp___children___internal___type',
  childrenImageSharp___internal___content = 'childrenImageSharp___internal___content',
  childrenImageSharp___internal___contentDigest = 'childrenImageSharp___internal___contentDigest',
  childrenImageSharp___internal___description = 'childrenImageSharp___internal___description',
  childrenImageSharp___internal___fieldOwners = 'childrenImageSharp___internal___fieldOwners',
  childrenImageSharp___internal___ignoreType = 'childrenImageSharp___internal___ignoreType',
  childrenImageSharp___internal___mediaType = 'childrenImageSharp___internal___mediaType',
  childrenImageSharp___internal___owner = 'childrenImageSharp___internal___owner',
  childrenImageSharp___internal___type = 'childrenImageSharp___internal___type',
  childImageSharp___fixed___base64 = 'childImageSharp___fixed___base64',
  childImageSharp___fixed___tracedSVG = 'childImageSharp___fixed___tracedSVG',
  childImageSharp___fixed___aspectRatio = 'childImageSharp___fixed___aspectRatio',
  childImageSharp___fixed___width = 'childImageSharp___fixed___width',
  childImageSharp___fixed___height = 'childImageSharp___fixed___height',
  childImageSharp___fixed___src = 'childImageSharp___fixed___src',
  childImageSharp___fixed___srcSet = 'childImageSharp___fixed___srcSet',
  childImageSharp___fixed___srcWebp = 'childImageSharp___fixed___srcWebp',
  childImageSharp___fixed___srcSetWebp = 'childImageSharp___fixed___srcSetWebp',
  childImageSharp___fixed___originalName = 'childImageSharp___fixed___originalName',
  childImageSharp___fluid___base64 = 'childImageSharp___fluid___base64',
  childImageSharp___fluid___tracedSVG = 'childImageSharp___fluid___tracedSVG',
  childImageSharp___fluid___aspectRatio = 'childImageSharp___fluid___aspectRatio',
  childImageSharp___fluid___src = 'childImageSharp___fluid___src',
  childImageSharp___fluid___srcSet = 'childImageSharp___fluid___srcSet',
  childImageSharp___fluid___srcWebp = 'childImageSharp___fluid___srcWebp',
  childImageSharp___fluid___srcSetWebp = 'childImageSharp___fluid___srcSetWebp',
  childImageSharp___fluid___sizes = 'childImageSharp___fluid___sizes',
  childImageSharp___fluid___originalImg = 'childImageSharp___fluid___originalImg',
  childImageSharp___fluid___originalName = 'childImageSharp___fluid___originalName',
  childImageSharp___fluid___presentationWidth = 'childImageSharp___fluid___presentationWidth',
  childImageSharp___fluid___presentationHeight = 'childImageSharp___fluid___presentationHeight',
  childImageSharp___gatsbyImageData = 'childImageSharp___gatsbyImageData',
  childImageSharp___original___width = 'childImageSharp___original___width',
  childImageSharp___original___height = 'childImageSharp___original___height',
  childImageSharp___original___src = 'childImageSharp___original___src',
  childImageSharp___resize___src = 'childImageSharp___resize___src',
  childImageSharp___resize___tracedSVG = 'childImageSharp___resize___tracedSVG',
  childImageSharp___resize___width = 'childImageSharp___resize___width',
  childImageSharp___resize___height = 'childImageSharp___resize___height',
  childImageSharp___resize___aspectRatio = 'childImageSharp___resize___aspectRatio',
  childImageSharp___resize___originalName = 'childImageSharp___resize___originalName',
  childImageSharp___id = 'childImageSharp___id',
  childImageSharp___parent___id = 'childImageSharp___parent___id',
  childImageSharp___parent___parent___id = 'childImageSharp___parent___parent___id',
  childImageSharp___parent___parent___children = 'childImageSharp___parent___parent___children',
  childImageSharp___parent___children = 'childImageSharp___parent___children',
  childImageSharp___parent___children___id = 'childImageSharp___parent___children___id',
  childImageSharp___parent___children___children = 'childImageSharp___parent___children___children',
  childImageSharp___parent___internal___content = 'childImageSharp___parent___internal___content',
  childImageSharp___parent___internal___contentDigest = 'childImageSharp___parent___internal___contentDigest',
  childImageSharp___parent___internal___description = 'childImageSharp___parent___internal___description',
  childImageSharp___parent___internal___fieldOwners = 'childImageSharp___parent___internal___fieldOwners',
  childImageSharp___parent___internal___ignoreType = 'childImageSharp___parent___internal___ignoreType',
  childImageSharp___parent___internal___mediaType = 'childImageSharp___parent___internal___mediaType',
  childImageSharp___parent___internal___owner = 'childImageSharp___parent___internal___owner',
  childImageSharp___parent___internal___type = 'childImageSharp___parent___internal___type',
  childImageSharp___children = 'childImageSharp___children',
  childImageSharp___children___id = 'childImageSharp___children___id',
  childImageSharp___children___parent___id = 'childImageSharp___children___parent___id',
  childImageSharp___children___parent___children = 'childImageSharp___children___parent___children',
  childImageSharp___children___children = 'childImageSharp___children___children',
  childImageSharp___children___children___id = 'childImageSharp___children___children___id',
  childImageSharp___children___children___children = 'childImageSharp___children___children___children',
  childImageSharp___children___internal___content = 'childImageSharp___children___internal___content',
  childImageSharp___children___internal___contentDigest = 'childImageSharp___children___internal___contentDigest',
  childImageSharp___children___internal___description = 'childImageSharp___children___internal___description',
  childImageSharp___children___internal___fieldOwners = 'childImageSharp___children___internal___fieldOwners',
  childImageSharp___children___internal___ignoreType = 'childImageSharp___children___internal___ignoreType',
  childImageSharp___children___internal___mediaType = 'childImageSharp___children___internal___mediaType',
  childImageSharp___children___internal___owner = 'childImageSharp___children___internal___owner',
  childImageSharp___children___internal___type = 'childImageSharp___children___internal___type',
  childImageSharp___internal___content = 'childImageSharp___internal___content',
  childImageSharp___internal___contentDigest = 'childImageSharp___internal___contentDigest',
  childImageSharp___internal___description = 'childImageSharp___internal___description',
  childImageSharp___internal___fieldOwners = 'childImageSharp___internal___fieldOwners',
  childImageSharp___internal___ignoreType = 'childImageSharp___internal___ignoreType',
  childImageSharp___internal___mediaType = 'childImageSharp___internal___mediaType',
  childImageSharp___internal___owner = 'childImageSharp___internal___owner',
  childImageSharp___internal___type = 'childImageSharp___internal___type',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type FileFilterInput = {
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  blksize?: InputMaybe<IntQueryOperatorInput>;
  blocks?: InputMaybe<IntQueryOperatorInput>;
  publicURL?: InputMaybe<StringQueryOperatorInput>;
  childrenImageSharp?: InputMaybe<ImageSharpFilterListInput>;
  childImageSharp?: InputMaybe<ImageSharpFilterInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type FileGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<FileEdge>;
  nodes: Array<File>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<FileGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type FileGroupConnectionDistinctArgs = {
  field: FileFieldsEnum;
};


export type FileGroupConnectionMaxArgs = {
  field: FileFieldsEnum;
};


export type FileGroupConnectionMinArgs = {
  field: FileFieldsEnum;
};


export type FileGroupConnectionSumArgs = {
  field: FileFieldsEnum;
};


export type FileGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: FileFieldsEnum;
};

export type FileSortInput = {
  fields?: InputMaybe<Array<InputMaybe<FileFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type FloatQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export enum GatsbyImageFormat {
  NO_CHANGE = 'NO_CHANGE',
  AUTO = 'AUTO',
  JPG = 'JPG',
  PNG = 'PNG',
  WEBP = 'WEBP',
  AVIF = 'AVIF'
}

export enum GatsbyImageLayout {
  FIXED = 'FIXED',
  FULL_WIDTH = 'FULL_WIDTH',
  CONSTRAINED = 'CONSTRAINED'
}

export enum GatsbyImagePlaceholder {
  DOMINANT_COLOR = 'DOMINANT_COLOR',
  TRACED_SVG = 'TRACED_SVG',
  BLURRED = 'BLURRED',
  NONE = 'NONE'
}

export type IdQueryOperatorInput = {
  eq?: InputMaybe<Scalars['ID']>;
  ne?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export enum ImageCropFocus {
  CENTER = 'CENTER',
  NORTH = 'NORTH',
  NORTHEAST = 'NORTHEAST',
  EAST = 'EAST',
  SOUTHEAST = 'SOUTHEAST',
  SOUTH = 'SOUTH',
  SOUTHWEST = 'SOUTHWEST',
  WEST = 'WEST',
  NORTHWEST = 'NORTHWEST',
  ENTROPY = 'ENTROPY',
  ATTENTION = 'ATTENTION'
}

export enum ImageFit {
  COVER = 'COVER',
  CONTAIN = 'CONTAIN',
  FILL = 'FILL',
  INSIDE = 'INSIDE',
  OUTSIDE = 'OUTSIDE'
}

export enum ImageFormat {
  NO_CHANGE = 'NO_CHANGE',
  AUTO = 'AUTO',
  JPG = 'JPG',
  PNG = 'PNG',
  WEBP = 'WEBP',
  AVIF = 'AVIF'
}

export enum ImageLayout {
  FIXED = 'FIXED',
  FULL_WIDTH = 'FULL_WIDTH',
  CONSTRAINED = 'CONSTRAINED'
}

export enum ImagePlaceholder {
  DOMINANT_COLOR = 'DOMINANT_COLOR',
  TRACED_SVG = 'TRACED_SVG',
  BLURRED = 'BLURRED',
  NONE = 'NONE'
}

export type ImageSharp = Node & {
  fixed?: Maybe<ImageSharpFixed>;
  fluid?: Maybe<ImageSharpFluid>;
  gatsbyImageData: Scalars['JSON'];
  original?: Maybe<ImageSharpOriginal>;
  resize?: Maybe<ImageSharpResize>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type ImageSharpFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  base64Width?: InputMaybe<Scalars['Int']>;
  jpegProgressive?: InputMaybe<Scalars['Boolean']>;
  pngCompressionSpeed?: InputMaybe<Scalars['Int']>;
  grayscale?: InputMaybe<Scalars['Boolean']>;
  duotone?: InputMaybe<DuotoneGradient>;
  traceSVG?: InputMaybe<Potrace>;
  quality?: InputMaybe<Scalars['Int']>;
  jpegQuality?: InputMaybe<Scalars['Int']>;
  pngQuality?: InputMaybe<Scalars['Int']>;
  webpQuality?: InputMaybe<Scalars['Int']>;
  toFormat?: InputMaybe<ImageFormat>;
  toFormatBase64?: InputMaybe<ImageFormat>;
  cropFocus?: InputMaybe<ImageCropFocus>;
  fit?: InputMaybe<ImageFit>;
  background?: InputMaybe<Scalars['String']>;
  rotate?: InputMaybe<Scalars['Int']>;
  trim?: InputMaybe<Scalars['Float']>;
};


export type ImageSharpFluidArgs = {
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  base64Width?: InputMaybe<Scalars['Int']>;
  grayscale?: InputMaybe<Scalars['Boolean']>;
  jpegProgressive?: InputMaybe<Scalars['Boolean']>;
  pngCompressionSpeed?: InputMaybe<Scalars['Int']>;
  duotone?: InputMaybe<DuotoneGradient>;
  traceSVG?: InputMaybe<Potrace>;
  quality?: InputMaybe<Scalars['Int']>;
  jpegQuality?: InputMaybe<Scalars['Int']>;
  pngQuality?: InputMaybe<Scalars['Int']>;
  webpQuality?: InputMaybe<Scalars['Int']>;
  toFormat?: InputMaybe<ImageFormat>;
  toFormatBase64?: InputMaybe<ImageFormat>;
  cropFocus?: InputMaybe<ImageCropFocus>;
  fit?: InputMaybe<ImageFit>;
  background?: InputMaybe<Scalars['String']>;
  rotate?: InputMaybe<Scalars['Int']>;
  trim?: InputMaybe<Scalars['Float']>;
  sizes?: InputMaybe<Scalars['String']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type ImageSharpGatsbyImageDataArgs = {
  layout?: InputMaybe<ImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  placeholder?: InputMaybe<ImagePlaceholder>;
  blurredOptions?: InputMaybe<BlurredOptions>;
  tracedSVGOptions?: InputMaybe<Potrace>;
  formats?: InputMaybe<Array<InputMaybe<ImageFormat>>>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<Scalars['Int']>;
  jpgOptions?: InputMaybe<JpgOptions>;
  pngOptions?: InputMaybe<PngOptions>;
  webpOptions?: InputMaybe<WebPOptions>;
  avifOptions?: InputMaybe<AvifOptions>;
  transformOptions?: InputMaybe<TransformOptions>;
  backgroundColor?: InputMaybe<Scalars['String']>;
};


export type ImageSharpResizeArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  jpegQuality?: InputMaybe<Scalars['Int']>;
  pngQuality?: InputMaybe<Scalars['Int']>;
  webpQuality?: InputMaybe<Scalars['Int']>;
  jpegProgressive?: InputMaybe<Scalars['Boolean']>;
  pngCompressionLevel?: InputMaybe<Scalars['Int']>;
  pngCompressionSpeed?: InputMaybe<Scalars['Int']>;
  grayscale?: InputMaybe<Scalars['Boolean']>;
  duotone?: InputMaybe<DuotoneGradient>;
  base64?: InputMaybe<Scalars['Boolean']>;
  traceSVG?: InputMaybe<Potrace>;
  toFormat?: InputMaybe<ImageFormat>;
  cropFocus?: InputMaybe<ImageCropFocus>;
  fit?: InputMaybe<ImageFit>;
  background?: InputMaybe<Scalars['String']>;
  rotate?: InputMaybe<Scalars['Int']>;
  trim?: InputMaybe<Scalars['Float']>;
};

export type ImageSharpConnection = {
  totalCount: Scalars['Int'];
  edges: Array<ImageSharpEdge>;
  nodes: Array<ImageSharp>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<ImageSharpGroupConnection>;
};


export type ImageSharpConnectionDistinctArgs = {
  field: ImageSharpFieldsEnum;
};


export type ImageSharpConnectionMaxArgs = {
  field: ImageSharpFieldsEnum;
};


export type ImageSharpConnectionMinArgs = {
  field: ImageSharpFieldsEnum;
};


export type ImageSharpConnectionSumArgs = {
  field: ImageSharpFieldsEnum;
};


export type ImageSharpConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: ImageSharpFieldsEnum;
};

export type ImageSharpEdge = {
  next?: Maybe<ImageSharp>;
  node: ImageSharp;
  previous?: Maybe<ImageSharp>;
};

export enum ImageSharpFieldsEnum {
  fixed___base64 = 'fixed___base64',
  fixed___tracedSVG = 'fixed___tracedSVG',
  fixed___aspectRatio = 'fixed___aspectRatio',
  fixed___width = 'fixed___width',
  fixed___height = 'fixed___height',
  fixed___src = 'fixed___src',
  fixed___srcSet = 'fixed___srcSet',
  fixed___srcWebp = 'fixed___srcWebp',
  fixed___srcSetWebp = 'fixed___srcSetWebp',
  fixed___originalName = 'fixed___originalName',
  fluid___base64 = 'fluid___base64',
  fluid___tracedSVG = 'fluid___tracedSVG',
  fluid___aspectRatio = 'fluid___aspectRatio',
  fluid___src = 'fluid___src',
  fluid___srcSet = 'fluid___srcSet',
  fluid___srcWebp = 'fluid___srcWebp',
  fluid___srcSetWebp = 'fluid___srcSetWebp',
  fluid___sizes = 'fluid___sizes',
  fluid___originalImg = 'fluid___originalImg',
  fluid___originalName = 'fluid___originalName',
  fluid___presentationWidth = 'fluid___presentationWidth',
  fluid___presentationHeight = 'fluid___presentationHeight',
  gatsbyImageData = 'gatsbyImageData',
  original___width = 'original___width',
  original___height = 'original___height',
  original___src = 'original___src',
  resize___src = 'resize___src',
  resize___tracedSVG = 'resize___tracedSVG',
  resize___width = 'resize___width',
  resize___height = 'resize___height',
  resize___aspectRatio = 'resize___aspectRatio',
  resize___originalName = 'resize___originalName',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type ImageSharpFilterInput = {
  fixed?: InputMaybe<ImageSharpFixedFilterInput>;
  fluid?: InputMaybe<ImageSharpFluidFilterInput>;
  gatsbyImageData?: InputMaybe<JsonQueryOperatorInput>;
  original?: InputMaybe<ImageSharpOriginalFilterInput>;
  resize?: InputMaybe<ImageSharpResizeFilterInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type ImageSharpFilterListInput = {
  elemMatch?: InputMaybe<ImageSharpFilterInput>;
};

export type ImageSharpFixed = {
  base64?: Maybe<Scalars['String']>;
  tracedSVG?: Maybe<Scalars['String']>;
  aspectRatio?: Maybe<Scalars['Float']>;
  width: Scalars['Float'];
  height: Scalars['Float'];
  src: Scalars['String'];
  srcSet: Scalars['String'];
  srcWebp?: Maybe<Scalars['String']>;
  srcSetWebp?: Maybe<Scalars['String']>;
  originalName?: Maybe<Scalars['String']>;
};

export type ImageSharpFixedFilterInput = {
  base64?: InputMaybe<StringQueryOperatorInput>;
  tracedSVG?: InputMaybe<StringQueryOperatorInput>;
  aspectRatio?: InputMaybe<FloatQueryOperatorInput>;
  width?: InputMaybe<FloatQueryOperatorInput>;
  height?: InputMaybe<FloatQueryOperatorInput>;
  src?: InputMaybe<StringQueryOperatorInput>;
  srcSet?: InputMaybe<StringQueryOperatorInput>;
  srcWebp?: InputMaybe<StringQueryOperatorInput>;
  srcSetWebp?: InputMaybe<StringQueryOperatorInput>;
  originalName?: InputMaybe<StringQueryOperatorInput>;
};

export type ImageSharpFluid = {
  base64?: Maybe<Scalars['String']>;
  tracedSVG?: Maybe<Scalars['String']>;
  aspectRatio: Scalars['Float'];
  src: Scalars['String'];
  srcSet: Scalars['String'];
  srcWebp?: Maybe<Scalars['String']>;
  srcSetWebp?: Maybe<Scalars['String']>;
  sizes: Scalars['String'];
  originalImg?: Maybe<Scalars['String']>;
  originalName?: Maybe<Scalars['String']>;
  presentationWidth: Scalars['Int'];
  presentationHeight: Scalars['Int'];
};

export type ImageSharpFluidFilterInput = {
  base64?: InputMaybe<StringQueryOperatorInput>;
  tracedSVG?: InputMaybe<StringQueryOperatorInput>;
  aspectRatio?: InputMaybe<FloatQueryOperatorInput>;
  src?: InputMaybe<StringQueryOperatorInput>;
  srcSet?: InputMaybe<StringQueryOperatorInput>;
  srcWebp?: InputMaybe<StringQueryOperatorInput>;
  srcSetWebp?: InputMaybe<StringQueryOperatorInput>;
  sizes?: InputMaybe<StringQueryOperatorInput>;
  originalImg?: InputMaybe<StringQueryOperatorInput>;
  originalName?: InputMaybe<StringQueryOperatorInput>;
  presentationWidth?: InputMaybe<IntQueryOperatorInput>;
  presentationHeight?: InputMaybe<IntQueryOperatorInput>;
};

export type ImageSharpGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<ImageSharpEdge>;
  nodes: Array<ImageSharp>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<ImageSharpGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type ImageSharpGroupConnectionDistinctArgs = {
  field: ImageSharpFieldsEnum;
};


export type ImageSharpGroupConnectionMaxArgs = {
  field: ImageSharpFieldsEnum;
};


export type ImageSharpGroupConnectionMinArgs = {
  field: ImageSharpFieldsEnum;
};


export type ImageSharpGroupConnectionSumArgs = {
  field: ImageSharpFieldsEnum;
};


export type ImageSharpGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: ImageSharpFieldsEnum;
};

export type ImageSharpOriginal = {
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  src?: Maybe<Scalars['String']>;
};

export type ImageSharpOriginalFilterInput = {
  width?: InputMaybe<FloatQueryOperatorInput>;
  height?: InputMaybe<FloatQueryOperatorInput>;
  src?: InputMaybe<StringQueryOperatorInput>;
};

export type ImageSharpResize = {
  src?: Maybe<Scalars['String']>;
  tracedSVG?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  aspectRatio?: Maybe<Scalars['Float']>;
  originalName?: Maybe<Scalars['String']>;
};

export type ImageSharpResizeFilterInput = {
  src?: InputMaybe<StringQueryOperatorInput>;
  tracedSVG?: InputMaybe<StringQueryOperatorInput>;
  width?: InputMaybe<IntQueryOperatorInput>;
  height?: InputMaybe<IntQueryOperatorInput>;
  aspectRatio?: InputMaybe<FloatQueryOperatorInput>;
  originalName?: InputMaybe<StringQueryOperatorInput>;
};

export type ImageSharpSortInput = {
  fields?: InputMaybe<Array<InputMaybe<ImageSharpFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type ImgixFixed = {
  base64: Scalars['String'];
  src: Scalars['String'];
  srcSet: Scalars['String'];
  srcWebp: Scalars['String'];
  srcSetWebp: Scalars['String'];
  sizes: Scalars['String'];
  width: Scalars['Int'];
  height: Scalars['Int'];
};

export type ImgixFixedFilterInput = {
  base64?: InputMaybe<StringQueryOperatorInput>;
  src?: InputMaybe<StringQueryOperatorInput>;
  srcSet?: InputMaybe<StringQueryOperatorInput>;
  srcWebp?: InputMaybe<StringQueryOperatorInput>;
  srcSetWebp?: InputMaybe<StringQueryOperatorInput>;
  sizes?: InputMaybe<StringQueryOperatorInput>;
  width?: InputMaybe<IntQueryOperatorInput>;
  height?: InputMaybe<IntQueryOperatorInput>;
};

export type ImgixFluid = {
  base64: Scalars['String'];
  src: Scalars['String'];
  srcSet: Scalars['String'];
  srcWebp: Scalars['String'];
  srcSetWebp: Scalars['String'];
  sizes: Scalars['String'];
  aspectRatio: Scalars['Float'];
};

export type ImgixFluidFilterInput = {
  base64?: InputMaybe<StringQueryOperatorInput>;
  src?: InputMaybe<StringQueryOperatorInput>;
  srcSet?: InputMaybe<StringQueryOperatorInput>;
  srcWebp?: InputMaybe<StringQueryOperatorInput>;
  srcSetWebp?: InputMaybe<StringQueryOperatorInput>;
  sizes?: InputMaybe<StringQueryOperatorInput>;
  aspectRatio?: InputMaybe<FloatQueryOperatorInput>;
};

export type ImgixParamsInput = {
  /** Specifies an aspect ratio to maintain when resizing and cropping the image. [See docs](https://docs.imgix.com/apis/url/size/ar). */
  ar?: InputMaybe<Scalars['String']>;
  /** Applies automatic enhancements to images. [See docs](https://docs.imgix.com/apis/url/auto). */
  auto?: InputMaybe<Scalars['String']>;
  /** Colors the background of padded and partially-transparent images. Default: `fff`. [See docs](https://docs.imgix.com/apis/url/bg). */
  bg?: InputMaybe<Scalars['String']>;
  /** Changes the blend alignment relative to the parent image. [See docs](https://docs.imgix.com/apis/url/blending/blend-align). */
  blendAlign?: InputMaybe<Scalars['String']>;
  /** Alias for `blendAlign`. */
  blendalign?: InputMaybe<Scalars['String']>;
  /** Alias for `blendAlign`. */
  ba?: InputMaybe<Scalars['String']>;
  /** Changes the alpha of the blend image. Default: `100`. [See docs](https://docs.imgix.com/apis/url/blending/blend-alpha). */
  blendAlpha?: InputMaybe<Scalars['Int']>;
  /** Alias for `blendAlpha`. */
  blendalpha?: InputMaybe<Scalars['Int']>;
  /** Alias for `blendAlpha`. */
  balph?: InputMaybe<Scalars['Int']>;
  /** Specifies a color to use when applying the blend. [See docs](https://docs.imgix.com/apis/url/blending/blend-color). */
  blendColor?: InputMaybe<Scalars['String']>;
  /** Alias for `blendColor`. */
  blendcolor?: InputMaybe<Scalars['String']>;
  /** Alias for `blendColor`. */
  blendClr?: InputMaybe<Scalars['String']>;
  /** Alias for `blendColor`. */
  blendclr?: InputMaybe<Scalars['String']>;
  /** Specifies the type of crop for blend images. [See docs](https://docs.imgix.com/apis/url/blending/blend-crop). */
  blendCrop?: InputMaybe<Scalars['String']>;
  /** Alias for `blendCrop`. */
  blendcrop?: InputMaybe<Scalars['String']>;
  /** Alias for `blendCrop`. */
  bc?: InputMaybe<Scalars['String']>;
  /** Specifies the fit mode for blend images. Default: `clip`. [See docs](https://docs.imgix.com/apis/url/blending/blend-fit). */
  blendFit?: InputMaybe<Scalars['String']>;
  /** Alias for `blendFit`. */
  blendfit?: InputMaybe<Scalars['String']>;
  /** Alias for `blendFit`. */
  bf?: InputMaybe<Scalars['String']>;
  /** Adjusts the height of the blend image. [See docs](https://docs.imgix.com/apis/url/blending/blend-h). */
  blendH?: InputMaybe<Scalars['Float']>;
  /** Alias for `blendH`. */
  blendh?: InputMaybe<Scalars['Float']>;
  /** Alias for `blendH`. */
  bh?: InputMaybe<Scalars['Float']>;
  /** Sets the blend mode for a blend image. Default: `overlay`. [See docs](https://docs.imgix.com/apis/url/blending/blend-mode). */
  blendMode?: InputMaybe<Scalars['String']>;
  /** Alias for `blendMode`. */
  blendmode?: InputMaybe<Scalars['String']>;
  /** Alias for `blendMode`. */
  bm?: InputMaybe<Scalars['String']>;
  /** Applies padding to the blend image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/blending/blend-pad). */
  blendPad?: InputMaybe<Scalars['Int']>;
  /** Alias for `blendPad`. */
  blendpad?: InputMaybe<Scalars['Int']>;
  /** Alias for `blendPad`. */
  bp?: InputMaybe<Scalars['Int']>;
  /** Adjusts the size of the blend image. [See docs](https://docs.imgix.com/apis/url/blending/blend-size). */
  blendSize?: InputMaybe<Scalars['String']>;
  /** Alias for `blendSize`. */
  blendsize?: InputMaybe<Scalars['String']>;
  /** Alias for `blendSize`. */
  bs?: InputMaybe<Scalars['String']>;
  /** Adjusts the width of the blend image. [See docs](https://docs.imgix.com/apis/url/blending/blend-w). */
  blendW?: InputMaybe<Scalars['Float']>;
  /** Alias for `blendW`. */
  blendw?: InputMaybe<Scalars['Float']>;
  /** Alias for `blendW`. */
  bw?: InputMaybe<Scalars['Float']>;
  /** Adjusts the x-offset of the blend image relative to its parent. Default: `0`. [See docs](https://docs.imgix.com/apis/url/blending/blend-x). */
  blendX?: InputMaybe<Scalars['Int']>;
  /** Alias for `blendX`. */
  blendx?: InputMaybe<Scalars['Int']>;
  /** Alias for `blendX`. */
  bx?: InputMaybe<Scalars['Int']>;
  /** Adjusts the y-offset of the blend image relative to its parent. Default: `0`. [See docs](https://docs.imgix.com/apis/url/blending/blend-y). */
  blendY?: InputMaybe<Scalars['Int']>;
  /** Alias for `blendY`. */
  blendy?: InputMaybe<Scalars['Int']>;
  /** Alias for `blendY`. */
  by?: InputMaybe<Scalars['Int']>;
  /** Specifies the location of the blend image. [See docs](https://docs.imgix.com/apis/url/blending/blend). */
  blend?: InputMaybe<Scalars['String']>;
  /** Alias for `blend`. */
  b?: InputMaybe<Scalars['String']>;
  /** Applies a gaussian blur to an image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/stylize/blur). */
  blur?: InputMaybe<Scalars['Int']>;
  /** Sets bottom border of an image. [See docs](https://docs.imgix.com/apis/url/border-and-padding/border-bottom). */
  borderBottom?: InputMaybe<Scalars['Int']>;
  /** Sets left border of an image. [See docs](https://docs.imgix.com/apis/url/border-and-padding/border-left). */
  borderLeft?: InputMaybe<Scalars['Int']>;
  /** Sets the inner radius of the image's border in pixels. [See docs](https://docs.imgix.com/apis/url/border-and-padding/border-radius-inner). */
  borderRadiusInner?: InputMaybe<Scalars['String']>;
  /** Sets the outer radius of the image's border in pixels. [See docs](https://docs.imgix.com/apis/url/border-and-padding/border-radius). */
  borderRadius?: InputMaybe<Scalars['String']>;
  /** Sets right border of an image. [See docs](https://docs.imgix.com/apis/url/border-and-padding/border-right). */
  borderRight?: InputMaybe<Scalars['Int']>;
  /** Sets top border of an image. [See docs](https://docs.imgix.com/apis/url/border-and-padding/border-top). */
  borderTop?: InputMaybe<Scalars['Int']>;
  /** Applies a border to an image. [See docs](https://docs.imgix.com/apis/url/border-and-padding/border). */
  border?: InputMaybe<Scalars['String']>;
  /** Adjusts the brightness of the source image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/bri). */
  bri?: InputMaybe<Scalars['Int']>;
  /** Sets one or more Client-Hints headers. [See docs](https://docs.imgix.com/apis/url/format/ch). */
  ch?: InputMaybe<Scalars['String']>;
  /** Specifies the output chroma subsampling rate. Default: `420`. [See docs](https://docs.imgix.com/apis/url/format/chromasub). */
  chromasub?: InputMaybe<Scalars['Int']>;
  /** Limits the number of unique colors in an image. [See docs](https://docs.imgix.com/apis/url/format/colorquant). */
  colorquant?: InputMaybe<Scalars['Int']>;
  /** Specifies how many colors to include in a palette-extraction response. Default: `6`. [See docs](https://docs.imgix.com/apis/url/color-palette/colors). */
  colors?: InputMaybe<Scalars['Int']>;
  /** Adjusts the contrast of the source image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/con). */
  con?: InputMaybe<Scalars['Int']>;
  /** Specifies the radius value for a rounded corner mask. [See docs](https://docs.imgix.com/apis/url/mask/corner-radius). */
  cornerRadius?: InputMaybe<Scalars['String']>;
  /** Specifies how to crop an image. [See docs](https://docs.imgix.com/apis/url/size/crop). */
  crop?: InputMaybe<Scalars['String']>;
  /** Specifies the color space of the output image. [See docs](https://docs.imgix.com/apis/url/format/cs). */
  cs?: InputMaybe<Scalars['String']>;
  /** Forces a URL to use send-file in its response. [See docs](https://docs.imgix.com/apis/url/format/dl). */
  dl?: InputMaybe<Scalars['String']>;
  /** Sets the DPI value in the EXIF header. [See docs](https://docs.imgix.com/apis/url/format/dpi). */
  dpi?: InputMaybe<Scalars['Int']>;
  /** Adjusts the device-pixel ratio of the output image. Default: `1`. [See docs](https://docs.imgix.com/apis/url/dpr). */
  dpr?: InputMaybe<Scalars['Float']>;
  /** Changes the alpha of the duotone effect atop the source image. Default: `100`. [See docs](https://docs.imgix.com/apis/url/stylize/duotone-alpha). */
  duotoneAlpha?: InputMaybe<Scalars['Int']>;
  /** Applies a duotone effect to the source image. [See docs](https://docs.imgix.com/apis/url/stylize/duotone). */
  duotone?: InputMaybe<Scalars['String']>;
  /** Adjusts the exposure of the output image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/exp). */
  exp?: InputMaybe<Scalars['Int']>;
  /** A Unix timestamp specifying a UTC time. Requests made to this URL after that time will output a 404 status code. [See docs](https://docs.imgix.com/apis/url/expires). */
  expires?: InputMaybe<Scalars['String']>;
  /** Selects a face to crop to. [See docs](https://docs.imgix.com/apis/url/face-detection/faceindex). */
  faceindex?: InputMaybe<Scalars['Int']>;
  /** Adjusts padding around a selected face. Default: `1`. [See docs](https://docs.imgix.com/apis/url/face-detection/facepad). */
  facepad?: InputMaybe<Scalars['Float']>;
  /** Specifies that face data should be included in output when combined with `fm=json`. [See docs](https://docs.imgix.com/apis/url/face-detection/faces). */
  faces?: InputMaybe<Scalars['Int']>;
  /** Sets the fill color for images with additional space created by the fit setting. Default: `fff`. [See docs](https://docs.imgix.com/apis/url/fill/fill-color). */
  fillColor?: InputMaybe<Scalars['String']>;
  /** Alias for `fillColor`. */
  fillcolor?: InputMaybe<Scalars['String']>;
  /** Determines how to fill in additional space created by the fit setting. [See docs](https://docs.imgix.com/apis/url/fill/fill). */
  fill?: InputMaybe<Scalars['String']>;
  /** Specifies how to map the source image to the output image dimensions. Default: `clip`. [See docs](https://docs.imgix.com/apis/url/size/fit). */
  fit?: InputMaybe<Scalars['String']>;
  /** Alias for `fit`. */
  f?: InputMaybe<Scalars['String']>;
  /** Flips an image on a specified axis. [See docs](https://docs.imgix.com/apis/url/rotation/flip). */
  flip?: InputMaybe<Scalars['String']>;
  /** Changes the format of the output image. [See docs](https://docs.imgix.com/apis/url/format/fm). */
  fm?: InputMaybe<Scalars['String']>;
  /** Displays crosshairs identifying the location of the set focal point. Default: `false`. [See docs](https://docs.imgix.com/apis/url/focalpoint-crop/fp-debug). */
  fpDebug?: InputMaybe<Scalars['Boolean']>;
  /** Sets the relative horizontal value for the focal point of an image. [See docs](https://docs.imgix.com/apis/url/focalpoint-crop/fp-x). */
  fpX?: InputMaybe<Scalars['Float']>;
  /** Sets the relative vertical value for the focal point of an image. [See docs](https://docs.imgix.com/apis/url/focalpoint-crop/fp-y). */
  fpY?: InputMaybe<Scalars['Float']>;
  /** Sets the relative zoom value for the focal point of an image. [See docs](https://docs.imgix.com/apis/url/focalpoint-crop/fp-z). */
  fpZ?: InputMaybe<Scalars['Float']>;
  /** Adjusts the gamma of the source image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/gam). */
  gam?: InputMaybe<Scalars['Int']>;
  /** Sets grid colors for the transparency checkerboard grid. */
  gridColors?: InputMaybe<Scalars['String']>;
  /** Sets grid size for the transparency checkerboard grid. */
  gridSize?: InputMaybe<Scalars['Int']>;
  /** Adjusts the height of the output image. [See docs](https://docs.imgix.com/apis/url/size/h). */
  h?: InputMaybe<Scalars['Float']>;
  /** Alias for `h`. */
  height?: InputMaybe<Scalars['Float']>;
  /** Adjusts the highlights of the source image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/high). */
  high?: InputMaybe<Scalars['Int']>;
  /** Applies a half-tone effect to the source image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/stylize/htn). */
  htn?: InputMaybe<Scalars['Int']>;
  /** Adjusts the hue of the source image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/hue). */
  hue?: InputMaybe<Scalars['Int']>;
  /** Inverts the colors on the source image. Default: `false`. [See docs](https://docs.imgix.com/apis/url/adjustment/invert). */
  invert?: InputMaybe<Scalars['Boolean']>;
  /** Alias for `invert`. */
  inv?: InputMaybe<Scalars['Boolean']>;
  /** Determine if IPTC data should be passed for JPEG images. */
  iptc?: InputMaybe<Scalars['String']>;
  /** Specifies that the output image should be a lossless variant. Default: `false`. [See docs](https://docs.imgix.com/apis/url/format/lossless). */
  lossless?: InputMaybe<Scalars['Boolean']>;
  /** Changes the watermark alignment relative to the parent image. [See docs](https://docs.imgix.com/apis/url/watermark/mark-align). */
  markAlign?: InputMaybe<Scalars['String']>;
  /** Alias for `markAlign`. */
  ma?: InputMaybe<Scalars['String']>;
  /** Alias for `markAlign`. */
  markalign?: InputMaybe<Scalars['String']>;
  /** Changes the alpha of the watermark image. Default: `100`. [See docs](https://docs.imgix.com/apis/url/watermark/mark-alpha). */
  markAlpha?: InputMaybe<Scalars['Int']>;
  /** Alias for `markAlpha`. */
  markalpha?: InputMaybe<Scalars['Int']>;
  /** Alias for `markAlpha`. */
  malph?: InputMaybe<Scalars['Int']>;
  /** Changes base URL of the watermark image. [See docs](https://docs.imgix.com/apis/url/watermark/mark-base). */
  markBase?: InputMaybe<Scalars['String']>;
  /** Alias for `markBase`. */
  mb?: InputMaybe<Scalars['String']>;
  /** Alias for `markBase`. */
  markbase?: InputMaybe<Scalars['String']>;
  /** Specifies the fit mode for watermark images. Default: `clip`. [See docs](https://docs.imgix.com/apis/url/watermark/mark-fit). */
  markFit?: InputMaybe<Scalars['String']>;
  /** Alias for `markFit`. */
  mf?: InputMaybe<Scalars['String']>;
  /** Alias for `markFit`. */
  markfit?: InputMaybe<Scalars['String']>;
  /** Adjusts the height of the watermark image. [See docs](https://docs.imgix.com/apis/url/watermark/mark-h). */
  markH?: InputMaybe<Scalars['Float']>;
  /** Alias for `markH`. */
  mh?: InputMaybe<Scalars['Float']>;
  /** Alias for `markH`. */
  markh?: InputMaybe<Scalars['Float']>;
  /** Applies padding to the watermark image. Default: `5`. [See docs](https://docs.imgix.com/apis/url/watermark/mark-pad). */
  markPad?: InputMaybe<Scalars['Int']>;
  /** Alias for `markPad`. */
  mp?: InputMaybe<Scalars['Int']>;
  /** Alias for `markPad`. */
  markpad?: InputMaybe<Scalars['Int']>;
  /** Rotates a watermark or tiled watermarks by a specified number of degrees. Default: `0`. [See docs](https://docs.imgix.com/apis/url/watermark/mark-rot). */
  markRot?: InputMaybe<Scalars['Float']>;
  /** Adjusts the scale of the watermark image. [See docs](https://docs.imgix.com/apis/url/watermark/mark-scale). */
  markScale?: InputMaybe<Scalars['Int']>;
  /** Alias for `markScale`. */
  ms?: InputMaybe<Scalars['Int']>;
  /** Alias for `markScale`. */
  markscale?: InputMaybe<Scalars['Int']>;
  /** Adds tiled watermark. [See docs](https://docs.imgix.com/apis/url/watermark/mark-tile). */
  markTile?: InputMaybe<Scalars['String']>;
  /** Alias for `markTile`. */
  mtile?: InputMaybe<Scalars['String']>;
  /** Alias for `markTile`. */
  marktile?: InputMaybe<Scalars['String']>;
  /** Adjusts the width of the watermark image. [See docs](https://docs.imgix.com/apis/url/watermark/mark-w). */
  markW?: InputMaybe<Scalars['Float']>;
  /** Alias for `markW`. */
  mw?: InputMaybe<Scalars['Float']>;
  /** Alias for `markW`. */
  markw?: InputMaybe<Scalars['Float']>;
  /** Adjusts the x-offset of the watermark image relative to its parent. [See docs](https://docs.imgix.com/apis/url/watermark/mark-x). */
  markX?: InputMaybe<Scalars['Int']>;
  /** Alias for `markX`. */
  mx?: InputMaybe<Scalars['Int']>;
  /** Alias for `markX`. */
  markx?: InputMaybe<Scalars['Int']>;
  /** Adjusts the y-offset of the watermark image relative to its parent. [See docs](https://docs.imgix.com/apis/url/watermark/mark-y). */
  markY?: InputMaybe<Scalars['Int']>;
  /** Alias for `markY`. */
  my?: InputMaybe<Scalars['Int']>;
  /** Alias for `markY`. */
  marky?: InputMaybe<Scalars['Int']>;
  /** Specifies the location of the watermark image. [See docs](https://docs.imgix.com/apis/url/watermark/mark). */
  mark?: InputMaybe<Scalars['String']>;
  /** Alias for `mark`. */
  m?: InputMaybe<Scalars['String']>;
  /** Colors the background of the transparent mask area of images. Default: `fff`. [See docs](https://docs.imgix.com/apis/url/mask/mask-bg). */
  maskBg?: InputMaybe<Scalars['String']>;
  /** Alias for `maskBg`. */
  maskbg?: InputMaybe<Scalars['String']>;
  /** Defines the type of mask and specifies the URL if that type is selected. [See docs](https://docs.imgix.com/apis/url/mask). */
  mask?: InputMaybe<Scalars['String']>;
  /** Specifies the maximum height of the output image in pixels. [See docs](https://docs.imgix.com/apis/url/size/max-height). */
  maxH?: InputMaybe<Scalars['Int']>;
  /** Alias for `maxH`. */
  maxHeight?: InputMaybe<Scalars['Int']>;
  /** Specifies the maximum width of the output image in pixels. [See docs](https://docs.imgix.com/apis/url/size/max-width). */
  maxW?: InputMaybe<Scalars['Int']>;
  /** Alias for `maxW`. */
  maxWidth?: InputMaybe<Scalars['Int']>;
  /** Specifies the minimum height of the output image in pixels. [See docs](https://docs.imgix.com/apis/url/size/min-height). */
  minH?: InputMaybe<Scalars['Int']>;
  /** Alias for `minH`. */
  minHeight?: InputMaybe<Scalars['Int']>;
  /** Specifies the minimum width of the output image in pixels. [See docs](https://docs.imgix.com/apis/url/size/min-width). */
  minW?: InputMaybe<Scalars['Int']>;
  /** Alias for `minW`. */
  minWidth?: InputMaybe<Scalars['Int']>;
  /** Applies a monochrome effect to the source image. [See docs](https://docs.imgix.com/apis/url/stylize/monochrome). */
  monochrome?: InputMaybe<Scalars['String']>;
  /** Alias for `monochrome`. */
  mono?: InputMaybe<Scalars['String']>;
  /** Reduces the noise in an image. Default: `20`. [See docs](https://docs.imgix.com/apis/url/noise-reduction/nr). */
  nr?: InputMaybe<Scalars['Int']>;
  /** Provides a threshold by which to sharpen an image. Default: `20`. [See docs](https://docs.imgix.com/apis/url/noise-reduction/nrs). */
  nrs?: InputMaybe<Scalars['Int']>;
  /** Changes the image orientation. [See docs](https://docs.imgix.com/apis/url/rotation/orient). */
  orient?: InputMaybe<Scalars['Int']>;
  /** Alias for `orient`. */
  or?: InputMaybe<Scalars['Int']>;
  /** Sets bottom padding of an image. [See docs](https://docs.imgix.com/apis/url/border-and-padding/pad-bottom). */
  padBottom?: InputMaybe<Scalars['Int']>;
  /** Sets left padding of an image. [See docs](https://docs.imgix.com/apis/url/border-and-padding/pad-left). */
  padLeft?: InputMaybe<Scalars['Int']>;
  /** Sets right padding of an image. [See docs](https://docs.imgix.com/apis/url/border-and-padding/pad-right). */
  padRight?: InputMaybe<Scalars['Int']>;
  /** Sets top padding of an image. [See docs](https://docs.imgix.com/apis/url/border-and-padding/pad-top). */
  padTop?: InputMaybe<Scalars['Int']>;
  /** Pads an image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/border-and-padding/pad). */
  pad?: InputMaybe<Scalars['Int']>;
  /** Selects a page from a PDF for display. Default: `1`. [See docs](https://docs.imgix.com/apis/url/pdf/page). */
  page?: InputMaybe<Scalars['Int']>;
  /** Specifies an output format for palette-extraction. [See docs](https://docs.imgix.com/apis/url/color-palette/palette). */
  palette?: InputMaybe<Scalars['String']>;
  /** Enables or disables PDF annotation. Default: `true`. [See docs](https://docs.imgix.com/apis/url/pdf/pdf-annotation). */
  pdfAnnotation?: InputMaybe<Scalars['Boolean']>;
  /** Alias for `pdfAnnotation`. */
  annotation?: InputMaybe<Scalars['Boolean']>;
  /** Specifies a CSS prefix for all classes in palette-extraction. Default: `image`. [See docs](https://docs.imgix.com/apis/url/color-palette/prefix). */
  prefix?: InputMaybe<Scalars['String']>;
  /** Applies a pixelation effect to an image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/stylize/px). */
  px?: InputMaybe<Scalars['Int']>;
  /** Adjusts the quality of an output image. Default: `75`. [See docs](https://docs.imgix.com/apis/url/format/q). */
  q?: InputMaybe<Scalars['Int']>;
  /** Crops an image to a specified rectangle. [See docs](https://docs.imgix.com/apis/url/size/rect). */
  rect?: InputMaybe<Scalars['String']>;
  /** Rotates an image by a specified number of degrees. Default: `0`. [See docs](https://docs.imgix.com/apis/url/rotation/rot). */
  rot?: InputMaybe<Scalars['Float']>;
  /** Adjusts the saturation of an image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/sat). */
  sat?: InputMaybe<Scalars['Int']>;
  /** Applies a sepia effect to an image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/stylize/sepia). */
  sepia?: InputMaybe<Scalars['Int']>;
  /** Adjusts the highlights of the source image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/shad). */
  shad?: InputMaybe<Scalars['Float']>;
  /** Adjusts the sharpness of the source image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/sharp). */
  sharp?: InputMaybe<Scalars['Float']>;
  /** Adds checkerboard behind images which support transparency. [See docs](https://docs.imgix.com/apis/url/fill/transparency). */
  transparency?: InputMaybe<Scalars['String']>;
  /** Specifies a trim color on a trim operation. [See docs](https://docs.imgix.com/apis/url/trim/trim-color). */
  trimColor?: InputMaybe<Scalars['String']>;
  /** Alias for `trimColor`. */
  trimcolor?: InputMaybe<Scalars['String']>;
  /** Specifies the mean difference on a trim operation. Default: `11`. [See docs](https://docs.imgix.com/apis/url/trim/trim-md). */
  trimMd?: InputMaybe<Scalars['Float']>;
  /** Alias for `trimMd`. */
  trimmd?: InputMaybe<Scalars['Float']>;
  /** Pads the area of the source image before trimming. Default: `0`. [See docs](https://docs.imgix.com/apis/url/trim/trim-pad). */
  trimPad?: InputMaybe<Scalars['Int']>;
  /** Alias for `trimPad`. */
  trimpad?: InputMaybe<Scalars['Int']>;
  /** Specifies the standard deviation on a trim operation. Default: `10`. [See docs](https://docs.imgix.com/apis/url/trim/trim-sd). */
  trimSd?: InputMaybe<Scalars['Float']>;
  /** Alias for `trimSd`. */
  trimsd?: InputMaybe<Scalars['Float']>;
  /** Specifies the tolerance on a trim operation. Default: `0`. [See docs](https://docs.imgix.com/apis/url/trim/trim-tol). */
  trimTol?: InputMaybe<Scalars['Float']>;
  /** Alias for `trimTol`. */
  trimtol?: InputMaybe<Scalars['Float']>;
  /** Trims the source image. [See docs](https://docs.imgix.com/apis/url/trim/trim). */
  trim?: InputMaybe<Scalars['String']>;
  /** Sets the vertical and horizontal alignment of rendered text relative to the base image. [See docs](https://docs.imgix.com/apis/url/text/txt-align). */
  txtAlign?: InputMaybe<Scalars['String']>;
  /** Alias for `txtAlign`. */
  txtalign?: InputMaybe<Scalars['String']>;
  /** Alias for `txtAlign`. */
  ta?: InputMaybe<Scalars['String']>;
  /** Sets the clipping properties of rendered text. Default: `end`. [See docs](https://docs.imgix.com/apis/url/text/txt-clip). */
  txtClip?: InputMaybe<Scalars['String']>;
  /** Alias for `txtClip`. */
  txtclip?: InputMaybe<Scalars['String']>;
  /** Alias for `txtClip`. */
  tcl?: InputMaybe<Scalars['String']>;
  /** Specifies the color of rendered text. [See docs](https://docs.imgix.com/apis/url/text/txt-color). */
  txtColor?: InputMaybe<Scalars['String']>;
  /** Alias for `txtColor`. */
  txtcolor?: InputMaybe<Scalars['String']>;
  /** Alias for `txtColor`. */
  txtClr?: InputMaybe<Scalars['String']>;
  /** Alias for `txtColor`. */
  txtclr?: InputMaybe<Scalars['String']>;
  /** Alias for `txtColor`. */
  tc?: InputMaybe<Scalars['String']>;
  /** Specifies the fit approach for rendered text. [See docs](https://docs.imgix.com/apis/url/text/txt-fit). */
  txtFit?: InputMaybe<Scalars['String']>;
  /** Alias for `txtFit`. */
  txtfit?: InputMaybe<Scalars['String']>;
  /** Selects a font for rendered text. [See docs](https://docs.imgix.com/apis/url/text/txt-font). */
  txtFont?: InputMaybe<Scalars['String']>;
  /** Alias for `txtFont`. */
  tf?: InputMaybe<Scalars['String']>;
  /** Alias for `txtFont`. */
  txtfont?: InputMaybe<Scalars['String']>;
  /** Sets the leading (line spacing) for rendered text. Only works on the multi-line text endpoint. Default: `0`. [See docs](https://docs.imgix.com/apis/url/typesetting/txt-lead). */
  txtLead?: InputMaybe<Scalars['Int']>;
  /** Alias for `txtLead`. */
  txtlead?: InputMaybe<Scalars['Int']>;
  /** Controls the level of ligature substitution. [See docs](https://docs.imgix.com/apis/url/text/txt-lig). */
  txtLig?: InputMaybe<Scalars['Int']>;
  /** Alias for `txtLig`. */
  txtlig?: InputMaybe<Scalars['Int']>;
  /** Specifies a text outline color. Default: `fff`. [See docs](https://docs.imgix.com/apis/url/text/txt-line-color). */
  txtLineColor?: InputMaybe<Scalars['String']>;
  /** Alias for `txtLineColor`. */
  txtlinecolor?: InputMaybe<Scalars['String']>;
  /** Alias for `txtLineColor`. */
  txtLineClr?: InputMaybe<Scalars['String']>;
  /** Alias for `txtLineColor`. */
  txtlineclr?: InputMaybe<Scalars['String']>;
  /** Outlines the rendered text with a specified color. Default: `0`. [See docs](https://docs.imgix.com/apis/url/text/txt-line). */
  txtLine?: InputMaybe<Scalars['Int']>;
  /** Alias for `txtLine`. */
  txtline?: InputMaybe<Scalars['Int']>;
  /** Alias for `txtLine`. */
  tl?: InputMaybe<Scalars['Int']>;
  /** Specifies the padding (in device-independent pixels) between a textbox and the edges of the base image. [See docs](https://docs.imgix.com/apis/url/text/txt-pad). */
  txtPad?: InputMaybe<Scalars['Int']>;
  /** Alias for `txtPad`. */
  txtpad?: InputMaybe<Scalars['Int']>;
  /** Alias for `txtPad`. */
  tp?: InputMaybe<Scalars['Int']>;
  /** Applies a shadow to rendered text. Default: `0`. [See docs](https://docs.imgix.com/apis/url/text/txt-shad). */
  txtShad?: InputMaybe<Scalars['Float']>;
  /** Alias for `txtShad`. */
  txtshad?: InputMaybe<Scalars['Float']>;
  /** Alias for `txtShad`. */
  tsh?: InputMaybe<Scalars['Float']>;
  /** Sets the font size of rendered text. Default: `12`. [See docs](https://docs.imgix.com/apis/url/text/txt-size). */
  txtSize?: InputMaybe<Scalars['Int']>;
  /** Alias for `txtSize`. */
  tsz?: InputMaybe<Scalars['Int']>;
  /** Alias for `txtSize`. */
  txtsize?: InputMaybe<Scalars['Int']>;
  /** Sets the tracking (letter spacing) for rendered text. Only works on the multi-line text endpoint. Default: `0`. [See docs](https://docs.imgix.com/apis/url/typesetting/txt-track). */
  txtTrack?: InputMaybe<Scalars['Int']>;
  /** Alias for `txtTrack`. */
  txttrack?: InputMaybe<Scalars['Int']>;
  /** Alias for `txtTrack`. */
  tt?: InputMaybe<Scalars['Int']>;
  /** Sets the width of rendered text. [See docs](https://docs.imgix.com/apis/url/text/txt-width). */
  txtWidth?: InputMaybe<Scalars['Int']>;
  /** Alias for `txtWidth`. */
  txtwidth?: InputMaybe<Scalars['Int']>;
  /** Sets the text string to render. [See docs](https://docs.imgix.com/apis/url/text/txt). */
  txt?: InputMaybe<Scalars['String']>;
  /** Alias for `txt`. */
  t?: InputMaybe<Scalars['String']>;
  /** Sharpens the source image using an unsharp mask. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/usm). */
  usm?: InputMaybe<Scalars['Int']>;
  /** Specifies the radius for an unsharp mask operation. Default: `2.5`. [See docs](https://docs.imgix.com/apis/url/adjustment/usmrad). */
  usmrad?: InputMaybe<Scalars['Float']>;
  /** Adjusts the vibrance of an image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/vib). */
  vib?: InputMaybe<Scalars['Int']>;
  /** Adjusts the width of the output image. [See docs](https://docs.imgix.com/apis/url/size/w). */
  w?: InputMaybe<Scalars['Float']>;
  /** Alias for `w`. */
  width?: InputMaybe<Scalars['Float']>;
};

export enum ImgixPlaceholder {
  DOMINANT_COLOR = 'DOMINANT_COLOR',
  BLURRED = 'BLURRED',
  NONE = 'NONE'
}

export type IntQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type Internal = {
  content?: Maybe<Scalars['String']>;
  contentDigest: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  fieldOwners?: Maybe<Array<Maybe<Scalars['String']>>>;
  ignoreType?: Maybe<Scalars['Boolean']>;
  mediaType?: Maybe<Scalars['String']>;
  owner: Scalars['String'];
  type: Scalars['String'];
};

export type InternalFilterInput = {
  content?: InputMaybe<StringQueryOperatorInput>;
  contentDigest?: InputMaybe<StringQueryOperatorInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  fieldOwners?: InputMaybe<StringQueryOperatorInput>;
  ignoreType?: InputMaybe<BooleanQueryOperatorInput>;
  mediaType?: InputMaybe<StringQueryOperatorInput>;
  owner?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
};

export type JpgOptions = {
  quality?: InputMaybe<Scalars['Int']>;
  progressive?: InputMaybe<Scalars['Boolean']>;
};

export type JsonQueryOperatorInput = {
  eq?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  regex?: InputMaybe<Scalars['JSON']>;
  glob?: InputMaybe<Scalars['JSON']>;
};

/** Node Interface */
export type Node = {
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type NodeFilterInput = {
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type NodeFilterListInput = {
  elemMatch?: InputMaybe<NodeFilterInput>;
};

export type PngOptions = {
  quality?: InputMaybe<Scalars['Int']>;
  compressionSpeed?: InputMaybe<Scalars['Int']>;
};

export type PageInfo = {
  currentPage: Scalars['Int'];
  hasPreviousPage: Scalars['Boolean'];
  hasNextPage: Scalars['Boolean'];
  itemCount: Scalars['Int'];
  pageCount: Scalars['Int'];
  perPage?: Maybe<Scalars['Int']>;
  totalCount: Scalars['Int'];
};

export type Potrace = {
  turnPolicy?: InputMaybe<PotraceTurnPolicy>;
  turdSize?: InputMaybe<Scalars['Float']>;
  alphaMax?: InputMaybe<Scalars['Float']>;
  optCurve?: InputMaybe<Scalars['Boolean']>;
  optTolerance?: InputMaybe<Scalars['Float']>;
  threshold?: InputMaybe<Scalars['Int']>;
  blackOnWhite?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  background?: InputMaybe<Scalars['String']>;
};

export enum PotraceTurnPolicy {
  TURNPOLICY_BLACK = 'TURNPOLICY_BLACK',
  TURNPOLICY_WHITE = 'TURNPOLICY_WHITE',
  TURNPOLICY_LEFT = 'TURNPOLICY_LEFT',
  TURNPOLICY_RIGHT = 'TURNPOLICY_RIGHT',
  TURNPOLICY_MINORITY = 'TURNPOLICY_MINORITY',
  TURNPOLICY_MAJORITY = 'TURNPOLICY_MAJORITY'
}

export type PrismicAcademyPage = Node & {
  uid: Scalars['String'];
  data: PrismicAcademyPageDataType;
  dataRaw: Scalars['JSON'];
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicAcademyPageFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicAcademyPageLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicAcademyPageConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicAcademyPageEdge>;
  nodes: Array<PrismicAcademyPage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicAcademyPageGroupConnection>;
};


export type PrismicAcademyPageConnectionDistinctArgs = {
  field: PrismicAcademyPageFieldsEnum;
};


export type PrismicAcademyPageConnectionMaxArgs = {
  field: PrismicAcademyPageFieldsEnum;
};


export type PrismicAcademyPageConnectionMinArgs = {
  field: PrismicAcademyPageFieldsEnum;
};


export type PrismicAcademyPageConnectionSumArgs = {
  field: PrismicAcademyPageFieldsEnum;
};


export type PrismicAcademyPageConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicAcademyPageFieldsEnum;
};

export type PrismicAcademyPageDataBodyDocsFullWidthImage = PrismicSliceType & {
  primary: PrismicAcademyPageDataBodyDocsFullWidthImagePrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicAcademyPageDataBodyDocsFullWidthImagePrimary = {
  background_image_position?: Maybe<Scalars['String']>;
  image?: Maybe<PrismicAcademyPageDataBodyDocsFullWidthImagePrimaryImageImageType>;
};

export type PrismicAcademyPageDataBodyDocsFullWidthImagePrimaryImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicAcademyPageDataBodyDocsFullWidthImagePrimaryImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicAcademyPageDataBodyDocsFullWidthImagePrimaryImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicAcademyPageDataBodyDocsFullWidthImagePrimaryImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicAcademyPageDataBodyDocsFullWidthImagePrimaryImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicAcademyPageDataBodyDocsRichText = PrismicSliceType & {
  primary: PrismicAcademyPageDataBodyDocsRichTextPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicAcademyPageDataBodyDocsRichTextPrimary = {
  rich_text?: Maybe<PrismicStructuredTextType>;
};

export type PrismicAcademyPageDataBodyImportantBlockQuote = PrismicSliceType & {
  primary: PrismicAcademyPageDataBodyImportantBlockQuotePrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicAcademyPageDataBodyImportantBlockQuotePrimary = {
  heading?: Maybe<PrismicStructuredTextType>;
  text?: Maybe<PrismicStructuredTextType>;
};

export type PrismicAcademyPageDataBodySlicesType = PrismicAcademyPageDataBodyDocsFullWidthImage | PrismicAcademyPageDataBodyDocsRichText | PrismicAcademyPageDataBodyImportantBlockQuote;

export type PrismicAcademyPageDataMetadataImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicAcademyPageDataMetadataImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicAcademyPageDataMetadataImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicAcademyPageDataMetadataImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicAcademyPageDataMetadataImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicAcademyPageDataMetadataImageImageTypeFilterInput = {
  alt?: InputMaybe<StringQueryOperatorInput>;
  copyright?: InputMaybe<StringQueryOperatorInput>;
  dimensions?: InputMaybe<PrismicImageDimensionsTypeFilterInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  fixed?: InputMaybe<ImgixFixedFilterInput>;
  fluid?: InputMaybe<ImgixFluidFilterInput>;
  gatsbyImageData?: InputMaybe<JsonQueryOperatorInput>;
  localFile?: InputMaybe<FileFilterInput>;
};

export type PrismicAcademyPageDataType = {
  body: Array<PrismicAcademyPageDataBodySlicesType>;
  metadata_description?: Maybe<PrismicStructuredTextType>;
  metadata_image?: Maybe<PrismicAcademyPageDataMetadataImageImageType>;
  metadata_title?: Maybe<PrismicStructuredTextType>;
  title?: Maybe<PrismicStructuredTextType>;
};

export type PrismicAcademyPageDataTypeFilterInput = {
  metadata_description?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  metadata_image?: InputMaybe<PrismicAcademyPageDataMetadataImageImageTypeFilterInput>;
  metadata_title?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  title?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
};

export type PrismicAcademyPageEdge = {
  next?: Maybe<PrismicAcademyPage>;
  node: PrismicAcademyPage;
  previous?: Maybe<PrismicAcademyPage>;
};

export enum PrismicAcademyPageFieldsEnum {
  uid = 'uid',
  data___metadata_description___text = 'data___metadata_description___text',
  data___metadata_description___html = 'data___metadata_description___html',
  data___metadata_description___richText = 'data___metadata_description___richText',
  data___metadata_description___raw = 'data___metadata_description___raw',
  data___metadata_image___alt = 'data___metadata_image___alt',
  data___metadata_image___copyright = 'data___metadata_image___copyright',
  data___metadata_image___dimensions___width = 'data___metadata_image___dimensions___width',
  data___metadata_image___dimensions___height = 'data___metadata_image___dimensions___height',
  data___metadata_image___url = 'data___metadata_image___url',
  data___metadata_image___fixed___base64 = 'data___metadata_image___fixed___base64',
  data___metadata_image___fixed___src = 'data___metadata_image___fixed___src',
  data___metadata_image___fixed___srcSet = 'data___metadata_image___fixed___srcSet',
  data___metadata_image___fixed___srcWebp = 'data___metadata_image___fixed___srcWebp',
  data___metadata_image___fixed___srcSetWebp = 'data___metadata_image___fixed___srcSetWebp',
  data___metadata_image___fixed___sizes = 'data___metadata_image___fixed___sizes',
  data___metadata_image___fixed___width = 'data___metadata_image___fixed___width',
  data___metadata_image___fixed___height = 'data___metadata_image___fixed___height',
  data___metadata_image___fluid___base64 = 'data___metadata_image___fluid___base64',
  data___metadata_image___fluid___src = 'data___metadata_image___fluid___src',
  data___metadata_image___fluid___srcSet = 'data___metadata_image___fluid___srcSet',
  data___metadata_image___fluid___srcWebp = 'data___metadata_image___fluid___srcWebp',
  data___metadata_image___fluid___srcSetWebp = 'data___metadata_image___fluid___srcSetWebp',
  data___metadata_image___fluid___sizes = 'data___metadata_image___fluid___sizes',
  data___metadata_image___fluid___aspectRatio = 'data___metadata_image___fluid___aspectRatio',
  data___metadata_image___gatsbyImageData = 'data___metadata_image___gatsbyImageData',
  data___metadata_image___localFile___sourceInstanceName = 'data___metadata_image___localFile___sourceInstanceName',
  data___metadata_image___localFile___absolutePath = 'data___metadata_image___localFile___absolutePath',
  data___metadata_image___localFile___relativePath = 'data___metadata_image___localFile___relativePath',
  data___metadata_image___localFile___extension = 'data___metadata_image___localFile___extension',
  data___metadata_image___localFile___size = 'data___metadata_image___localFile___size',
  data___metadata_image___localFile___prettySize = 'data___metadata_image___localFile___prettySize',
  data___metadata_image___localFile___modifiedTime = 'data___metadata_image___localFile___modifiedTime',
  data___metadata_image___localFile___accessTime = 'data___metadata_image___localFile___accessTime',
  data___metadata_image___localFile___changeTime = 'data___metadata_image___localFile___changeTime',
  data___metadata_image___localFile___birthTime = 'data___metadata_image___localFile___birthTime',
  data___metadata_image___localFile___root = 'data___metadata_image___localFile___root',
  data___metadata_image___localFile___dir = 'data___metadata_image___localFile___dir',
  data___metadata_image___localFile___base = 'data___metadata_image___localFile___base',
  data___metadata_image___localFile___ext = 'data___metadata_image___localFile___ext',
  data___metadata_image___localFile___name = 'data___metadata_image___localFile___name',
  data___metadata_image___localFile___relativeDirectory = 'data___metadata_image___localFile___relativeDirectory',
  data___metadata_image___localFile___dev = 'data___metadata_image___localFile___dev',
  data___metadata_image___localFile___mode = 'data___metadata_image___localFile___mode',
  data___metadata_image___localFile___nlink = 'data___metadata_image___localFile___nlink',
  data___metadata_image___localFile___uid = 'data___metadata_image___localFile___uid',
  data___metadata_image___localFile___gid = 'data___metadata_image___localFile___gid',
  data___metadata_image___localFile___rdev = 'data___metadata_image___localFile___rdev',
  data___metadata_image___localFile___ino = 'data___metadata_image___localFile___ino',
  data___metadata_image___localFile___atimeMs = 'data___metadata_image___localFile___atimeMs',
  data___metadata_image___localFile___mtimeMs = 'data___metadata_image___localFile___mtimeMs',
  data___metadata_image___localFile___ctimeMs = 'data___metadata_image___localFile___ctimeMs',
  data___metadata_image___localFile___atime = 'data___metadata_image___localFile___atime',
  data___metadata_image___localFile___mtime = 'data___metadata_image___localFile___mtime',
  data___metadata_image___localFile___ctime = 'data___metadata_image___localFile___ctime',
  data___metadata_image___localFile___birthtime = 'data___metadata_image___localFile___birthtime',
  data___metadata_image___localFile___birthtimeMs = 'data___metadata_image___localFile___birthtimeMs',
  data___metadata_image___localFile___blksize = 'data___metadata_image___localFile___blksize',
  data___metadata_image___localFile___blocks = 'data___metadata_image___localFile___blocks',
  data___metadata_image___localFile___publicURL = 'data___metadata_image___localFile___publicURL',
  data___metadata_image___localFile___childrenImageSharp = 'data___metadata_image___localFile___childrenImageSharp',
  data___metadata_image___localFile___id = 'data___metadata_image___localFile___id',
  data___metadata_image___localFile___children = 'data___metadata_image___localFile___children',
  data___metadata_title___text = 'data___metadata_title___text',
  data___metadata_title___html = 'data___metadata_title___html',
  data___metadata_title___richText = 'data___metadata_title___richText',
  data___metadata_title___raw = 'data___metadata_title___raw',
  data___title___text = 'data___title___text',
  data___title___html = 'data___title___html',
  data___title___richText = 'data___title___richText',
  data___title___raw = 'data___title___raw',
  dataRaw = 'dataRaw',
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicAcademyPageFilterInput = {
  uid?: InputMaybe<StringQueryOperatorInput>;
  data?: InputMaybe<PrismicAcademyPageDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicAcademyPageGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicAcademyPageEdge>;
  nodes: Array<PrismicAcademyPage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicAcademyPageGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicAcademyPageGroupConnectionDistinctArgs = {
  field: PrismicAcademyPageFieldsEnum;
};


export type PrismicAcademyPageGroupConnectionMaxArgs = {
  field: PrismicAcademyPageFieldsEnum;
};


export type PrismicAcademyPageGroupConnectionMinArgs = {
  field: PrismicAcademyPageFieldsEnum;
};


export type PrismicAcademyPageGroupConnectionSumArgs = {
  field: PrismicAcademyPageFieldsEnum;
};


export type PrismicAcademyPageGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicAcademyPageFieldsEnum;
};

export type PrismicAcademyPageSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicAcademyPageFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicAcademySitemap = Node & {
  data: PrismicAcademySitemapDataType;
  dataRaw: Scalars['JSON'];
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicAcademySitemapFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicAcademySitemapLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicAcademySitemapConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicAcademySitemapEdge>;
  nodes: Array<PrismicAcademySitemap>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicAcademySitemapGroupConnection>;
};


export type PrismicAcademySitemapConnectionDistinctArgs = {
  field: PrismicAcademySitemapFieldsEnum;
};


export type PrismicAcademySitemapConnectionMaxArgs = {
  field: PrismicAcademySitemapFieldsEnum;
};


export type PrismicAcademySitemapConnectionMinArgs = {
  field: PrismicAcademySitemapFieldsEnum;
};


export type PrismicAcademySitemapConnectionSumArgs = {
  field: PrismicAcademySitemapFieldsEnum;
};


export type PrismicAcademySitemapConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicAcademySitemapFieldsEnum;
};

export type PrismicAcademySitemapDataBodyAcademySection = PrismicSliceType & {
  items: Array<PrismicAcademySitemapDataBodyAcademySectionItem>;
  primary: PrismicAcademySitemapDataBodyAcademySectionPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicAcademySitemapDataBodyAcademySectionItem = {
  doc_page?: Maybe<PrismicLinkType>;
};

export type PrismicAcademySitemapDataBodyAcademySectionPrimary = {
  name?: Maybe<PrismicStructuredTextType>;
};

export type PrismicAcademySitemapDataBodySlicesType = PrismicAcademySitemapDataBodyAcademySection;

export type PrismicAcademySitemapDataTopLevelPages = {
  doc_page?: Maybe<PrismicLinkType>;
};

export type PrismicAcademySitemapDataTopLevelPagesFilterInput = {
  doc_page?: InputMaybe<PrismicLinkTypeFilterInput>;
};

export type PrismicAcademySitemapDataTopLevelPagesFilterListInput = {
  elemMatch?: InputMaybe<PrismicAcademySitemapDataTopLevelPagesFilterInput>;
};

export type PrismicAcademySitemapDataType = {
  body: Array<PrismicAcademySitemapDataBodySlicesType>;
  top_level_pages?: Maybe<Array<Maybe<PrismicAcademySitemapDataTopLevelPages>>>;
};

export type PrismicAcademySitemapDataTypeFilterInput = {
  top_level_pages?: InputMaybe<PrismicAcademySitemapDataTopLevelPagesFilterListInput>;
};

export type PrismicAcademySitemapEdge = {
  next?: Maybe<PrismicAcademySitemap>;
  node: PrismicAcademySitemap;
  previous?: Maybe<PrismicAcademySitemap>;
};

export enum PrismicAcademySitemapFieldsEnum {
  data___top_level_pages = 'data___top_level_pages',
  data___top_level_pages___doc_page___link_type = 'data___top_level_pages___doc_page___link_type',
  data___top_level_pages___doc_page___isBroken = 'data___top_level_pages___doc_page___isBroken',
  data___top_level_pages___doc_page___url = 'data___top_level_pages___doc_page___url',
  data___top_level_pages___doc_page___target = 'data___top_level_pages___doc_page___target',
  data___top_level_pages___doc_page___size = 'data___top_level_pages___doc_page___size',
  data___top_level_pages___doc_page___id = 'data___top_level_pages___doc_page___id',
  data___top_level_pages___doc_page___type = 'data___top_level_pages___doc_page___type',
  data___top_level_pages___doc_page___tags = 'data___top_level_pages___doc_page___tags',
  data___top_level_pages___doc_page___lang = 'data___top_level_pages___doc_page___lang',
  data___top_level_pages___doc_page___slug = 'data___top_level_pages___doc_page___slug',
  data___top_level_pages___doc_page___uid = 'data___top_level_pages___doc_page___uid',
  data___top_level_pages___doc_page___raw = 'data___top_level_pages___doc_page___raw',
  dataRaw = 'dataRaw',
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicAcademySitemapFilterInput = {
  data?: InputMaybe<PrismicAcademySitemapDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicAcademySitemapGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicAcademySitemapEdge>;
  nodes: Array<PrismicAcademySitemap>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicAcademySitemapGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicAcademySitemapGroupConnectionDistinctArgs = {
  field: PrismicAcademySitemapFieldsEnum;
};


export type PrismicAcademySitemapGroupConnectionMaxArgs = {
  field: PrismicAcademySitemapFieldsEnum;
};


export type PrismicAcademySitemapGroupConnectionMinArgs = {
  field: PrismicAcademySitemapFieldsEnum;
};


export type PrismicAcademySitemapGroupConnectionSumArgs = {
  field: PrismicAcademySitemapFieldsEnum;
};


export type PrismicAcademySitemapGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicAcademySitemapFieldsEnum;
};

export type PrismicAcademySitemapSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicAcademySitemapFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicAllDocumentTypes = PrismicHomepage | PrismicMarketingPage | PrismicDocPage | PrismicDocsSitemap | PrismicAcademyPage | PrismicAcademySitemap | PrismicNav | PrismicFooter | PrismicAuthor | PrismicBlogPage | PrismicBlogFeed | PrismicBanner | PrismicPricingPage | PrismicPricingPlan | PrismicPartnerPage | PrismicGrowthCalculator | PrismicLtvCalculator | PrismicBlog | PrismicDocs | PrismicDocsTemplateType | PrismicDocsInner | PrismicTestPage | PrismicBlogSocialLinks | PrismicPricing | PrismicTest1;

export type PrismicAlternateLanguageType = {
  id?: Maybe<Scalars['ID']>;
  uid?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  document?: Maybe<PrismicAllDocumentTypes>;
  raw?: Maybe<Scalars['JSON']>;
};

export type PrismicAlternateLanguageTypeFilterInput = {
  id?: InputMaybe<IdQueryOperatorInput>;
  uid?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  raw?: InputMaybe<JsonQueryOperatorInput>;
};

export type PrismicAlternateLanguageTypeFilterListInput = {
  elemMatch?: InputMaybe<PrismicAlternateLanguageTypeFilterInput>;
};

export type PrismicAuthor = Node & {
  data: PrismicAuthorDataType;
  dataRaw: Scalars['JSON'];
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicAuthorFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicAuthorLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicAuthorConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicAuthorEdge>;
  nodes: Array<PrismicAuthor>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicAuthorGroupConnection>;
};


export type PrismicAuthorConnectionDistinctArgs = {
  field: PrismicAuthorFieldsEnum;
};


export type PrismicAuthorConnectionMaxArgs = {
  field: PrismicAuthorFieldsEnum;
};


export type PrismicAuthorConnectionMinArgs = {
  field: PrismicAuthorFieldsEnum;
};


export type PrismicAuthorConnectionSumArgs = {
  field: PrismicAuthorFieldsEnum;
};


export type PrismicAuthorConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicAuthorFieldsEnum;
};

export type PrismicAuthorDataPictureImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicAuthorDataPictureImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicAuthorDataPictureImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicAuthorDataPictureImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicAuthorDataPictureImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicAuthorDataPictureImageTypeFilterInput = {
  alt?: InputMaybe<StringQueryOperatorInput>;
  copyright?: InputMaybe<StringQueryOperatorInput>;
  dimensions?: InputMaybe<PrismicImageDimensionsTypeFilterInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  fixed?: InputMaybe<ImgixFixedFilterInput>;
  fluid?: InputMaybe<ImgixFluidFilterInput>;
  gatsbyImageData?: InputMaybe<JsonQueryOperatorInput>;
  localFile?: InputMaybe<FileFilterInput>;
};

export type PrismicAuthorDataType = {
  first_name?: Maybe<PrismicStructuredTextType>;
  last_name?: Maybe<PrismicStructuredTextType>;
  picture?: Maybe<PrismicAuthorDataPictureImageType>;
  position?: Maybe<PrismicStructuredTextType>;
};

export type PrismicAuthorDataTypeFilterInput = {
  first_name?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  last_name?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  picture?: InputMaybe<PrismicAuthorDataPictureImageTypeFilterInput>;
  position?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
};

export type PrismicAuthorEdge = {
  next?: Maybe<PrismicAuthor>;
  node: PrismicAuthor;
  previous?: Maybe<PrismicAuthor>;
};

export enum PrismicAuthorFieldsEnum {
  data___first_name___text = 'data___first_name___text',
  data___first_name___html = 'data___first_name___html',
  data___first_name___richText = 'data___first_name___richText',
  data___first_name___raw = 'data___first_name___raw',
  data___last_name___text = 'data___last_name___text',
  data___last_name___html = 'data___last_name___html',
  data___last_name___richText = 'data___last_name___richText',
  data___last_name___raw = 'data___last_name___raw',
  data___picture___alt = 'data___picture___alt',
  data___picture___copyright = 'data___picture___copyright',
  data___picture___dimensions___width = 'data___picture___dimensions___width',
  data___picture___dimensions___height = 'data___picture___dimensions___height',
  data___picture___url = 'data___picture___url',
  data___picture___fixed___base64 = 'data___picture___fixed___base64',
  data___picture___fixed___src = 'data___picture___fixed___src',
  data___picture___fixed___srcSet = 'data___picture___fixed___srcSet',
  data___picture___fixed___srcWebp = 'data___picture___fixed___srcWebp',
  data___picture___fixed___srcSetWebp = 'data___picture___fixed___srcSetWebp',
  data___picture___fixed___sizes = 'data___picture___fixed___sizes',
  data___picture___fixed___width = 'data___picture___fixed___width',
  data___picture___fixed___height = 'data___picture___fixed___height',
  data___picture___fluid___base64 = 'data___picture___fluid___base64',
  data___picture___fluid___src = 'data___picture___fluid___src',
  data___picture___fluid___srcSet = 'data___picture___fluid___srcSet',
  data___picture___fluid___srcWebp = 'data___picture___fluid___srcWebp',
  data___picture___fluid___srcSetWebp = 'data___picture___fluid___srcSetWebp',
  data___picture___fluid___sizes = 'data___picture___fluid___sizes',
  data___picture___fluid___aspectRatio = 'data___picture___fluid___aspectRatio',
  data___picture___gatsbyImageData = 'data___picture___gatsbyImageData',
  data___picture___localFile___sourceInstanceName = 'data___picture___localFile___sourceInstanceName',
  data___picture___localFile___absolutePath = 'data___picture___localFile___absolutePath',
  data___picture___localFile___relativePath = 'data___picture___localFile___relativePath',
  data___picture___localFile___extension = 'data___picture___localFile___extension',
  data___picture___localFile___size = 'data___picture___localFile___size',
  data___picture___localFile___prettySize = 'data___picture___localFile___prettySize',
  data___picture___localFile___modifiedTime = 'data___picture___localFile___modifiedTime',
  data___picture___localFile___accessTime = 'data___picture___localFile___accessTime',
  data___picture___localFile___changeTime = 'data___picture___localFile___changeTime',
  data___picture___localFile___birthTime = 'data___picture___localFile___birthTime',
  data___picture___localFile___root = 'data___picture___localFile___root',
  data___picture___localFile___dir = 'data___picture___localFile___dir',
  data___picture___localFile___base = 'data___picture___localFile___base',
  data___picture___localFile___ext = 'data___picture___localFile___ext',
  data___picture___localFile___name = 'data___picture___localFile___name',
  data___picture___localFile___relativeDirectory = 'data___picture___localFile___relativeDirectory',
  data___picture___localFile___dev = 'data___picture___localFile___dev',
  data___picture___localFile___mode = 'data___picture___localFile___mode',
  data___picture___localFile___nlink = 'data___picture___localFile___nlink',
  data___picture___localFile___uid = 'data___picture___localFile___uid',
  data___picture___localFile___gid = 'data___picture___localFile___gid',
  data___picture___localFile___rdev = 'data___picture___localFile___rdev',
  data___picture___localFile___ino = 'data___picture___localFile___ino',
  data___picture___localFile___atimeMs = 'data___picture___localFile___atimeMs',
  data___picture___localFile___mtimeMs = 'data___picture___localFile___mtimeMs',
  data___picture___localFile___ctimeMs = 'data___picture___localFile___ctimeMs',
  data___picture___localFile___atime = 'data___picture___localFile___atime',
  data___picture___localFile___mtime = 'data___picture___localFile___mtime',
  data___picture___localFile___ctime = 'data___picture___localFile___ctime',
  data___picture___localFile___birthtime = 'data___picture___localFile___birthtime',
  data___picture___localFile___birthtimeMs = 'data___picture___localFile___birthtimeMs',
  data___picture___localFile___blksize = 'data___picture___localFile___blksize',
  data___picture___localFile___blocks = 'data___picture___localFile___blocks',
  data___picture___localFile___publicURL = 'data___picture___localFile___publicURL',
  data___picture___localFile___childrenImageSharp = 'data___picture___localFile___childrenImageSharp',
  data___picture___localFile___id = 'data___picture___localFile___id',
  data___picture___localFile___children = 'data___picture___localFile___children',
  data___position___text = 'data___position___text',
  data___position___html = 'data___position___html',
  data___position___richText = 'data___position___richText',
  data___position___raw = 'data___position___raw',
  dataRaw = 'dataRaw',
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicAuthorFilterInput = {
  data?: InputMaybe<PrismicAuthorDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicAuthorGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicAuthorEdge>;
  nodes: Array<PrismicAuthor>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicAuthorGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicAuthorGroupConnectionDistinctArgs = {
  field: PrismicAuthorFieldsEnum;
};


export type PrismicAuthorGroupConnectionMaxArgs = {
  field: PrismicAuthorFieldsEnum;
};


export type PrismicAuthorGroupConnectionMinArgs = {
  field: PrismicAuthorFieldsEnum;
};


export type PrismicAuthorGroupConnectionSumArgs = {
  field: PrismicAuthorFieldsEnum;
};


export type PrismicAuthorGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicAuthorFieldsEnum;
};

export type PrismicAuthorSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicAuthorFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicBanner = Node & {
  data: PrismicBannerDataType;
  dataRaw: Scalars['JSON'];
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicBannerFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicBannerLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicBannerConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicBannerEdge>;
  nodes: Array<PrismicBanner>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicBannerGroupConnection>;
};


export type PrismicBannerConnectionDistinctArgs = {
  field: PrismicBannerFieldsEnum;
};


export type PrismicBannerConnectionMaxArgs = {
  field: PrismicBannerFieldsEnum;
};


export type PrismicBannerConnectionMinArgs = {
  field: PrismicBannerFieldsEnum;
};


export type PrismicBannerConnectionSumArgs = {
  field: PrismicBannerFieldsEnum;
};


export type PrismicBannerConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicBannerFieldsEnum;
};

export type PrismicBannerDataType = {
  show?: Maybe<Scalars['Boolean']>;
  text?: Maybe<PrismicStructuredTextType>;
};

export type PrismicBannerDataTypeFilterInput = {
  show?: InputMaybe<BooleanQueryOperatorInput>;
  text?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
};

export type PrismicBannerEdge = {
  next?: Maybe<PrismicBanner>;
  node: PrismicBanner;
  previous?: Maybe<PrismicBanner>;
};

export enum PrismicBannerFieldsEnum {
  data___show = 'data___show',
  data___text___text = 'data___text___text',
  data___text___html = 'data___text___html',
  data___text___richText = 'data___text___richText',
  data___text___raw = 'data___text___raw',
  dataRaw = 'dataRaw',
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicBannerFilterInput = {
  data?: InputMaybe<PrismicBannerDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicBannerGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicBannerEdge>;
  nodes: Array<PrismicBanner>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicBannerGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicBannerGroupConnectionDistinctArgs = {
  field: PrismicBannerFieldsEnum;
};


export type PrismicBannerGroupConnectionMaxArgs = {
  field: PrismicBannerFieldsEnum;
};


export type PrismicBannerGroupConnectionMinArgs = {
  field: PrismicBannerFieldsEnum;
};


export type PrismicBannerGroupConnectionSumArgs = {
  field: PrismicBannerFieldsEnum;
};


export type PrismicBannerGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicBannerFieldsEnum;
};

export type PrismicBannerSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicBannerFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicBlog = Node & {
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicBlogFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicBlogLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicBlogConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicBlogEdge>;
  nodes: Array<PrismicBlog>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicBlogGroupConnection>;
};


export type PrismicBlogConnectionDistinctArgs = {
  field: PrismicBlogFieldsEnum;
};


export type PrismicBlogConnectionMaxArgs = {
  field: PrismicBlogFieldsEnum;
};


export type PrismicBlogConnectionMinArgs = {
  field: PrismicBlogFieldsEnum;
};


export type PrismicBlogConnectionSumArgs = {
  field: PrismicBlogFieldsEnum;
};


export type PrismicBlogConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicBlogFieldsEnum;
};

export type PrismicBlogEdge = {
  next?: Maybe<PrismicBlog>;
  node: PrismicBlog;
  previous?: Maybe<PrismicBlog>;
};

export type PrismicBlogFeed = Node & {
  data: PrismicBlogFeedDataType;
  dataRaw: Scalars['JSON'];
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicBlogFeedFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicBlogFeedLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicBlogFeedConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicBlogFeedEdge>;
  nodes: Array<PrismicBlogFeed>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicBlogFeedGroupConnection>;
};


export type PrismicBlogFeedConnectionDistinctArgs = {
  field: PrismicBlogFeedFieldsEnum;
};


export type PrismicBlogFeedConnectionMaxArgs = {
  field: PrismicBlogFeedFieldsEnum;
};


export type PrismicBlogFeedConnectionMinArgs = {
  field: PrismicBlogFeedFieldsEnum;
};


export type PrismicBlogFeedConnectionSumArgs = {
  field: PrismicBlogFeedFieldsEnum;
};


export type PrismicBlogFeedConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicBlogFeedFieldsEnum;
};

export type PrismicBlogFeedDataMetadataImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicBlogFeedDataMetadataImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicBlogFeedDataMetadataImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicBlogFeedDataMetadataImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicBlogFeedDataMetadataImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicBlogFeedDataMetadataImageImageTypeFilterInput = {
  alt?: InputMaybe<StringQueryOperatorInput>;
  copyright?: InputMaybe<StringQueryOperatorInput>;
  dimensions?: InputMaybe<PrismicImageDimensionsTypeFilterInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  fixed?: InputMaybe<ImgixFixedFilterInput>;
  fluid?: InputMaybe<ImgixFluidFilterInput>;
  gatsbyImageData?: InputMaybe<JsonQueryOperatorInput>;
  localFile?: InputMaybe<FileFilterInput>;
};

export type PrismicBlogFeedDataType = {
  featured_article_1?: Maybe<PrismicLinkType>;
  featured_article_2?: Maybe<PrismicLinkType>;
  metadata_description?: Maybe<PrismicStructuredTextType>;
  metadata_image?: Maybe<PrismicBlogFeedDataMetadataImageImageType>;
  metadata_title?: Maybe<PrismicStructuredTextType>;
};

export type PrismicBlogFeedDataTypeFilterInput = {
  featured_article_1?: InputMaybe<PrismicLinkTypeFilterInput>;
  featured_article_2?: InputMaybe<PrismicLinkTypeFilterInput>;
  metadata_description?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  metadata_image?: InputMaybe<PrismicBlogFeedDataMetadataImageImageTypeFilterInput>;
  metadata_title?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
};

export type PrismicBlogFeedEdge = {
  next?: Maybe<PrismicBlogFeed>;
  node: PrismicBlogFeed;
  previous?: Maybe<PrismicBlogFeed>;
};

export enum PrismicBlogFeedFieldsEnum {
  data___featured_article_1___link_type = 'data___featured_article_1___link_type',
  data___featured_article_1___isBroken = 'data___featured_article_1___isBroken',
  data___featured_article_1___url = 'data___featured_article_1___url',
  data___featured_article_1___target = 'data___featured_article_1___target',
  data___featured_article_1___size = 'data___featured_article_1___size',
  data___featured_article_1___id = 'data___featured_article_1___id',
  data___featured_article_1___type = 'data___featured_article_1___type',
  data___featured_article_1___tags = 'data___featured_article_1___tags',
  data___featured_article_1___lang = 'data___featured_article_1___lang',
  data___featured_article_1___slug = 'data___featured_article_1___slug',
  data___featured_article_1___uid = 'data___featured_article_1___uid',
  data___featured_article_1___localFile___sourceInstanceName = 'data___featured_article_1___localFile___sourceInstanceName',
  data___featured_article_1___localFile___absolutePath = 'data___featured_article_1___localFile___absolutePath',
  data___featured_article_1___localFile___relativePath = 'data___featured_article_1___localFile___relativePath',
  data___featured_article_1___localFile___extension = 'data___featured_article_1___localFile___extension',
  data___featured_article_1___localFile___size = 'data___featured_article_1___localFile___size',
  data___featured_article_1___localFile___prettySize = 'data___featured_article_1___localFile___prettySize',
  data___featured_article_1___localFile___modifiedTime = 'data___featured_article_1___localFile___modifiedTime',
  data___featured_article_1___localFile___accessTime = 'data___featured_article_1___localFile___accessTime',
  data___featured_article_1___localFile___changeTime = 'data___featured_article_1___localFile___changeTime',
  data___featured_article_1___localFile___birthTime = 'data___featured_article_1___localFile___birthTime',
  data___featured_article_1___localFile___root = 'data___featured_article_1___localFile___root',
  data___featured_article_1___localFile___dir = 'data___featured_article_1___localFile___dir',
  data___featured_article_1___localFile___base = 'data___featured_article_1___localFile___base',
  data___featured_article_1___localFile___ext = 'data___featured_article_1___localFile___ext',
  data___featured_article_1___localFile___name = 'data___featured_article_1___localFile___name',
  data___featured_article_1___localFile___relativeDirectory = 'data___featured_article_1___localFile___relativeDirectory',
  data___featured_article_1___localFile___dev = 'data___featured_article_1___localFile___dev',
  data___featured_article_1___localFile___mode = 'data___featured_article_1___localFile___mode',
  data___featured_article_1___localFile___nlink = 'data___featured_article_1___localFile___nlink',
  data___featured_article_1___localFile___uid = 'data___featured_article_1___localFile___uid',
  data___featured_article_1___localFile___gid = 'data___featured_article_1___localFile___gid',
  data___featured_article_1___localFile___rdev = 'data___featured_article_1___localFile___rdev',
  data___featured_article_1___localFile___ino = 'data___featured_article_1___localFile___ino',
  data___featured_article_1___localFile___atimeMs = 'data___featured_article_1___localFile___atimeMs',
  data___featured_article_1___localFile___mtimeMs = 'data___featured_article_1___localFile___mtimeMs',
  data___featured_article_1___localFile___ctimeMs = 'data___featured_article_1___localFile___ctimeMs',
  data___featured_article_1___localFile___atime = 'data___featured_article_1___localFile___atime',
  data___featured_article_1___localFile___mtime = 'data___featured_article_1___localFile___mtime',
  data___featured_article_1___localFile___ctime = 'data___featured_article_1___localFile___ctime',
  data___featured_article_1___localFile___birthtime = 'data___featured_article_1___localFile___birthtime',
  data___featured_article_1___localFile___birthtimeMs = 'data___featured_article_1___localFile___birthtimeMs',
  data___featured_article_1___localFile___blksize = 'data___featured_article_1___localFile___blksize',
  data___featured_article_1___localFile___blocks = 'data___featured_article_1___localFile___blocks',
  data___featured_article_1___localFile___publicURL = 'data___featured_article_1___localFile___publicURL',
  data___featured_article_1___localFile___childrenImageSharp = 'data___featured_article_1___localFile___childrenImageSharp',
  data___featured_article_1___localFile___id = 'data___featured_article_1___localFile___id',
  data___featured_article_1___localFile___children = 'data___featured_article_1___localFile___children',
  data___featured_article_1___raw = 'data___featured_article_1___raw',
  data___featured_article_2___link_type = 'data___featured_article_2___link_type',
  data___featured_article_2___isBroken = 'data___featured_article_2___isBroken',
  data___featured_article_2___url = 'data___featured_article_2___url',
  data___featured_article_2___target = 'data___featured_article_2___target',
  data___featured_article_2___size = 'data___featured_article_2___size',
  data___featured_article_2___id = 'data___featured_article_2___id',
  data___featured_article_2___type = 'data___featured_article_2___type',
  data___featured_article_2___tags = 'data___featured_article_2___tags',
  data___featured_article_2___lang = 'data___featured_article_2___lang',
  data___featured_article_2___slug = 'data___featured_article_2___slug',
  data___featured_article_2___uid = 'data___featured_article_2___uid',
  data___featured_article_2___localFile___sourceInstanceName = 'data___featured_article_2___localFile___sourceInstanceName',
  data___featured_article_2___localFile___absolutePath = 'data___featured_article_2___localFile___absolutePath',
  data___featured_article_2___localFile___relativePath = 'data___featured_article_2___localFile___relativePath',
  data___featured_article_2___localFile___extension = 'data___featured_article_2___localFile___extension',
  data___featured_article_2___localFile___size = 'data___featured_article_2___localFile___size',
  data___featured_article_2___localFile___prettySize = 'data___featured_article_2___localFile___prettySize',
  data___featured_article_2___localFile___modifiedTime = 'data___featured_article_2___localFile___modifiedTime',
  data___featured_article_2___localFile___accessTime = 'data___featured_article_2___localFile___accessTime',
  data___featured_article_2___localFile___changeTime = 'data___featured_article_2___localFile___changeTime',
  data___featured_article_2___localFile___birthTime = 'data___featured_article_2___localFile___birthTime',
  data___featured_article_2___localFile___root = 'data___featured_article_2___localFile___root',
  data___featured_article_2___localFile___dir = 'data___featured_article_2___localFile___dir',
  data___featured_article_2___localFile___base = 'data___featured_article_2___localFile___base',
  data___featured_article_2___localFile___ext = 'data___featured_article_2___localFile___ext',
  data___featured_article_2___localFile___name = 'data___featured_article_2___localFile___name',
  data___featured_article_2___localFile___relativeDirectory = 'data___featured_article_2___localFile___relativeDirectory',
  data___featured_article_2___localFile___dev = 'data___featured_article_2___localFile___dev',
  data___featured_article_2___localFile___mode = 'data___featured_article_2___localFile___mode',
  data___featured_article_2___localFile___nlink = 'data___featured_article_2___localFile___nlink',
  data___featured_article_2___localFile___uid = 'data___featured_article_2___localFile___uid',
  data___featured_article_2___localFile___gid = 'data___featured_article_2___localFile___gid',
  data___featured_article_2___localFile___rdev = 'data___featured_article_2___localFile___rdev',
  data___featured_article_2___localFile___ino = 'data___featured_article_2___localFile___ino',
  data___featured_article_2___localFile___atimeMs = 'data___featured_article_2___localFile___atimeMs',
  data___featured_article_2___localFile___mtimeMs = 'data___featured_article_2___localFile___mtimeMs',
  data___featured_article_2___localFile___ctimeMs = 'data___featured_article_2___localFile___ctimeMs',
  data___featured_article_2___localFile___atime = 'data___featured_article_2___localFile___atime',
  data___featured_article_2___localFile___mtime = 'data___featured_article_2___localFile___mtime',
  data___featured_article_2___localFile___ctime = 'data___featured_article_2___localFile___ctime',
  data___featured_article_2___localFile___birthtime = 'data___featured_article_2___localFile___birthtime',
  data___featured_article_2___localFile___birthtimeMs = 'data___featured_article_2___localFile___birthtimeMs',
  data___featured_article_2___localFile___blksize = 'data___featured_article_2___localFile___blksize',
  data___featured_article_2___localFile___blocks = 'data___featured_article_2___localFile___blocks',
  data___featured_article_2___localFile___publicURL = 'data___featured_article_2___localFile___publicURL',
  data___featured_article_2___localFile___childrenImageSharp = 'data___featured_article_2___localFile___childrenImageSharp',
  data___featured_article_2___localFile___id = 'data___featured_article_2___localFile___id',
  data___featured_article_2___localFile___children = 'data___featured_article_2___localFile___children',
  data___featured_article_2___raw = 'data___featured_article_2___raw',
  data___metadata_description___text = 'data___metadata_description___text',
  data___metadata_description___html = 'data___metadata_description___html',
  data___metadata_description___richText = 'data___metadata_description___richText',
  data___metadata_description___raw = 'data___metadata_description___raw',
  data___metadata_image___alt = 'data___metadata_image___alt',
  data___metadata_image___copyright = 'data___metadata_image___copyright',
  data___metadata_image___dimensions___width = 'data___metadata_image___dimensions___width',
  data___metadata_image___dimensions___height = 'data___metadata_image___dimensions___height',
  data___metadata_image___url = 'data___metadata_image___url',
  data___metadata_image___fixed___base64 = 'data___metadata_image___fixed___base64',
  data___metadata_image___fixed___src = 'data___metadata_image___fixed___src',
  data___metadata_image___fixed___srcSet = 'data___metadata_image___fixed___srcSet',
  data___metadata_image___fixed___srcWebp = 'data___metadata_image___fixed___srcWebp',
  data___metadata_image___fixed___srcSetWebp = 'data___metadata_image___fixed___srcSetWebp',
  data___metadata_image___fixed___sizes = 'data___metadata_image___fixed___sizes',
  data___metadata_image___fixed___width = 'data___metadata_image___fixed___width',
  data___metadata_image___fixed___height = 'data___metadata_image___fixed___height',
  data___metadata_image___fluid___base64 = 'data___metadata_image___fluid___base64',
  data___metadata_image___fluid___src = 'data___metadata_image___fluid___src',
  data___metadata_image___fluid___srcSet = 'data___metadata_image___fluid___srcSet',
  data___metadata_image___fluid___srcWebp = 'data___metadata_image___fluid___srcWebp',
  data___metadata_image___fluid___srcSetWebp = 'data___metadata_image___fluid___srcSetWebp',
  data___metadata_image___fluid___sizes = 'data___metadata_image___fluid___sizes',
  data___metadata_image___fluid___aspectRatio = 'data___metadata_image___fluid___aspectRatio',
  data___metadata_image___gatsbyImageData = 'data___metadata_image___gatsbyImageData',
  data___metadata_image___localFile___sourceInstanceName = 'data___metadata_image___localFile___sourceInstanceName',
  data___metadata_image___localFile___absolutePath = 'data___metadata_image___localFile___absolutePath',
  data___metadata_image___localFile___relativePath = 'data___metadata_image___localFile___relativePath',
  data___metadata_image___localFile___extension = 'data___metadata_image___localFile___extension',
  data___metadata_image___localFile___size = 'data___metadata_image___localFile___size',
  data___metadata_image___localFile___prettySize = 'data___metadata_image___localFile___prettySize',
  data___metadata_image___localFile___modifiedTime = 'data___metadata_image___localFile___modifiedTime',
  data___metadata_image___localFile___accessTime = 'data___metadata_image___localFile___accessTime',
  data___metadata_image___localFile___changeTime = 'data___metadata_image___localFile___changeTime',
  data___metadata_image___localFile___birthTime = 'data___metadata_image___localFile___birthTime',
  data___metadata_image___localFile___root = 'data___metadata_image___localFile___root',
  data___metadata_image___localFile___dir = 'data___metadata_image___localFile___dir',
  data___metadata_image___localFile___base = 'data___metadata_image___localFile___base',
  data___metadata_image___localFile___ext = 'data___metadata_image___localFile___ext',
  data___metadata_image___localFile___name = 'data___metadata_image___localFile___name',
  data___metadata_image___localFile___relativeDirectory = 'data___metadata_image___localFile___relativeDirectory',
  data___metadata_image___localFile___dev = 'data___metadata_image___localFile___dev',
  data___metadata_image___localFile___mode = 'data___metadata_image___localFile___mode',
  data___metadata_image___localFile___nlink = 'data___metadata_image___localFile___nlink',
  data___metadata_image___localFile___uid = 'data___metadata_image___localFile___uid',
  data___metadata_image___localFile___gid = 'data___metadata_image___localFile___gid',
  data___metadata_image___localFile___rdev = 'data___metadata_image___localFile___rdev',
  data___metadata_image___localFile___ino = 'data___metadata_image___localFile___ino',
  data___metadata_image___localFile___atimeMs = 'data___metadata_image___localFile___atimeMs',
  data___metadata_image___localFile___mtimeMs = 'data___metadata_image___localFile___mtimeMs',
  data___metadata_image___localFile___ctimeMs = 'data___metadata_image___localFile___ctimeMs',
  data___metadata_image___localFile___atime = 'data___metadata_image___localFile___atime',
  data___metadata_image___localFile___mtime = 'data___metadata_image___localFile___mtime',
  data___metadata_image___localFile___ctime = 'data___metadata_image___localFile___ctime',
  data___metadata_image___localFile___birthtime = 'data___metadata_image___localFile___birthtime',
  data___metadata_image___localFile___birthtimeMs = 'data___metadata_image___localFile___birthtimeMs',
  data___metadata_image___localFile___blksize = 'data___metadata_image___localFile___blksize',
  data___metadata_image___localFile___blocks = 'data___metadata_image___localFile___blocks',
  data___metadata_image___localFile___publicURL = 'data___metadata_image___localFile___publicURL',
  data___metadata_image___localFile___childrenImageSharp = 'data___metadata_image___localFile___childrenImageSharp',
  data___metadata_image___localFile___id = 'data___metadata_image___localFile___id',
  data___metadata_image___localFile___children = 'data___metadata_image___localFile___children',
  data___metadata_title___text = 'data___metadata_title___text',
  data___metadata_title___html = 'data___metadata_title___html',
  data___metadata_title___richText = 'data___metadata_title___richText',
  data___metadata_title___raw = 'data___metadata_title___raw',
  dataRaw = 'dataRaw',
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicBlogFeedFilterInput = {
  data?: InputMaybe<PrismicBlogFeedDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicBlogFeedGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicBlogFeedEdge>;
  nodes: Array<PrismicBlogFeed>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicBlogFeedGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicBlogFeedGroupConnectionDistinctArgs = {
  field: PrismicBlogFeedFieldsEnum;
};


export type PrismicBlogFeedGroupConnectionMaxArgs = {
  field: PrismicBlogFeedFieldsEnum;
};


export type PrismicBlogFeedGroupConnectionMinArgs = {
  field: PrismicBlogFeedFieldsEnum;
};


export type PrismicBlogFeedGroupConnectionSumArgs = {
  field: PrismicBlogFeedFieldsEnum;
};


export type PrismicBlogFeedGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicBlogFeedFieldsEnum;
};

export type PrismicBlogFeedSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicBlogFeedFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export enum PrismicBlogFieldsEnum {
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicBlogFilterInput = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicBlogGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicBlogEdge>;
  nodes: Array<PrismicBlog>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicBlogGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicBlogGroupConnectionDistinctArgs = {
  field: PrismicBlogFieldsEnum;
};


export type PrismicBlogGroupConnectionMaxArgs = {
  field: PrismicBlogFieldsEnum;
};


export type PrismicBlogGroupConnectionMinArgs = {
  field: PrismicBlogFieldsEnum;
};


export type PrismicBlogGroupConnectionSumArgs = {
  field: PrismicBlogFieldsEnum;
};


export type PrismicBlogGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicBlogFieldsEnum;
};

export type PrismicBlogPage = Node & {
  uid: Scalars['String'];
  data: PrismicBlogPageDataType;
  dataRaw: Scalars['JSON'];
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicBlogPageFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicBlogPageLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicBlogPageConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicBlogPageEdge>;
  nodes: Array<PrismicBlogPage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicBlogPageGroupConnection>;
};


export type PrismicBlogPageConnectionDistinctArgs = {
  field: PrismicBlogPageFieldsEnum;
};


export type PrismicBlogPageConnectionMaxArgs = {
  field: PrismicBlogPageFieldsEnum;
};


export type PrismicBlogPageConnectionMinArgs = {
  field: PrismicBlogPageFieldsEnum;
};


export type PrismicBlogPageConnectionSumArgs = {
  field: PrismicBlogPageFieldsEnum;
};


export type PrismicBlogPageConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicBlogPageFieldsEnum;
};

export type PrismicBlogPageDataAuthors = {
  author?: Maybe<PrismicLinkType>;
};

export type PrismicBlogPageDataAuthorsFilterInput = {
  author?: InputMaybe<PrismicLinkTypeFilterInput>;
};

export type PrismicBlogPageDataAuthorsFilterListInput = {
  elemMatch?: InputMaybe<PrismicBlogPageDataAuthorsFilterInput>;
};

export type PrismicBlogPageDataBodyBlogExtraWideImage = PrismicSliceType & {
  primary: PrismicBlogPageDataBodyBlogExtraWideImagePrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicBlogPageDataBodyBlogExtraWideImagePrimary = {
  caption?: Maybe<PrismicStructuredTextType>;
  image?: Maybe<PrismicBlogPageDataBodyBlogExtraWideImagePrimaryImageImageType>;
};

export type PrismicBlogPageDataBodyBlogExtraWideImagePrimaryImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicBlogPageDataBodyBlogExtraWideImagePrimaryImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicBlogPageDataBodyBlogExtraWideImagePrimaryImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicBlogPageDataBodyBlogExtraWideImagePrimaryImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicBlogPageDataBodyBlogExtraWideImagePrimaryImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicBlogPageDataBodyBlogExtraWideVideo = PrismicSliceType & {
  primary: PrismicBlogPageDataBodyBlogExtraWideVideoPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicBlogPageDataBodyBlogExtraWideVideoPrimary = {
  caption?: Maybe<PrismicStructuredTextType>;
  embed?: Maybe<PrismicEmbedType>;
};

export type PrismicBlogPageDataBodyBlogImageWithCaption = PrismicSliceType & {
  primary: PrismicBlogPageDataBodyBlogImageWithCaptionPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicBlogPageDataBodyBlogImageWithCaptionPrimary = {
  caption?: Maybe<PrismicStructuredTextType>;
  image?: Maybe<PrismicBlogPageDataBodyBlogImageWithCaptionPrimaryImageImageType>;
};

export type PrismicBlogPageDataBodyBlogImageWithCaptionPrimaryImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicBlogPageDataBodyBlogImageWithCaptionPrimaryImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicBlogPageDataBodyBlogImageWithCaptionPrimaryImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicBlogPageDataBodyBlogImageWithCaptionPrimaryImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicBlogPageDataBodyBlogImageWithCaptionPrimaryImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicBlogPageDataBodyBlogRichText = PrismicSliceType & {
  primary: PrismicBlogPageDataBodyBlogRichTextPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicBlogPageDataBodyBlogRichTextPrimary = {
  content?: Maybe<PrismicStructuredTextType>;
};

export type PrismicBlogPageDataBodySideBySideImages = PrismicSliceType & {
  items: Array<PrismicBlogPageDataBodySideBySideImagesItem>;
  primary: PrismicBlogPageDataBodySideBySideImagesPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicBlogPageDataBodySideBySideImagesItem = {
  image?: Maybe<PrismicBlogPageDataBodySideBySideImagesItemsImageImageType>;
};

export type PrismicBlogPageDataBodySideBySideImagesItemsImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicBlogPageDataBodySideBySideImagesItemsImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicBlogPageDataBodySideBySideImagesItemsImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicBlogPageDataBodySideBySideImagesItemsImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicBlogPageDataBodySideBySideImagesItemsImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicBlogPageDataBodySideBySideImagesPrimary = {
  caption?: Maybe<PrismicStructuredTextType>;
};

export type PrismicBlogPageDataBodySlicesType = PrismicBlogPageDataBodyBlogExtraWideImage | PrismicBlogPageDataBodyBlogExtraWideVideo | PrismicBlogPageDataBodyBlogImageWithCaption | PrismicBlogPageDataBodyBlogRichText | PrismicBlogPageDataBodySideBySideImages | PrismicBlogPageDataBodyTableOfContents;

export type PrismicBlogPageDataBodyTableOfContents = PrismicSliceType & {
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicBlogPageDataMetadataImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicBlogPageDataMetadataImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicBlogPageDataMetadataImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicBlogPageDataMetadataImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicBlogPageDataMetadataImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicBlogPageDataMetadataImageImageTypeFilterInput = {
  alt?: InputMaybe<StringQueryOperatorInput>;
  copyright?: InputMaybe<StringQueryOperatorInput>;
  dimensions?: InputMaybe<PrismicImageDimensionsTypeFilterInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  fixed?: InputMaybe<ImgixFixedFilterInput>;
  fluid?: InputMaybe<ImgixFluidFilterInput>;
  gatsbyImageData?: InputMaybe<JsonQueryOperatorInput>;
  localFile?: InputMaybe<FileFilterInput>;
};

export type PrismicBlogPageDataType = {
  authors?: Maybe<Array<Maybe<PrismicBlogPageDataAuthors>>>;
  body: Array<PrismicBlogPageDataBodySlicesType>;
  metadata_image?: Maybe<PrismicBlogPageDataMetadataImageImageType>;
  publish_date?: Maybe<Scalars['Date']>;
  subtitle?: Maybe<PrismicStructuredTextType>;
  title?: Maybe<PrismicStructuredTextType>;
};


export type PrismicBlogPageDataTypePublish_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicBlogPageDataTypeFilterInput = {
  authors?: InputMaybe<PrismicBlogPageDataAuthorsFilterListInput>;
  metadata_image?: InputMaybe<PrismicBlogPageDataMetadataImageImageTypeFilterInput>;
  publish_date?: InputMaybe<DateQueryOperatorInput>;
  subtitle?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  title?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
};

export type PrismicBlogPageEdge = {
  next?: Maybe<PrismicBlogPage>;
  node: PrismicBlogPage;
  previous?: Maybe<PrismicBlogPage>;
};

export enum PrismicBlogPageFieldsEnum {
  uid = 'uid',
  data___authors = 'data___authors',
  data___authors___author___link_type = 'data___authors___author___link_type',
  data___authors___author___isBroken = 'data___authors___author___isBroken',
  data___authors___author___url = 'data___authors___author___url',
  data___authors___author___target = 'data___authors___author___target',
  data___authors___author___size = 'data___authors___author___size',
  data___authors___author___id = 'data___authors___author___id',
  data___authors___author___type = 'data___authors___author___type',
  data___authors___author___tags = 'data___authors___author___tags',
  data___authors___author___lang = 'data___authors___author___lang',
  data___authors___author___slug = 'data___authors___author___slug',
  data___authors___author___uid = 'data___authors___author___uid',
  data___authors___author___raw = 'data___authors___author___raw',
  data___metadata_image___alt = 'data___metadata_image___alt',
  data___metadata_image___copyright = 'data___metadata_image___copyright',
  data___metadata_image___dimensions___width = 'data___metadata_image___dimensions___width',
  data___metadata_image___dimensions___height = 'data___metadata_image___dimensions___height',
  data___metadata_image___url = 'data___metadata_image___url',
  data___metadata_image___fixed___base64 = 'data___metadata_image___fixed___base64',
  data___metadata_image___fixed___src = 'data___metadata_image___fixed___src',
  data___metadata_image___fixed___srcSet = 'data___metadata_image___fixed___srcSet',
  data___metadata_image___fixed___srcWebp = 'data___metadata_image___fixed___srcWebp',
  data___metadata_image___fixed___srcSetWebp = 'data___metadata_image___fixed___srcSetWebp',
  data___metadata_image___fixed___sizes = 'data___metadata_image___fixed___sizes',
  data___metadata_image___fixed___width = 'data___metadata_image___fixed___width',
  data___metadata_image___fixed___height = 'data___metadata_image___fixed___height',
  data___metadata_image___fluid___base64 = 'data___metadata_image___fluid___base64',
  data___metadata_image___fluid___src = 'data___metadata_image___fluid___src',
  data___metadata_image___fluid___srcSet = 'data___metadata_image___fluid___srcSet',
  data___metadata_image___fluid___srcWebp = 'data___metadata_image___fluid___srcWebp',
  data___metadata_image___fluid___srcSetWebp = 'data___metadata_image___fluid___srcSetWebp',
  data___metadata_image___fluid___sizes = 'data___metadata_image___fluid___sizes',
  data___metadata_image___fluid___aspectRatio = 'data___metadata_image___fluid___aspectRatio',
  data___metadata_image___gatsbyImageData = 'data___metadata_image___gatsbyImageData',
  data___metadata_image___localFile___sourceInstanceName = 'data___metadata_image___localFile___sourceInstanceName',
  data___metadata_image___localFile___absolutePath = 'data___metadata_image___localFile___absolutePath',
  data___metadata_image___localFile___relativePath = 'data___metadata_image___localFile___relativePath',
  data___metadata_image___localFile___extension = 'data___metadata_image___localFile___extension',
  data___metadata_image___localFile___size = 'data___metadata_image___localFile___size',
  data___metadata_image___localFile___prettySize = 'data___metadata_image___localFile___prettySize',
  data___metadata_image___localFile___modifiedTime = 'data___metadata_image___localFile___modifiedTime',
  data___metadata_image___localFile___accessTime = 'data___metadata_image___localFile___accessTime',
  data___metadata_image___localFile___changeTime = 'data___metadata_image___localFile___changeTime',
  data___metadata_image___localFile___birthTime = 'data___metadata_image___localFile___birthTime',
  data___metadata_image___localFile___root = 'data___metadata_image___localFile___root',
  data___metadata_image___localFile___dir = 'data___metadata_image___localFile___dir',
  data___metadata_image___localFile___base = 'data___metadata_image___localFile___base',
  data___metadata_image___localFile___ext = 'data___metadata_image___localFile___ext',
  data___metadata_image___localFile___name = 'data___metadata_image___localFile___name',
  data___metadata_image___localFile___relativeDirectory = 'data___metadata_image___localFile___relativeDirectory',
  data___metadata_image___localFile___dev = 'data___metadata_image___localFile___dev',
  data___metadata_image___localFile___mode = 'data___metadata_image___localFile___mode',
  data___metadata_image___localFile___nlink = 'data___metadata_image___localFile___nlink',
  data___metadata_image___localFile___uid = 'data___metadata_image___localFile___uid',
  data___metadata_image___localFile___gid = 'data___metadata_image___localFile___gid',
  data___metadata_image___localFile___rdev = 'data___metadata_image___localFile___rdev',
  data___metadata_image___localFile___ino = 'data___metadata_image___localFile___ino',
  data___metadata_image___localFile___atimeMs = 'data___metadata_image___localFile___atimeMs',
  data___metadata_image___localFile___mtimeMs = 'data___metadata_image___localFile___mtimeMs',
  data___metadata_image___localFile___ctimeMs = 'data___metadata_image___localFile___ctimeMs',
  data___metadata_image___localFile___atime = 'data___metadata_image___localFile___atime',
  data___metadata_image___localFile___mtime = 'data___metadata_image___localFile___mtime',
  data___metadata_image___localFile___ctime = 'data___metadata_image___localFile___ctime',
  data___metadata_image___localFile___birthtime = 'data___metadata_image___localFile___birthtime',
  data___metadata_image___localFile___birthtimeMs = 'data___metadata_image___localFile___birthtimeMs',
  data___metadata_image___localFile___blksize = 'data___metadata_image___localFile___blksize',
  data___metadata_image___localFile___blocks = 'data___metadata_image___localFile___blocks',
  data___metadata_image___localFile___publicURL = 'data___metadata_image___localFile___publicURL',
  data___metadata_image___localFile___childrenImageSharp = 'data___metadata_image___localFile___childrenImageSharp',
  data___metadata_image___localFile___id = 'data___metadata_image___localFile___id',
  data___metadata_image___localFile___children = 'data___metadata_image___localFile___children',
  data___publish_date = 'data___publish_date',
  data___subtitle___text = 'data___subtitle___text',
  data___subtitle___html = 'data___subtitle___html',
  data___subtitle___richText = 'data___subtitle___richText',
  data___subtitle___raw = 'data___subtitle___raw',
  data___title___text = 'data___title___text',
  data___title___html = 'data___title___html',
  data___title___richText = 'data___title___richText',
  data___title___raw = 'data___title___raw',
  dataRaw = 'dataRaw',
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicBlogPageFilterInput = {
  uid?: InputMaybe<StringQueryOperatorInput>;
  data?: InputMaybe<PrismicBlogPageDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicBlogPageGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicBlogPageEdge>;
  nodes: Array<PrismicBlogPage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicBlogPageGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicBlogPageGroupConnectionDistinctArgs = {
  field: PrismicBlogPageFieldsEnum;
};


export type PrismicBlogPageGroupConnectionMaxArgs = {
  field: PrismicBlogPageFieldsEnum;
};


export type PrismicBlogPageGroupConnectionMinArgs = {
  field: PrismicBlogPageFieldsEnum;
};


export type PrismicBlogPageGroupConnectionSumArgs = {
  field: PrismicBlogPageFieldsEnum;
};


export type PrismicBlogPageGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicBlogPageFieldsEnum;
};

export type PrismicBlogPageSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicBlogPageFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicBlogSocialLinks = Node & {
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicBlogSocialLinksFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicBlogSocialLinksLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicBlogSocialLinksConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicBlogSocialLinksEdge>;
  nodes: Array<PrismicBlogSocialLinks>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicBlogSocialLinksGroupConnection>;
};


export type PrismicBlogSocialLinksConnectionDistinctArgs = {
  field: PrismicBlogSocialLinksFieldsEnum;
};


export type PrismicBlogSocialLinksConnectionMaxArgs = {
  field: PrismicBlogSocialLinksFieldsEnum;
};


export type PrismicBlogSocialLinksConnectionMinArgs = {
  field: PrismicBlogSocialLinksFieldsEnum;
};


export type PrismicBlogSocialLinksConnectionSumArgs = {
  field: PrismicBlogSocialLinksFieldsEnum;
};


export type PrismicBlogSocialLinksConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicBlogSocialLinksFieldsEnum;
};

export type PrismicBlogSocialLinksEdge = {
  next?: Maybe<PrismicBlogSocialLinks>;
  node: PrismicBlogSocialLinks;
  previous?: Maybe<PrismicBlogSocialLinks>;
};

export enum PrismicBlogSocialLinksFieldsEnum {
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicBlogSocialLinksFilterInput = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicBlogSocialLinksGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicBlogSocialLinksEdge>;
  nodes: Array<PrismicBlogSocialLinks>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicBlogSocialLinksGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicBlogSocialLinksGroupConnectionDistinctArgs = {
  field: PrismicBlogSocialLinksFieldsEnum;
};


export type PrismicBlogSocialLinksGroupConnectionMaxArgs = {
  field: PrismicBlogSocialLinksFieldsEnum;
};


export type PrismicBlogSocialLinksGroupConnectionMinArgs = {
  field: PrismicBlogSocialLinksFieldsEnum;
};


export type PrismicBlogSocialLinksGroupConnectionSumArgs = {
  field: PrismicBlogSocialLinksFieldsEnum;
};


export type PrismicBlogSocialLinksGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicBlogSocialLinksFieldsEnum;
};

export type PrismicBlogSocialLinksSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicBlogSocialLinksFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicBlogSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicBlogFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicDocPage = Node & {
  uid: Scalars['String'];
  data: PrismicDocPageDataType;
  dataRaw: Scalars['JSON'];
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicDocPageFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicDocPageLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicDocPageConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicDocPageEdge>;
  nodes: Array<PrismicDocPage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicDocPageGroupConnection>;
};


export type PrismicDocPageConnectionDistinctArgs = {
  field: PrismicDocPageFieldsEnum;
};


export type PrismicDocPageConnectionMaxArgs = {
  field: PrismicDocPageFieldsEnum;
};


export type PrismicDocPageConnectionMinArgs = {
  field: PrismicDocPageFieldsEnum;
};


export type PrismicDocPageConnectionSumArgs = {
  field: PrismicDocPageFieldsEnum;
};


export type PrismicDocPageConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicDocPageFieldsEnum;
};

export type PrismicDocPageDataBodyDocsFullWidthImage = PrismicSliceType & {
  primary: PrismicDocPageDataBodyDocsFullWidthImagePrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicDocPageDataBodyDocsFullWidthImagePrimary = {
  background_image_position?: Maybe<Scalars['String']>;
  image?: Maybe<PrismicDocPageDataBodyDocsFullWidthImagePrimaryImageImageType>;
};

export type PrismicDocPageDataBodyDocsFullWidthImagePrimaryImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicDocPageDataBodyDocsFullWidthImagePrimaryImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicDocPageDataBodyDocsFullWidthImagePrimaryImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicDocPageDataBodyDocsFullWidthImagePrimaryImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicDocPageDataBodyDocsFullWidthImagePrimaryImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicDocPageDataBodyDocsRichText = PrismicSliceType & {
  primary: PrismicDocPageDataBodyDocsRichTextPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicDocPageDataBodyDocsRichTextPrimary = {
  rich_text?: Maybe<PrismicStructuredTextType>;
};

export type PrismicDocPageDataBodyImportantBlockQuote = PrismicSliceType & {
  primary: PrismicDocPageDataBodyImportantBlockQuotePrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicDocPageDataBodyImportantBlockQuotePrimary = {
  heading?: Maybe<PrismicStructuredTextType>;
  text?: Maybe<PrismicStructuredTextType>;
};

export type PrismicDocPageDataBodySlicesType = PrismicDocPageDataBodyDocsFullWidthImage | PrismicDocPageDataBodyDocsRichText | PrismicDocPageDataBodyImportantBlockQuote;

export type PrismicDocPageDataMetadataImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicDocPageDataMetadataImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicDocPageDataMetadataImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicDocPageDataMetadataImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicDocPageDataMetadataImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicDocPageDataMetadataImageImageTypeFilterInput = {
  alt?: InputMaybe<StringQueryOperatorInput>;
  copyright?: InputMaybe<StringQueryOperatorInput>;
  dimensions?: InputMaybe<PrismicImageDimensionsTypeFilterInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  fixed?: InputMaybe<ImgixFixedFilterInput>;
  fluid?: InputMaybe<ImgixFluidFilterInput>;
  gatsbyImageData?: InputMaybe<JsonQueryOperatorInput>;
  localFile?: InputMaybe<FileFilterInput>;
};

export type PrismicDocPageDataType = {
  body: Array<PrismicDocPageDataBodySlicesType>;
  metadata_description?: Maybe<PrismicStructuredTextType>;
  metadata_image?: Maybe<PrismicDocPageDataMetadataImageImageType>;
  metadata_title?: Maybe<PrismicStructuredTextType>;
  title?: Maybe<PrismicStructuredTextType>;
};

export type PrismicDocPageDataTypeFilterInput = {
  metadata_description?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  metadata_image?: InputMaybe<PrismicDocPageDataMetadataImageImageTypeFilterInput>;
  metadata_title?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  title?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
};

export type PrismicDocPageEdge = {
  next?: Maybe<PrismicDocPage>;
  node: PrismicDocPage;
  previous?: Maybe<PrismicDocPage>;
};

export enum PrismicDocPageFieldsEnum {
  uid = 'uid',
  data___metadata_description___text = 'data___metadata_description___text',
  data___metadata_description___html = 'data___metadata_description___html',
  data___metadata_description___richText = 'data___metadata_description___richText',
  data___metadata_description___raw = 'data___metadata_description___raw',
  data___metadata_image___alt = 'data___metadata_image___alt',
  data___metadata_image___copyright = 'data___metadata_image___copyright',
  data___metadata_image___dimensions___width = 'data___metadata_image___dimensions___width',
  data___metadata_image___dimensions___height = 'data___metadata_image___dimensions___height',
  data___metadata_image___url = 'data___metadata_image___url',
  data___metadata_image___fixed___base64 = 'data___metadata_image___fixed___base64',
  data___metadata_image___fixed___src = 'data___metadata_image___fixed___src',
  data___metadata_image___fixed___srcSet = 'data___metadata_image___fixed___srcSet',
  data___metadata_image___fixed___srcWebp = 'data___metadata_image___fixed___srcWebp',
  data___metadata_image___fixed___srcSetWebp = 'data___metadata_image___fixed___srcSetWebp',
  data___metadata_image___fixed___sizes = 'data___metadata_image___fixed___sizes',
  data___metadata_image___fixed___width = 'data___metadata_image___fixed___width',
  data___metadata_image___fixed___height = 'data___metadata_image___fixed___height',
  data___metadata_image___fluid___base64 = 'data___metadata_image___fluid___base64',
  data___metadata_image___fluid___src = 'data___metadata_image___fluid___src',
  data___metadata_image___fluid___srcSet = 'data___metadata_image___fluid___srcSet',
  data___metadata_image___fluid___srcWebp = 'data___metadata_image___fluid___srcWebp',
  data___metadata_image___fluid___srcSetWebp = 'data___metadata_image___fluid___srcSetWebp',
  data___metadata_image___fluid___sizes = 'data___metadata_image___fluid___sizes',
  data___metadata_image___fluid___aspectRatio = 'data___metadata_image___fluid___aspectRatio',
  data___metadata_image___gatsbyImageData = 'data___metadata_image___gatsbyImageData',
  data___metadata_image___localFile___sourceInstanceName = 'data___metadata_image___localFile___sourceInstanceName',
  data___metadata_image___localFile___absolutePath = 'data___metadata_image___localFile___absolutePath',
  data___metadata_image___localFile___relativePath = 'data___metadata_image___localFile___relativePath',
  data___metadata_image___localFile___extension = 'data___metadata_image___localFile___extension',
  data___metadata_image___localFile___size = 'data___metadata_image___localFile___size',
  data___metadata_image___localFile___prettySize = 'data___metadata_image___localFile___prettySize',
  data___metadata_image___localFile___modifiedTime = 'data___metadata_image___localFile___modifiedTime',
  data___metadata_image___localFile___accessTime = 'data___metadata_image___localFile___accessTime',
  data___metadata_image___localFile___changeTime = 'data___metadata_image___localFile___changeTime',
  data___metadata_image___localFile___birthTime = 'data___metadata_image___localFile___birthTime',
  data___metadata_image___localFile___root = 'data___metadata_image___localFile___root',
  data___metadata_image___localFile___dir = 'data___metadata_image___localFile___dir',
  data___metadata_image___localFile___base = 'data___metadata_image___localFile___base',
  data___metadata_image___localFile___ext = 'data___metadata_image___localFile___ext',
  data___metadata_image___localFile___name = 'data___metadata_image___localFile___name',
  data___metadata_image___localFile___relativeDirectory = 'data___metadata_image___localFile___relativeDirectory',
  data___metadata_image___localFile___dev = 'data___metadata_image___localFile___dev',
  data___metadata_image___localFile___mode = 'data___metadata_image___localFile___mode',
  data___metadata_image___localFile___nlink = 'data___metadata_image___localFile___nlink',
  data___metadata_image___localFile___uid = 'data___metadata_image___localFile___uid',
  data___metadata_image___localFile___gid = 'data___metadata_image___localFile___gid',
  data___metadata_image___localFile___rdev = 'data___metadata_image___localFile___rdev',
  data___metadata_image___localFile___ino = 'data___metadata_image___localFile___ino',
  data___metadata_image___localFile___atimeMs = 'data___metadata_image___localFile___atimeMs',
  data___metadata_image___localFile___mtimeMs = 'data___metadata_image___localFile___mtimeMs',
  data___metadata_image___localFile___ctimeMs = 'data___metadata_image___localFile___ctimeMs',
  data___metadata_image___localFile___atime = 'data___metadata_image___localFile___atime',
  data___metadata_image___localFile___mtime = 'data___metadata_image___localFile___mtime',
  data___metadata_image___localFile___ctime = 'data___metadata_image___localFile___ctime',
  data___metadata_image___localFile___birthtime = 'data___metadata_image___localFile___birthtime',
  data___metadata_image___localFile___birthtimeMs = 'data___metadata_image___localFile___birthtimeMs',
  data___metadata_image___localFile___blksize = 'data___metadata_image___localFile___blksize',
  data___metadata_image___localFile___blocks = 'data___metadata_image___localFile___blocks',
  data___metadata_image___localFile___publicURL = 'data___metadata_image___localFile___publicURL',
  data___metadata_image___localFile___childrenImageSharp = 'data___metadata_image___localFile___childrenImageSharp',
  data___metadata_image___localFile___id = 'data___metadata_image___localFile___id',
  data___metadata_image___localFile___children = 'data___metadata_image___localFile___children',
  data___metadata_title___text = 'data___metadata_title___text',
  data___metadata_title___html = 'data___metadata_title___html',
  data___metadata_title___richText = 'data___metadata_title___richText',
  data___metadata_title___raw = 'data___metadata_title___raw',
  data___title___text = 'data___title___text',
  data___title___html = 'data___title___html',
  data___title___richText = 'data___title___richText',
  data___title___raw = 'data___title___raw',
  dataRaw = 'dataRaw',
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicDocPageFilterInput = {
  uid?: InputMaybe<StringQueryOperatorInput>;
  data?: InputMaybe<PrismicDocPageDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicDocPageGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicDocPageEdge>;
  nodes: Array<PrismicDocPage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicDocPageGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicDocPageGroupConnectionDistinctArgs = {
  field: PrismicDocPageFieldsEnum;
};


export type PrismicDocPageGroupConnectionMaxArgs = {
  field: PrismicDocPageFieldsEnum;
};


export type PrismicDocPageGroupConnectionMinArgs = {
  field: PrismicDocPageFieldsEnum;
};


export type PrismicDocPageGroupConnectionSumArgs = {
  field: PrismicDocPageFieldsEnum;
};


export type PrismicDocPageGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicDocPageFieldsEnum;
};

export type PrismicDocPageSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicDocPageFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicDocs = Node & {
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicDocsFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicDocsLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicDocsConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicDocsEdge>;
  nodes: Array<PrismicDocs>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicDocsGroupConnection>;
};


export type PrismicDocsConnectionDistinctArgs = {
  field: PrismicDocsFieldsEnum;
};


export type PrismicDocsConnectionMaxArgs = {
  field: PrismicDocsFieldsEnum;
};


export type PrismicDocsConnectionMinArgs = {
  field: PrismicDocsFieldsEnum;
};


export type PrismicDocsConnectionSumArgs = {
  field: PrismicDocsFieldsEnum;
};


export type PrismicDocsConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicDocsFieldsEnum;
};

export type PrismicDocsEdge = {
  next?: Maybe<PrismicDocs>;
  node: PrismicDocs;
  previous?: Maybe<PrismicDocs>;
};

export enum PrismicDocsFieldsEnum {
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicDocsFilterInput = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicDocsGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicDocsEdge>;
  nodes: Array<PrismicDocs>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicDocsGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicDocsGroupConnectionDistinctArgs = {
  field: PrismicDocsFieldsEnum;
};


export type PrismicDocsGroupConnectionMaxArgs = {
  field: PrismicDocsFieldsEnum;
};


export type PrismicDocsGroupConnectionMinArgs = {
  field: PrismicDocsFieldsEnum;
};


export type PrismicDocsGroupConnectionSumArgs = {
  field: PrismicDocsFieldsEnum;
};


export type PrismicDocsGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicDocsFieldsEnum;
};

export type PrismicDocsInner = Node & {
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicDocsInnerFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicDocsInnerLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicDocsInnerConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicDocsInnerEdge>;
  nodes: Array<PrismicDocsInner>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicDocsInnerGroupConnection>;
};


export type PrismicDocsInnerConnectionDistinctArgs = {
  field: PrismicDocsInnerFieldsEnum;
};


export type PrismicDocsInnerConnectionMaxArgs = {
  field: PrismicDocsInnerFieldsEnum;
};


export type PrismicDocsInnerConnectionMinArgs = {
  field: PrismicDocsInnerFieldsEnum;
};


export type PrismicDocsInnerConnectionSumArgs = {
  field: PrismicDocsInnerFieldsEnum;
};


export type PrismicDocsInnerConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicDocsInnerFieldsEnum;
};

export type PrismicDocsInnerEdge = {
  next?: Maybe<PrismicDocsInner>;
  node: PrismicDocsInner;
  previous?: Maybe<PrismicDocsInner>;
};

export enum PrismicDocsInnerFieldsEnum {
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicDocsInnerFilterInput = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicDocsInnerGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicDocsInnerEdge>;
  nodes: Array<PrismicDocsInner>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicDocsInnerGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicDocsInnerGroupConnectionDistinctArgs = {
  field: PrismicDocsInnerFieldsEnum;
};


export type PrismicDocsInnerGroupConnectionMaxArgs = {
  field: PrismicDocsInnerFieldsEnum;
};


export type PrismicDocsInnerGroupConnectionMinArgs = {
  field: PrismicDocsInnerFieldsEnum;
};


export type PrismicDocsInnerGroupConnectionSumArgs = {
  field: PrismicDocsInnerFieldsEnum;
};


export type PrismicDocsInnerGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicDocsInnerFieldsEnum;
};

export type PrismicDocsInnerSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicDocsInnerFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicDocsSitemap = Node & {
  data: PrismicDocsSitemapDataType;
  dataRaw: Scalars['JSON'];
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicDocsSitemapFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicDocsSitemapLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicDocsSitemapConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicDocsSitemapEdge>;
  nodes: Array<PrismicDocsSitemap>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicDocsSitemapGroupConnection>;
};


export type PrismicDocsSitemapConnectionDistinctArgs = {
  field: PrismicDocsSitemapFieldsEnum;
};


export type PrismicDocsSitemapConnectionMaxArgs = {
  field: PrismicDocsSitemapFieldsEnum;
};


export type PrismicDocsSitemapConnectionMinArgs = {
  field: PrismicDocsSitemapFieldsEnum;
};


export type PrismicDocsSitemapConnectionSumArgs = {
  field: PrismicDocsSitemapFieldsEnum;
};


export type PrismicDocsSitemapConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicDocsSitemapFieldsEnum;
};

export type PrismicDocsSitemapDataBodyDocsSection = PrismicSliceType & {
  items: Array<PrismicDocsSitemapDataBodyDocsSectionItem>;
  primary: PrismicDocsSitemapDataBodyDocsSectionPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicDocsSitemapDataBodyDocsSectionItem = {
  doc_page?: Maybe<PrismicLinkType>;
};

export type PrismicDocsSitemapDataBodyDocsSectionPrimary = {
  name?: Maybe<PrismicStructuredTextType>;
};

export type PrismicDocsSitemapDataBodySlicesType = PrismicDocsSitemapDataBodyDocsSection;

export type PrismicDocsSitemapDataTopLevelPages = {
  doc_page?: Maybe<PrismicLinkType>;
};

export type PrismicDocsSitemapDataTopLevelPagesFilterInput = {
  doc_page?: InputMaybe<PrismicLinkTypeFilterInput>;
};

export type PrismicDocsSitemapDataTopLevelPagesFilterListInput = {
  elemMatch?: InputMaybe<PrismicDocsSitemapDataTopLevelPagesFilterInput>;
};

export type PrismicDocsSitemapDataType = {
  body: Array<PrismicDocsSitemapDataBodySlicesType>;
  top_level_pages?: Maybe<Array<Maybe<PrismicDocsSitemapDataTopLevelPages>>>;
};

export type PrismicDocsSitemapDataTypeFilterInput = {
  top_level_pages?: InputMaybe<PrismicDocsSitemapDataTopLevelPagesFilterListInput>;
};

export type PrismicDocsSitemapEdge = {
  next?: Maybe<PrismicDocsSitemap>;
  node: PrismicDocsSitemap;
  previous?: Maybe<PrismicDocsSitemap>;
};

export enum PrismicDocsSitemapFieldsEnum {
  data___top_level_pages = 'data___top_level_pages',
  data___top_level_pages___doc_page___link_type = 'data___top_level_pages___doc_page___link_type',
  data___top_level_pages___doc_page___isBroken = 'data___top_level_pages___doc_page___isBroken',
  data___top_level_pages___doc_page___url = 'data___top_level_pages___doc_page___url',
  data___top_level_pages___doc_page___target = 'data___top_level_pages___doc_page___target',
  data___top_level_pages___doc_page___size = 'data___top_level_pages___doc_page___size',
  data___top_level_pages___doc_page___id = 'data___top_level_pages___doc_page___id',
  data___top_level_pages___doc_page___type = 'data___top_level_pages___doc_page___type',
  data___top_level_pages___doc_page___tags = 'data___top_level_pages___doc_page___tags',
  data___top_level_pages___doc_page___lang = 'data___top_level_pages___doc_page___lang',
  data___top_level_pages___doc_page___slug = 'data___top_level_pages___doc_page___slug',
  data___top_level_pages___doc_page___uid = 'data___top_level_pages___doc_page___uid',
  data___top_level_pages___doc_page___raw = 'data___top_level_pages___doc_page___raw',
  dataRaw = 'dataRaw',
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicDocsSitemapFilterInput = {
  data?: InputMaybe<PrismicDocsSitemapDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicDocsSitemapGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicDocsSitemapEdge>;
  nodes: Array<PrismicDocsSitemap>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicDocsSitemapGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicDocsSitemapGroupConnectionDistinctArgs = {
  field: PrismicDocsSitemapFieldsEnum;
};


export type PrismicDocsSitemapGroupConnectionMaxArgs = {
  field: PrismicDocsSitemapFieldsEnum;
};


export type PrismicDocsSitemapGroupConnectionMinArgs = {
  field: PrismicDocsSitemapFieldsEnum;
};


export type PrismicDocsSitemapGroupConnectionSumArgs = {
  field: PrismicDocsSitemapFieldsEnum;
};


export type PrismicDocsSitemapGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicDocsSitemapFieldsEnum;
};

export type PrismicDocsSitemapSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicDocsSitemapFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicDocsSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicDocsFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicDocsTemplateType = Node & {
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicDocsTemplateTypeFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicDocsTemplateTypeLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicDocsTemplateTypeConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicDocsTemplateTypeEdge>;
  nodes: Array<PrismicDocsTemplateType>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicDocsTemplateTypeGroupConnection>;
};


export type PrismicDocsTemplateTypeConnectionDistinctArgs = {
  field: PrismicDocsTemplateTypeFieldsEnum;
};


export type PrismicDocsTemplateTypeConnectionMaxArgs = {
  field: PrismicDocsTemplateTypeFieldsEnum;
};


export type PrismicDocsTemplateTypeConnectionMinArgs = {
  field: PrismicDocsTemplateTypeFieldsEnum;
};


export type PrismicDocsTemplateTypeConnectionSumArgs = {
  field: PrismicDocsTemplateTypeFieldsEnum;
};


export type PrismicDocsTemplateTypeConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicDocsTemplateTypeFieldsEnum;
};

export type PrismicDocsTemplateTypeEdge = {
  next?: Maybe<PrismicDocsTemplateType>;
  node: PrismicDocsTemplateType;
  previous?: Maybe<PrismicDocsTemplateType>;
};

export enum PrismicDocsTemplateTypeFieldsEnum {
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicDocsTemplateTypeFilterInput = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicDocsTemplateTypeGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicDocsTemplateTypeEdge>;
  nodes: Array<PrismicDocsTemplateType>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicDocsTemplateTypeGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicDocsTemplateTypeGroupConnectionDistinctArgs = {
  field: PrismicDocsTemplateTypeFieldsEnum;
};


export type PrismicDocsTemplateTypeGroupConnectionMaxArgs = {
  field: PrismicDocsTemplateTypeFieldsEnum;
};


export type PrismicDocsTemplateTypeGroupConnectionMinArgs = {
  field: PrismicDocsTemplateTypeFieldsEnum;
};


export type PrismicDocsTemplateTypeGroupConnectionSumArgs = {
  field: PrismicDocsTemplateTypeFieldsEnum;
};


export type PrismicDocsTemplateTypeGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicDocsTemplateTypeFieldsEnum;
};

export type PrismicDocsTemplateTypeSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicDocsTemplateTypeFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicEmbedType = Node & {
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type PrismicEmbedTypeConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicEmbedTypeEdge>;
  nodes: Array<PrismicEmbedType>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicEmbedTypeGroupConnection>;
};


export type PrismicEmbedTypeConnectionDistinctArgs = {
  field: PrismicEmbedTypeFieldsEnum;
};


export type PrismicEmbedTypeConnectionMaxArgs = {
  field: PrismicEmbedTypeFieldsEnum;
};


export type PrismicEmbedTypeConnectionMinArgs = {
  field: PrismicEmbedTypeFieldsEnum;
};


export type PrismicEmbedTypeConnectionSumArgs = {
  field: PrismicEmbedTypeFieldsEnum;
};


export type PrismicEmbedTypeConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicEmbedTypeFieldsEnum;
};

export type PrismicEmbedTypeEdge = {
  next?: Maybe<PrismicEmbedType>;
  node: PrismicEmbedType;
  previous?: Maybe<PrismicEmbedType>;
};

export enum PrismicEmbedTypeFieldsEnum {
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicEmbedTypeFilterInput = {
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicEmbedTypeGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicEmbedTypeEdge>;
  nodes: Array<PrismicEmbedType>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicEmbedTypeGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicEmbedTypeGroupConnectionDistinctArgs = {
  field: PrismicEmbedTypeFieldsEnum;
};


export type PrismicEmbedTypeGroupConnectionMaxArgs = {
  field: PrismicEmbedTypeFieldsEnum;
};


export type PrismicEmbedTypeGroupConnectionMinArgs = {
  field: PrismicEmbedTypeFieldsEnum;
};


export type PrismicEmbedTypeGroupConnectionSumArgs = {
  field: PrismicEmbedTypeFieldsEnum;
};


export type PrismicEmbedTypeGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicEmbedTypeFieldsEnum;
};

export type PrismicEmbedTypeSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicEmbedTypeFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicFooter = Node & {
  data: PrismicFooterDataType;
  dataRaw: Scalars['JSON'];
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicFooterFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicFooterLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicFooterConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicFooterEdge>;
  nodes: Array<PrismicFooter>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicFooterGroupConnection>;
};


export type PrismicFooterConnectionDistinctArgs = {
  field: PrismicFooterFieldsEnum;
};


export type PrismicFooterConnectionMaxArgs = {
  field: PrismicFooterFieldsEnum;
};


export type PrismicFooterConnectionMinArgs = {
  field: PrismicFooterFieldsEnum;
};


export type PrismicFooterConnectionSumArgs = {
  field: PrismicFooterFieldsEnum;
};


export type PrismicFooterConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicFooterFieldsEnum;
};

export type PrismicFooterDataColumn1Links = {
  link?: Maybe<PrismicLinkType>;
  link_label?: Maybe<Scalars['String']>;
};

export type PrismicFooterDataColumn1LinksFilterInput = {
  link?: InputMaybe<PrismicLinkTypeFilterInput>;
  link_label?: InputMaybe<StringQueryOperatorInput>;
};

export type PrismicFooterDataColumn1LinksFilterListInput = {
  elemMatch?: InputMaybe<PrismicFooterDataColumn1LinksFilterInput>;
};

export type PrismicFooterDataColumn2Links = {
  link?: Maybe<PrismicLinkType>;
  link_label?: Maybe<Scalars['String']>;
};

export type PrismicFooterDataColumn2LinksFilterInput = {
  link?: InputMaybe<PrismicLinkTypeFilterInput>;
  link_label?: InputMaybe<StringQueryOperatorInput>;
};

export type PrismicFooterDataColumn2LinksFilterListInput = {
  elemMatch?: InputMaybe<PrismicFooterDataColumn2LinksFilterInput>;
};

export type PrismicFooterDataColumn3Links = {
  link?: Maybe<PrismicLinkType>;
  link_label?: Maybe<Scalars['String']>;
};

export type PrismicFooterDataColumn3LinksFilterInput = {
  link?: InputMaybe<PrismicLinkTypeFilterInput>;
  link_label?: InputMaybe<StringQueryOperatorInput>;
};

export type PrismicFooterDataColumn3LinksFilterListInput = {
  elemMatch?: InputMaybe<PrismicFooterDataColumn3LinksFilterInput>;
};

export type PrismicFooterDataType = {
  column1_heading?: Maybe<PrismicStructuredTextType>;
  column1_links?: Maybe<Array<Maybe<PrismicFooterDataColumn1Links>>>;
  column2_heading?: Maybe<PrismicStructuredTextType>;
  column2_links?: Maybe<Array<Maybe<PrismicFooterDataColumn2Links>>>;
  column3_heading?: Maybe<PrismicStructuredTextType>;
  column3_links?: Maybe<Array<Maybe<PrismicFooterDataColumn3Links>>>;
  cta_button_label?: Maybe<Scalars['String']>;
  cta_button_link?: Maybe<PrismicLinkType>;
  heading?: Maybe<PrismicStructuredTextType>;
  subheading?: Maybe<PrismicStructuredTextType>;
};

export type PrismicFooterDataTypeFilterInput = {
  column1_heading?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  column1_links?: InputMaybe<PrismicFooterDataColumn1LinksFilterListInput>;
  column2_heading?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  column2_links?: InputMaybe<PrismicFooterDataColumn2LinksFilterListInput>;
  column3_heading?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  column3_links?: InputMaybe<PrismicFooterDataColumn3LinksFilterListInput>;
  cta_button_label?: InputMaybe<StringQueryOperatorInput>;
  cta_button_link?: InputMaybe<PrismicLinkTypeFilterInput>;
  heading?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  subheading?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
};

export type PrismicFooterEdge = {
  next?: Maybe<PrismicFooter>;
  node: PrismicFooter;
  previous?: Maybe<PrismicFooter>;
};

export enum PrismicFooterFieldsEnum {
  data___column1_heading___text = 'data___column1_heading___text',
  data___column1_heading___html = 'data___column1_heading___html',
  data___column1_heading___richText = 'data___column1_heading___richText',
  data___column1_heading___raw = 'data___column1_heading___raw',
  data___column1_links = 'data___column1_links',
  data___column1_links___link___link_type = 'data___column1_links___link___link_type',
  data___column1_links___link___isBroken = 'data___column1_links___link___isBroken',
  data___column1_links___link___url = 'data___column1_links___link___url',
  data___column1_links___link___target = 'data___column1_links___link___target',
  data___column1_links___link___size = 'data___column1_links___link___size',
  data___column1_links___link___id = 'data___column1_links___link___id',
  data___column1_links___link___type = 'data___column1_links___link___type',
  data___column1_links___link___tags = 'data___column1_links___link___tags',
  data___column1_links___link___lang = 'data___column1_links___link___lang',
  data___column1_links___link___slug = 'data___column1_links___link___slug',
  data___column1_links___link___uid = 'data___column1_links___link___uid',
  data___column1_links___link___raw = 'data___column1_links___link___raw',
  data___column1_links___link_label = 'data___column1_links___link_label',
  data___column2_heading___text = 'data___column2_heading___text',
  data___column2_heading___html = 'data___column2_heading___html',
  data___column2_heading___richText = 'data___column2_heading___richText',
  data___column2_heading___raw = 'data___column2_heading___raw',
  data___column2_links = 'data___column2_links',
  data___column2_links___link___link_type = 'data___column2_links___link___link_type',
  data___column2_links___link___isBroken = 'data___column2_links___link___isBroken',
  data___column2_links___link___url = 'data___column2_links___link___url',
  data___column2_links___link___target = 'data___column2_links___link___target',
  data___column2_links___link___size = 'data___column2_links___link___size',
  data___column2_links___link___id = 'data___column2_links___link___id',
  data___column2_links___link___type = 'data___column2_links___link___type',
  data___column2_links___link___tags = 'data___column2_links___link___tags',
  data___column2_links___link___lang = 'data___column2_links___link___lang',
  data___column2_links___link___slug = 'data___column2_links___link___slug',
  data___column2_links___link___uid = 'data___column2_links___link___uid',
  data___column2_links___link___raw = 'data___column2_links___link___raw',
  data___column2_links___link_label = 'data___column2_links___link_label',
  data___column3_heading___text = 'data___column3_heading___text',
  data___column3_heading___html = 'data___column3_heading___html',
  data___column3_heading___richText = 'data___column3_heading___richText',
  data___column3_heading___raw = 'data___column3_heading___raw',
  data___column3_links = 'data___column3_links',
  data___column3_links___link___link_type = 'data___column3_links___link___link_type',
  data___column3_links___link___isBroken = 'data___column3_links___link___isBroken',
  data___column3_links___link___url = 'data___column3_links___link___url',
  data___column3_links___link___target = 'data___column3_links___link___target',
  data___column3_links___link___size = 'data___column3_links___link___size',
  data___column3_links___link___id = 'data___column3_links___link___id',
  data___column3_links___link___type = 'data___column3_links___link___type',
  data___column3_links___link___tags = 'data___column3_links___link___tags',
  data___column3_links___link___lang = 'data___column3_links___link___lang',
  data___column3_links___link___slug = 'data___column3_links___link___slug',
  data___column3_links___link___uid = 'data___column3_links___link___uid',
  data___column3_links___link___raw = 'data___column3_links___link___raw',
  data___column3_links___link_label = 'data___column3_links___link_label',
  data___cta_button_label = 'data___cta_button_label',
  data___cta_button_link___link_type = 'data___cta_button_link___link_type',
  data___cta_button_link___isBroken = 'data___cta_button_link___isBroken',
  data___cta_button_link___url = 'data___cta_button_link___url',
  data___cta_button_link___target = 'data___cta_button_link___target',
  data___cta_button_link___size = 'data___cta_button_link___size',
  data___cta_button_link___id = 'data___cta_button_link___id',
  data___cta_button_link___type = 'data___cta_button_link___type',
  data___cta_button_link___tags = 'data___cta_button_link___tags',
  data___cta_button_link___lang = 'data___cta_button_link___lang',
  data___cta_button_link___slug = 'data___cta_button_link___slug',
  data___cta_button_link___uid = 'data___cta_button_link___uid',
  data___cta_button_link___localFile___sourceInstanceName = 'data___cta_button_link___localFile___sourceInstanceName',
  data___cta_button_link___localFile___absolutePath = 'data___cta_button_link___localFile___absolutePath',
  data___cta_button_link___localFile___relativePath = 'data___cta_button_link___localFile___relativePath',
  data___cta_button_link___localFile___extension = 'data___cta_button_link___localFile___extension',
  data___cta_button_link___localFile___size = 'data___cta_button_link___localFile___size',
  data___cta_button_link___localFile___prettySize = 'data___cta_button_link___localFile___prettySize',
  data___cta_button_link___localFile___modifiedTime = 'data___cta_button_link___localFile___modifiedTime',
  data___cta_button_link___localFile___accessTime = 'data___cta_button_link___localFile___accessTime',
  data___cta_button_link___localFile___changeTime = 'data___cta_button_link___localFile___changeTime',
  data___cta_button_link___localFile___birthTime = 'data___cta_button_link___localFile___birthTime',
  data___cta_button_link___localFile___root = 'data___cta_button_link___localFile___root',
  data___cta_button_link___localFile___dir = 'data___cta_button_link___localFile___dir',
  data___cta_button_link___localFile___base = 'data___cta_button_link___localFile___base',
  data___cta_button_link___localFile___ext = 'data___cta_button_link___localFile___ext',
  data___cta_button_link___localFile___name = 'data___cta_button_link___localFile___name',
  data___cta_button_link___localFile___relativeDirectory = 'data___cta_button_link___localFile___relativeDirectory',
  data___cta_button_link___localFile___dev = 'data___cta_button_link___localFile___dev',
  data___cta_button_link___localFile___mode = 'data___cta_button_link___localFile___mode',
  data___cta_button_link___localFile___nlink = 'data___cta_button_link___localFile___nlink',
  data___cta_button_link___localFile___uid = 'data___cta_button_link___localFile___uid',
  data___cta_button_link___localFile___gid = 'data___cta_button_link___localFile___gid',
  data___cta_button_link___localFile___rdev = 'data___cta_button_link___localFile___rdev',
  data___cta_button_link___localFile___ino = 'data___cta_button_link___localFile___ino',
  data___cta_button_link___localFile___atimeMs = 'data___cta_button_link___localFile___atimeMs',
  data___cta_button_link___localFile___mtimeMs = 'data___cta_button_link___localFile___mtimeMs',
  data___cta_button_link___localFile___ctimeMs = 'data___cta_button_link___localFile___ctimeMs',
  data___cta_button_link___localFile___atime = 'data___cta_button_link___localFile___atime',
  data___cta_button_link___localFile___mtime = 'data___cta_button_link___localFile___mtime',
  data___cta_button_link___localFile___ctime = 'data___cta_button_link___localFile___ctime',
  data___cta_button_link___localFile___birthtime = 'data___cta_button_link___localFile___birthtime',
  data___cta_button_link___localFile___birthtimeMs = 'data___cta_button_link___localFile___birthtimeMs',
  data___cta_button_link___localFile___blksize = 'data___cta_button_link___localFile___blksize',
  data___cta_button_link___localFile___blocks = 'data___cta_button_link___localFile___blocks',
  data___cta_button_link___localFile___publicURL = 'data___cta_button_link___localFile___publicURL',
  data___cta_button_link___localFile___childrenImageSharp = 'data___cta_button_link___localFile___childrenImageSharp',
  data___cta_button_link___localFile___id = 'data___cta_button_link___localFile___id',
  data___cta_button_link___localFile___children = 'data___cta_button_link___localFile___children',
  data___cta_button_link___raw = 'data___cta_button_link___raw',
  data___heading___text = 'data___heading___text',
  data___heading___html = 'data___heading___html',
  data___heading___richText = 'data___heading___richText',
  data___heading___raw = 'data___heading___raw',
  data___subheading___text = 'data___subheading___text',
  data___subheading___html = 'data___subheading___html',
  data___subheading___richText = 'data___subheading___richText',
  data___subheading___raw = 'data___subheading___raw',
  dataRaw = 'dataRaw',
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicFooterFilterInput = {
  data?: InputMaybe<PrismicFooterDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicFooterGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicFooterEdge>;
  nodes: Array<PrismicFooter>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicFooterGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicFooterGroupConnectionDistinctArgs = {
  field: PrismicFooterFieldsEnum;
};


export type PrismicFooterGroupConnectionMaxArgs = {
  field: PrismicFooterFieldsEnum;
};


export type PrismicFooterGroupConnectionMinArgs = {
  field: PrismicFooterFieldsEnum;
};


export type PrismicFooterGroupConnectionSumArgs = {
  field: PrismicFooterFieldsEnum;
};


export type PrismicFooterGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicFooterFieldsEnum;
};

export type PrismicFooterSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicFooterFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicGeoPointType = {
  longitude: Scalars['Float'];
  latitude: Scalars['Float'];
};

export type PrismicGrowthCalculator = Node & {
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  uid: Scalars['String'];
  data: PrismicGrowthCalculatorDataType;
  dataRaw: Scalars['JSON'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicGrowthCalculatorFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicGrowthCalculatorLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicGrowthCalculatorConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicGrowthCalculatorEdge>;
  nodes: Array<PrismicGrowthCalculator>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicGrowthCalculatorGroupConnection>;
};


export type PrismicGrowthCalculatorConnectionDistinctArgs = {
  field: PrismicGrowthCalculatorFieldsEnum;
};


export type PrismicGrowthCalculatorConnectionMaxArgs = {
  field: PrismicGrowthCalculatorFieldsEnum;
};


export type PrismicGrowthCalculatorConnectionMinArgs = {
  field: PrismicGrowthCalculatorFieldsEnum;
};


export type PrismicGrowthCalculatorConnectionSumArgs = {
  field: PrismicGrowthCalculatorFieldsEnum;
};


export type PrismicGrowthCalculatorConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicGrowthCalculatorFieldsEnum;
};

export type PrismicGrowthCalculatorDataBodySlicesType = PrismicGrowthCalculatorDataBodyTextWithReferences;

export type PrismicGrowthCalculatorDataBodyTextWithReferences = PrismicSliceType & {
  items: Array<PrismicGrowthCalculatorDataBodyTextWithReferencesItem>;
  primary: PrismicGrowthCalculatorDataBodyTextWithReferencesPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicGrowthCalculatorDataBodyTextWithReferencesItem = {
  references?: Maybe<PrismicStructuredTextType>;
};

export type PrismicGrowthCalculatorDataBodyTextWithReferencesPrimary = {
  text?: Maybe<PrismicStructuredTextType>;
};

export type PrismicGrowthCalculatorDataPageImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicGrowthCalculatorDataPageImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicGrowthCalculatorDataPageImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicGrowthCalculatorDataPageImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicGrowthCalculatorDataPageImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicGrowthCalculatorDataPageImageImageTypeFilterInput = {
  alt?: InputMaybe<StringQueryOperatorInput>;
  copyright?: InputMaybe<StringQueryOperatorInput>;
  dimensions?: InputMaybe<PrismicImageDimensionsTypeFilterInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  fixed?: InputMaybe<ImgixFixedFilterInput>;
  fluid?: InputMaybe<ImgixFluidFilterInput>;
  gatsbyImageData?: InputMaybe<JsonQueryOperatorInput>;
  localFile?: InputMaybe<FileFilterInput>;
};

export type PrismicGrowthCalculatorDataType = {
  body: Array<PrismicGrowthCalculatorDataBodySlicesType>;
  page_description?: Maybe<PrismicStructuredTextType>;
  page_image?: Maybe<PrismicGrowthCalculatorDataPageImageImageType>;
  page_title?: Maybe<PrismicStructuredTextType>;
};

export type PrismicGrowthCalculatorDataTypeFilterInput = {
  page_description?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  page_image?: InputMaybe<PrismicGrowthCalculatorDataPageImageImageTypeFilterInput>;
  page_title?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
};

export type PrismicGrowthCalculatorEdge = {
  next?: Maybe<PrismicGrowthCalculator>;
  node: PrismicGrowthCalculator;
  previous?: Maybe<PrismicGrowthCalculator>;
};

export enum PrismicGrowthCalculatorFieldsEnum {
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  uid = 'uid',
  data___page_description___text = 'data___page_description___text',
  data___page_description___html = 'data___page_description___html',
  data___page_description___richText = 'data___page_description___richText',
  data___page_description___raw = 'data___page_description___raw',
  data___page_image___alt = 'data___page_image___alt',
  data___page_image___copyright = 'data___page_image___copyright',
  data___page_image___dimensions___width = 'data___page_image___dimensions___width',
  data___page_image___dimensions___height = 'data___page_image___dimensions___height',
  data___page_image___url = 'data___page_image___url',
  data___page_image___fixed___base64 = 'data___page_image___fixed___base64',
  data___page_image___fixed___src = 'data___page_image___fixed___src',
  data___page_image___fixed___srcSet = 'data___page_image___fixed___srcSet',
  data___page_image___fixed___srcWebp = 'data___page_image___fixed___srcWebp',
  data___page_image___fixed___srcSetWebp = 'data___page_image___fixed___srcSetWebp',
  data___page_image___fixed___sizes = 'data___page_image___fixed___sizes',
  data___page_image___fixed___width = 'data___page_image___fixed___width',
  data___page_image___fixed___height = 'data___page_image___fixed___height',
  data___page_image___fluid___base64 = 'data___page_image___fluid___base64',
  data___page_image___fluid___src = 'data___page_image___fluid___src',
  data___page_image___fluid___srcSet = 'data___page_image___fluid___srcSet',
  data___page_image___fluid___srcWebp = 'data___page_image___fluid___srcWebp',
  data___page_image___fluid___srcSetWebp = 'data___page_image___fluid___srcSetWebp',
  data___page_image___fluid___sizes = 'data___page_image___fluid___sizes',
  data___page_image___fluid___aspectRatio = 'data___page_image___fluid___aspectRatio',
  data___page_image___gatsbyImageData = 'data___page_image___gatsbyImageData',
  data___page_image___localFile___sourceInstanceName = 'data___page_image___localFile___sourceInstanceName',
  data___page_image___localFile___absolutePath = 'data___page_image___localFile___absolutePath',
  data___page_image___localFile___relativePath = 'data___page_image___localFile___relativePath',
  data___page_image___localFile___extension = 'data___page_image___localFile___extension',
  data___page_image___localFile___size = 'data___page_image___localFile___size',
  data___page_image___localFile___prettySize = 'data___page_image___localFile___prettySize',
  data___page_image___localFile___modifiedTime = 'data___page_image___localFile___modifiedTime',
  data___page_image___localFile___accessTime = 'data___page_image___localFile___accessTime',
  data___page_image___localFile___changeTime = 'data___page_image___localFile___changeTime',
  data___page_image___localFile___birthTime = 'data___page_image___localFile___birthTime',
  data___page_image___localFile___root = 'data___page_image___localFile___root',
  data___page_image___localFile___dir = 'data___page_image___localFile___dir',
  data___page_image___localFile___base = 'data___page_image___localFile___base',
  data___page_image___localFile___ext = 'data___page_image___localFile___ext',
  data___page_image___localFile___name = 'data___page_image___localFile___name',
  data___page_image___localFile___relativeDirectory = 'data___page_image___localFile___relativeDirectory',
  data___page_image___localFile___dev = 'data___page_image___localFile___dev',
  data___page_image___localFile___mode = 'data___page_image___localFile___mode',
  data___page_image___localFile___nlink = 'data___page_image___localFile___nlink',
  data___page_image___localFile___uid = 'data___page_image___localFile___uid',
  data___page_image___localFile___gid = 'data___page_image___localFile___gid',
  data___page_image___localFile___rdev = 'data___page_image___localFile___rdev',
  data___page_image___localFile___ino = 'data___page_image___localFile___ino',
  data___page_image___localFile___atimeMs = 'data___page_image___localFile___atimeMs',
  data___page_image___localFile___mtimeMs = 'data___page_image___localFile___mtimeMs',
  data___page_image___localFile___ctimeMs = 'data___page_image___localFile___ctimeMs',
  data___page_image___localFile___atime = 'data___page_image___localFile___atime',
  data___page_image___localFile___mtime = 'data___page_image___localFile___mtime',
  data___page_image___localFile___ctime = 'data___page_image___localFile___ctime',
  data___page_image___localFile___birthtime = 'data___page_image___localFile___birthtime',
  data___page_image___localFile___birthtimeMs = 'data___page_image___localFile___birthtimeMs',
  data___page_image___localFile___blksize = 'data___page_image___localFile___blksize',
  data___page_image___localFile___blocks = 'data___page_image___localFile___blocks',
  data___page_image___localFile___publicURL = 'data___page_image___localFile___publicURL',
  data___page_image___localFile___childrenImageSharp = 'data___page_image___localFile___childrenImageSharp',
  data___page_image___localFile___id = 'data___page_image___localFile___id',
  data___page_image___localFile___children = 'data___page_image___localFile___children',
  data___page_title___text = 'data___page_title___text',
  data___page_title___html = 'data___page_title___html',
  data___page_title___richText = 'data___page_title___richText',
  data___page_title___raw = 'data___page_title___raw',
  dataRaw = 'dataRaw',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicGrowthCalculatorFilterInput = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  uid?: InputMaybe<StringQueryOperatorInput>;
  data?: InputMaybe<PrismicGrowthCalculatorDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicGrowthCalculatorGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicGrowthCalculatorEdge>;
  nodes: Array<PrismicGrowthCalculator>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicGrowthCalculatorGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicGrowthCalculatorGroupConnectionDistinctArgs = {
  field: PrismicGrowthCalculatorFieldsEnum;
};


export type PrismicGrowthCalculatorGroupConnectionMaxArgs = {
  field: PrismicGrowthCalculatorFieldsEnum;
};


export type PrismicGrowthCalculatorGroupConnectionMinArgs = {
  field: PrismicGrowthCalculatorFieldsEnum;
};


export type PrismicGrowthCalculatorGroupConnectionSumArgs = {
  field: PrismicGrowthCalculatorFieldsEnum;
};


export type PrismicGrowthCalculatorGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicGrowthCalculatorFieldsEnum;
};

export type PrismicGrowthCalculatorSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicGrowthCalculatorFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicHomepage = Node & {
  data: PrismicHomepageDataType;
  dataRaw: Scalars['JSON'];
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicHomepageFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicHomepageLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicHomepageConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicHomepageEdge>;
  nodes: Array<PrismicHomepage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicHomepageGroupConnection>;
};


export type PrismicHomepageConnectionDistinctArgs = {
  field: PrismicHomepageFieldsEnum;
};


export type PrismicHomepageConnectionMaxArgs = {
  field: PrismicHomepageFieldsEnum;
};


export type PrismicHomepageConnectionMinArgs = {
  field: PrismicHomepageFieldsEnum;
};


export type PrismicHomepageConnectionSumArgs = {
  field: PrismicHomepageFieldsEnum;
};


export type PrismicHomepageConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicHomepageFieldsEnum;
};

export type PrismicHomepageDataBodyCardsSection = PrismicSliceType & {
  items: Array<PrismicHomepageDataBodyCardsSectionItem>;
  primary: PrismicHomepageDataBodyCardsSectionPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicHomepageDataBodyCardsSectionItem = {
  card_body?: Maybe<Scalars['String']>;
  card_heading?: Maybe<Scalars['String']>;
  card_image?: Maybe<PrismicHomepageDataBodyCardsSectionItemsCardImageImageType>;
  card_link?: Maybe<PrismicLinkType>;
  card_link_label?: Maybe<Scalars['String']>;
};

export type PrismicHomepageDataBodyCardsSectionItemsCardImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicHomepageDataBodyCardsSectionItemsCardImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyCardsSectionItemsCardImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyCardsSectionItemsCardImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyCardsSectionItemsCardImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicHomepageDataBodyCardsSectionPrimary = {
  background?: Maybe<Scalars['String']>;
  card_text_position?: Maybe<Scalars['String']>;
  description?: Maybe<PrismicStructuredTextType>;
  headline?: Maybe<PrismicStructuredTextType>;
  headline_position?: Maybe<Scalars['String']>;
  number_of_columns?: Maybe<Scalars['String']>;
  primary_cta_label?: Maybe<Scalars['String']>;
  primary_cta_link?: Maybe<PrismicLinkType>;
  secondary_cta_label?: Maybe<Scalars['String']>;
  secondary_cta_link?: Maybe<PrismicLinkType>;
  vertical_margin?: Maybe<Scalars['String']>;
};

export type PrismicHomepageDataBodyCtaBanner = PrismicSliceType & {
  primary: PrismicHomepageDataBodyCtaBannerPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicHomepageDataBodyCtaBannerPrimary = {
  background?: Maybe<Scalars['String']>;
  heading?: Maybe<PrismicStructuredTextType>;
  primary_cta_icon?: Maybe<Scalars['String']>;
  primary_cta_label?: Maybe<Scalars['String']>;
  primary_cta_link?: Maybe<PrismicLinkType>;
  secondary_cta_icon?: Maybe<Scalars['String']>;
  secondary_cta_label?: Maybe<Scalars['String']>;
  secondary_cta_link?: Maybe<PrismicLinkType>;
  vertical_margin?: Maybe<Scalars['String']>;
};

export type PrismicHomepageDataBodyCustomerLogos = PrismicSliceType & {
  items: Array<PrismicHomepageDataBodyCustomerLogosItem>;
  primary: PrismicHomepageDataBodyCustomerLogosPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicHomepageDataBodyCustomerLogosItem = {
  link?: Maybe<PrismicLinkType>;
  logo?: Maybe<PrismicHomepageDataBodyCustomerLogosItemsLogoImageType>;
};

export type PrismicHomepageDataBodyCustomerLogosItemsLogoImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicHomepageDataBodyCustomerLogosItemsLogoImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyCustomerLogosItemsLogoImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyCustomerLogosItemsLogoImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyCustomerLogosItemsLogoImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicHomepageDataBodyCustomerLogosPrimary = {
  eyebrow_headline?: Maybe<PrismicStructuredTextType>;
};

export type PrismicHomepageDataBodyFullWidthImage = PrismicSliceType & {
  items: Array<PrismicHomepageDataBodyFullWidthImageItem>;
  primary: PrismicHomepageDataBodyFullWidthImagePrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicHomepageDataBodyFullWidthImageItem = {
  list_item?: Maybe<Scalars['String']>;
};

export type PrismicHomepageDataBodyFullWidthImagePrimary = {
  background?: Maybe<Scalars['String']>;
  cta_label?: Maybe<Scalars['String']>;
  cta_link?: Maybe<PrismicLinkType>;
  gradient_image?: Maybe<PrismicHomepageDataBodyFullWidthImagePrimaryGradientImageImageType>;
  heading?: Maybe<PrismicStructuredTextType>;
  image?: Maybe<PrismicHomepageDataBodyFullWidthImagePrimaryImageImageType>;
  mobile_gradient_image?: Maybe<PrismicHomepageDataBodyFullWidthImagePrimaryMobileGradientImageImageType>;
  mobile_image?: Maybe<PrismicHomepageDataBodyFullWidthImagePrimaryMobileImageImageType>;
  subheading?: Maybe<PrismicStructuredTextType>;
  subheading_position?: Maybe<Scalars['String']>;
  vertical_margin?: Maybe<Scalars['String']>;
};

export type PrismicHomepageDataBodyFullWidthImagePrimaryGradientImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicHomepageDataBodyFullWidthImagePrimaryGradientImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyFullWidthImagePrimaryGradientImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyFullWidthImagePrimaryGradientImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyFullWidthImagePrimaryGradientImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicHomepageDataBodyFullWidthImagePrimaryImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicHomepageDataBodyFullWidthImagePrimaryImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyFullWidthImagePrimaryImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyFullWidthImagePrimaryImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyFullWidthImagePrimaryImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicHomepageDataBodyFullWidthImagePrimaryMobileGradientImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicHomepageDataBodyFullWidthImagePrimaryMobileGradientImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyFullWidthImagePrimaryMobileGradientImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyFullWidthImagePrimaryMobileGradientImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyFullWidthImagePrimaryMobileGradientImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicHomepageDataBodyFullWidthImagePrimaryMobileImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicHomepageDataBodyFullWidthImagePrimaryMobileImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyFullWidthImagePrimaryMobileImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyFullWidthImagePrimaryMobileImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyFullWidthImagePrimaryMobileImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicHomepageDataBodyHomepageHero = PrismicSliceType & {
  primary: PrismicHomepageDataBodyHomepageHeroPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicHomepageDataBodyHomepageHeroPrimary = {
  cta_link?: Maybe<PrismicLinkType>;
  cta_text?: Maybe<PrismicStructuredTextType>;
  section_title?: Maybe<PrismicStructuredTextType>;
  text?: Maybe<PrismicStructuredTextType>;
  video_link?: Maybe<PrismicLinkType>;
};

export type PrismicHomepageDataBodyInfoWithImage = PrismicSliceType & {
  items: Array<PrismicHomepageDataBodyInfoWithImageItem>;
  primary: PrismicHomepageDataBodyInfoWithImagePrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicHomepageDataBodyInfoWithImageItem = {
  list_item?: Maybe<Scalars['String']>;
};

export type PrismicHomepageDataBodyInfoWithImagePrimary = {
  background?: Maybe<Scalars['String']>;
  featured_image?: Maybe<PrismicHomepageDataBodyInfoWithImagePrimaryFeaturedImageImageType>;
  heading?: Maybe<PrismicStructuredTextType>;
  primary_link?: Maybe<PrismicLinkType>;
  primary_link_text?: Maybe<PrismicStructuredTextType>;
  subheading?: Maybe<PrismicStructuredTextType>;
  vertical_margin?: Maybe<Scalars['String']>;
};

export type PrismicHomepageDataBodyInfoWithImagePrimaryFeaturedImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicHomepageDataBodyInfoWithImagePrimaryFeaturedImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyInfoWithImagePrimaryFeaturedImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyInfoWithImagePrimaryFeaturedImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyInfoWithImagePrimaryFeaturedImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicHomepageDataBodySlicesType = PrismicHomepageDataBodyCardsSection | PrismicHomepageDataBodyCtaBanner | PrismicHomepageDataBodyCustomerLogos | PrismicHomepageDataBodyFullWidthImage | PrismicHomepageDataBodyHomepageHero | PrismicHomepageDataBodyInfoWithImage | PrismicHomepageDataBodyTabsEmbed | PrismicHomepageDataBodyTestimonialCarousel | PrismicHomepageDataBodyWistiaVideo;

export type PrismicHomepageDataBodyTabsEmbed = PrismicSliceType & {
  items: Array<PrismicHomepageDataBodyTabsEmbedItem>;
  primary: PrismicHomepageDataBodyTabsEmbedPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicHomepageDataBodyTabsEmbedItem = {
  iframe_src?: Maybe<PrismicLinkType>;
  tab_label?: Maybe<Scalars['String']>;
};

export type PrismicHomepageDataBodyTabsEmbedPrimary = {
  heading?: Maybe<PrismicStructuredTextType>;
  mobile_image?: Maybe<PrismicHomepageDataBodyTabsEmbedPrimaryMobileImageImageType>;
  vertical_margin?: Maybe<Scalars['String']>;
};

export type PrismicHomepageDataBodyTabsEmbedPrimaryMobileImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicHomepageDataBodyTabsEmbedPrimaryMobileImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyTabsEmbedPrimaryMobileImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyTabsEmbedPrimaryMobileImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyTabsEmbedPrimaryMobileImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicHomepageDataBodyTestimonialCarousel = PrismicSliceType & {
  items: Array<PrismicHomepageDataBodyTestimonialCarouselItem>;
  primary: PrismicHomepageDataBodyTestimonialCarouselPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicHomepageDataBodyTestimonialCarouselItem = {
  author_name?: Maybe<Scalars['String']>;
  author_title?: Maybe<Scalars['String']>;
  image?: Maybe<PrismicHomepageDataBodyTestimonialCarouselItemsImageImageType>;
  quote?: Maybe<Scalars['String']>;
};

export type PrismicHomepageDataBodyTestimonialCarouselItemsImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicHomepageDataBodyTestimonialCarouselItemsImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyTestimonialCarouselItemsImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyTestimonialCarouselItemsImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataBodyTestimonialCarouselItemsImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicHomepageDataBodyTestimonialCarouselPrimary = {
  background?: Maybe<Scalars['String']>;
  heading?: Maybe<PrismicStructuredTextType>;
};

export type PrismicHomepageDataBodyWistiaVideo = PrismicSliceType & {
  primary: PrismicHomepageDataBodyWistiaVideoPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicHomepageDataBodyWistiaVideoPrimary = {
  video_link?: Maybe<PrismicLinkType>;
};

export type PrismicHomepageDataPageImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicHomepageDataPageImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataPageImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataPageImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicHomepageDataPageImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicHomepageDataPageImageImageTypeFilterInput = {
  alt?: InputMaybe<StringQueryOperatorInput>;
  copyright?: InputMaybe<StringQueryOperatorInput>;
  dimensions?: InputMaybe<PrismicImageDimensionsTypeFilterInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  fixed?: InputMaybe<ImgixFixedFilterInput>;
  fluid?: InputMaybe<ImgixFluidFilterInput>;
  gatsbyImageData?: InputMaybe<JsonQueryOperatorInput>;
  localFile?: InputMaybe<FileFilterInput>;
};

export type PrismicHomepageDataType = {
  body: Array<PrismicHomepageDataBodySlicesType>;
  page_description?: Maybe<PrismicStructuredTextType>;
  page_image?: Maybe<PrismicHomepageDataPageImageImageType>;
  page_title?: Maybe<PrismicStructuredTextType>;
};

export type PrismicHomepageDataTypeFilterInput = {
  page_description?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  page_image?: InputMaybe<PrismicHomepageDataPageImageImageTypeFilterInput>;
  page_title?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
};

export type PrismicHomepageEdge = {
  next?: Maybe<PrismicHomepage>;
  node: PrismicHomepage;
  previous?: Maybe<PrismicHomepage>;
};

export enum PrismicHomepageFieldsEnum {
  data___page_description___text = 'data___page_description___text',
  data___page_description___html = 'data___page_description___html',
  data___page_description___richText = 'data___page_description___richText',
  data___page_description___raw = 'data___page_description___raw',
  data___page_image___alt = 'data___page_image___alt',
  data___page_image___copyright = 'data___page_image___copyright',
  data___page_image___dimensions___width = 'data___page_image___dimensions___width',
  data___page_image___dimensions___height = 'data___page_image___dimensions___height',
  data___page_image___url = 'data___page_image___url',
  data___page_image___fixed___base64 = 'data___page_image___fixed___base64',
  data___page_image___fixed___src = 'data___page_image___fixed___src',
  data___page_image___fixed___srcSet = 'data___page_image___fixed___srcSet',
  data___page_image___fixed___srcWebp = 'data___page_image___fixed___srcWebp',
  data___page_image___fixed___srcSetWebp = 'data___page_image___fixed___srcSetWebp',
  data___page_image___fixed___sizes = 'data___page_image___fixed___sizes',
  data___page_image___fixed___width = 'data___page_image___fixed___width',
  data___page_image___fixed___height = 'data___page_image___fixed___height',
  data___page_image___fluid___base64 = 'data___page_image___fluid___base64',
  data___page_image___fluid___src = 'data___page_image___fluid___src',
  data___page_image___fluid___srcSet = 'data___page_image___fluid___srcSet',
  data___page_image___fluid___srcWebp = 'data___page_image___fluid___srcWebp',
  data___page_image___fluid___srcSetWebp = 'data___page_image___fluid___srcSetWebp',
  data___page_image___fluid___sizes = 'data___page_image___fluid___sizes',
  data___page_image___fluid___aspectRatio = 'data___page_image___fluid___aspectRatio',
  data___page_image___gatsbyImageData = 'data___page_image___gatsbyImageData',
  data___page_image___localFile___sourceInstanceName = 'data___page_image___localFile___sourceInstanceName',
  data___page_image___localFile___absolutePath = 'data___page_image___localFile___absolutePath',
  data___page_image___localFile___relativePath = 'data___page_image___localFile___relativePath',
  data___page_image___localFile___extension = 'data___page_image___localFile___extension',
  data___page_image___localFile___size = 'data___page_image___localFile___size',
  data___page_image___localFile___prettySize = 'data___page_image___localFile___prettySize',
  data___page_image___localFile___modifiedTime = 'data___page_image___localFile___modifiedTime',
  data___page_image___localFile___accessTime = 'data___page_image___localFile___accessTime',
  data___page_image___localFile___changeTime = 'data___page_image___localFile___changeTime',
  data___page_image___localFile___birthTime = 'data___page_image___localFile___birthTime',
  data___page_image___localFile___root = 'data___page_image___localFile___root',
  data___page_image___localFile___dir = 'data___page_image___localFile___dir',
  data___page_image___localFile___base = 'data___page_image___localFile___base',
  data___page_image___localFile___ext = 'data___page_image___localFile___ext',
  data___page_image___localFile___name = 'data___page_image___localFile___name',
  data___page_image___localFile___relativeDirectory = 'data___page_image___localFile___relativeDirectory',
  data___page_image___localFile___dev = 'data___page_image___localFile___dev',
  data___page_image___localFile___mode = 'data___page_image___localFile___mode',
  data___page_image___localFile___nlink = 'data___page_image___localFile___nlink',
  data___page_image___localFile___uid = 'data___page_image___localFile___uid',
  data___page_image___localFile___gid = 'data___page_image___localFile___gid',
  data___page_image___localFile___rdev = 'data___page_image___localFile___rdev',
  data___page_image___localFile___ino = 'data___page_image___localFile___ino',
  data___page_image___localFile___atimeMs = 'data___page_image___localFile___atimeMs',
  data___page_image___localFile___mtimeMs = 'data___page_image___localFile___mtimeMs',
  data___page_image___localFile___ctimeMs = 'data___page_image___localFile___ctimeMs',
  data___page_image___localFile___atime = 'data___page_image___localFile___atime',
  data___page_image___localFile___mtime = 'data___page_image___localFile___mtime',
  data___page_image___localFile___ctime = 'data___page_image___localFile___ctime',
  data___page_image___localFile___birthtime = 'data___page_image___localFile___birthtime',
  data___page_image___localFile___birthtimeMs = 'data___page_image___localFile___birthtimeMs',
  data___page_image___localFile___blksize = 'data___page_image___localFile___blksize',
  data___page_image___localFile___blocks = 'data___page_image___localFile___blocks',
  data___page_image___localFile___publicURL = 'data___page_image___localFile___publicURL',
  data___page_image___localFile___childrenImageSharp = 'data___page_image___localFile___childrenImageSharp',
  data___page_image___localFile___id = 'data___page_image___localFile___id',
  data___page_image___localFile___children = 'data___page_image___localFile___children',
  data___page_title___text = 'data___page_title___text',
  data___page_title___html = 'data___page_title___html',
  data___page_title___richText = 'data___page_title___richText',
  data___page_title___raw = 'data___page_title___raw',
  dataRaw = 'dataRaw',
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicHomepageFilterInput = {
  data?: InputMaybe<PrismicHomepageDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicHomepageGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicHomepageEdge>;
  nodes: Array<PrismicHomepage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicHomepageGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicHomepageGroupConnectionDistinctArgs = {
  field: PrismicHomepageFieldsEnum;
};


export type PrismicHomepageGroupConnectionMaxArgs = {
  field: PrismicHomepageFieldsEnum;
};


export type PrismicHomepageGroupConnectionMinArgs = {
  field: PrismicHomepageFieldsEnum;
};


export type PrismicHomepageGroupConnectionSumArgs = {
  field: PrismicHomepageFieldsEnum;
};


export type PrismicHomepageGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicHomepageFieldsEnum;
};

export type PrismicHomepageSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicHomepageFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicImageDimensionsType = {
  width: Scalars['Int'];
  height: Scalars['Int'];
};

export type PrismicImageDimensionsTypeFilterInput = {
  width?: InputMaybe<IntQueryOperatorInput>;
  height?: InputMaybe<IntQueryOperatorInput>;
};

export type PrismicImageThumbnailType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicImageThumbnailTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicImageThumbnailTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicImageThumbnailTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicImageThumbnailTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicLinkType = {
  link_type?: Maybe<PrismicLinkTypeEnum>;
  isBroken?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  lang?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
  document?: Maybe<PrismicAllDocumentTypes>;
  localFile?: Maybe<File>;
  raw?: Maybe<Scalars['JSON']>;
};

export enum PrismicLinkTypeEnum {
  Any = 'Any',
  Document = 'Document',
  Media = 'Media',
  Web = 'Web'
}

export type PrismicLinkTypeEnumQueryOperatorInput = {
  eq?: InputMaybe<PrismicLinkTypeEnum>;
  ne?: InputMaybe<PrismicLinkTypeEnum>;
  in?: InputMaybe<Array<InputMaybe<PrismicLinkTypeEnum>>>;
  nin?: InputMaybe<Array<InputMaybe<PrismicLinkTypeEnum>>>;
};

export type PrismicLinkTypeFilterInput = {
  link_type?: InputMaybe<PrismicLinkTypeEnumQueryOperatorInput>;
  isBroken?: InputMaybe<BooleanQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  target?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  slug?: InputMaybe<StringQueryOperatorInput>;
  uid?: InputMaybe<StringQueryOperatorInput>;
  localFile?: InputMaybe<FileFilterInput>;
  raw?: InputMaybe<JsonQueryOperatorInput>;
};

export type PrismicLtvCalculator = Node & {
  uid: Scalars['String'];
  data: PrismicLtvCalculatorDataType;
  dataRaw: Scalars['JSON'];
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicLtvCalculatorFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicLtvCalculatorLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicLtvCalculatorConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicLtvCalculatorEdge>;
  nodes: Array<PrismicLtvCalculator>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicLtvCalculatorGroupConnection>;
};


export type PrismicLtvCalculatorConnectionDistinctArgs = {
  field: PrismicLtvCalculatorFieldsEnum;
};


export type PrismicLtvCalculatorConnectionMaxArgs = {
  field: PrismicLtvCalculatorFieldsEnum;
};


export type PrismicLtvCalculatorConnectionMinArgs = {
  field: PrismicLtvCalculatorFieldsEnum;
};


export type PrismicLtvCalculatorConnectionSumArgs = {
  field: PrismicLtvCalculatorFieldsEnum;
};


export type PrismicLtvCalculatorConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicLtvCalculatorFieldsEnum;
};

export type PrismicLtvCalculatorDataBodySlicesType = PrismicLtvCalculatorDataBodyTextWithReferences;

export type PrismicLtvCalculatorDataBodyTextWithReferences = PrismicSliceType & {
  items: Array<PrismicLtvCalculatorDataBodyTextWithReferencesItem>;
  primary: PrismicLtvCalculatorDataBodyTextWithReferencesPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicLtvCalculatorDataBodyTextWithReferencesItem = {
  references?: Maybe<PrismicStructuredTextType>;
};

export type PrismicLtvCalculatorDataBodyTextWithReferencesPrimary = {
  text?: Maybe<PrismicStructuredTextType>;
};

export type PrismicLtvCalculatorDataPageImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicLtvCalculatorDataPageImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicLtvCalculatorDataPageImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicLtvCalculatorDataPageImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicLtvCalculatorDataPageImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicLtvCalculatorDataPageImageImageTypeFilterInput = {
  alt?: InputMaybe<StringQueryOperatorInput>;
  copyright?: InputMaybe<StringQueryOperatorInput>;
  dimensions?: InputMaybe<PrismicImageDimensionsTypeFilterInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  fixed?: InputMaybe<ImgixFixedFilterInput>;
  fluid?: InputMaybe<ImgixFluidFilterInput>;
  gatsbyImageData?: InputMaybe<JsonQueryOperatorInput>;
  localFile?: InputMaybe<FileFilterInput>;
};

export type PrismicLtvCalculatorDataType = {
  body: Array<PrismicLtvCalculatorDataBodySlicesType>;
  page_description?: Maybe<PrismicStructuredTextType>;
  page_image?: Maybe<PrismicLtvCalculatorDataPageImageImageType>;
  page_title?: Maybe<PrismicStructuredTextType>;
};

export type PrismicLtvCalculatorDataTypeFilterInput = {
  page_description?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  page_image?: InputMaybe<PrismicLtvCalculatorDataPageImageImageTypeFilterInput>;
  page_title?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
};

export type PrismicLtvCalculatorEdge = {
  next?: Maybe<PrismicLtvCalculator>;
  node: PrismicLtvCalculator;
  previous?: Maybe<PrismicLtvCalculator>;
};

export enum PrismicLtvCalculatorFieldsEnum {
  uid = 'uid',
  data___page_description___text = 'data___page_description___text',
  data___page_description___html = 'data___page_description___html',
  data___page_description___richText = 'data___page_description___richText',
  data___page_description___raw = 'data___page_description___raw',
  data___page_image___alt = 'data___page_image___alt',
  data___page_image___copyright = 'data___page_image___copyright',
  data___page_image___dimensions___width = 'data___page_image___dimensions___width',
  data___page_image___dimensions___height = 'data___page_image___dimensions___height',
  data___page_image___url = 'data___page_image___url',
  data___page_image___fixed___base64 = 'data___page_image___fixed___base64',
  data___page_image___fixed___src = 'data___page_image___fixed___src',
  data___page_image___fixed___srcSet = 'data___page_image___fixed___srcSet',
  data___page_image___fixed___srcWebp = 'data___page_image___fixed___srcWebp',
  data___page_image___fixed___srcSetWebp = 'data___page_image___fixed___srcSetWebp',
  data___page_image___fixed___sizes = 'data___page_image___fixed___sizes',
  data___page_image___fixed___width = 'data___page_image___fixed___width',
  data___page_image___fixed___height = 'data___page_image___fixed___height',
  data___page_image___fluid___base64 = 'data___page_image___fluid___base64',
  data___page_image___fluid___src = 'data___page_image___fluid___src',
  data___page_image___fluid___srcSet = 'data___page_image___fluid___srcSet',
  data___page_image___fluid___srcWebp = 'data___page_image___fluid___srcWebp',
  data___page_image___fluid___srcSetWebp = 'data___page_image___fluid___srcSetWebp',
  data___page_image___fluid___sizes = 'data___page_image___fluid___sizes',
  data___page_image___fluid___aspectRatio = 'data___page_image___fluid___aspectRatio',
  data___page_image___gatsbyImageData = 'data___page_image___gatsbyImageData',
  data___page_image___localFile___sourceInstanceName = 'data___page_image___localFile___sourceInstanceName',
  data___page_image___localFile___absolutePath = 'data___page_image___localFile___absolutePath',
  data___page_image___localFile___relativePath = 'data___page_image___localFile___relativePath',
  data___page_image___localFile___extension = 'data___page_image___localFile___extension',
  data___page_image___localFile___size = 'data___page_image___localFile___size',
  data___page_image___localFile___prettySize = 'data___page_image___localFile___prettySize',
  data___page_image___localFile___modifiedTime = 'data___page_image___localFile___modifiedTime',
  data___page_image___localFile___accessTime = 'data___page_image___localFile___accessTime',
  data___page_image___localFile___changeTime = 'data___page_image___localFile___changeTime',
  data___page_image___localFile___birthTime = 'data___page_image___localFile___birthTime',
  data___page_image___localFile___root = 'data___page_image___localFile___root',
  data___page_image___localFile___dir = 'data___page_image___localFile___dir',
  data___page_image___localFile___base = 'data___page_image___localFile___base',
  data___page_image___localFile___ext = 'data___page_image___localFile___ext',
  data___page_image___localFile___name = 'data___page_image___localFile___name',
  data___page_image___localFile___relativeDirectory = 'data___page_image___localFile___relativeDirectory',
  data___page_image___localFile___dev = 'data___page_image___localFile___dev',
  data___page_image___localFile___mode = 'data___page_image___localFile___mode',
  data___page_image___localFile___nlink = 'data___page_image___localFile___nlink',
  data___page_image___localFile___uid = 'data___page_image___localFile___uid',
  data___page_image___localFile___gid = 'data___page_image___localFile___gid',
  data___page_image___localFile___rdev = 'data___page_image___localFile___rdev',
  data___page_image___localFile___ino = 'data___page_image___localFile___ino',
  data___page_image___localFile___atimeMs = 'data___page_image___localFile___atimeMs',
  data___page_image___localFile___mtimeMs = 'data___page_image___localFile___mtimeMs',
  data___page_image___localFile___ctimeMs = 'data___page_image___localFile___ctimeMs',
  data___page_image___localFile___atime = 'data___page_image___localFile___atime',
  data___page_image___localFile___mtime = 'data___page_image___localFile___mtime',
  data___page_image___localFile___ctime = 'data___page_image___localFile___ctime',
  data___page_image___localFile___birthtime = 'data___page_image___localFile___birthtime',
  data___page_image___localFile___birthtimeMs = 'data___page_image___localFile___birthtimeMs',
  data___page_image___localFile___blksize = 'data___page_image___localFile___blksize',
  data___page_image___localFile___blocks = 'data___page_image___localFile___blocks',
  data___page_image___localFile___publicURL = 'data___page_image___localFile___publicURL',
  data___page_image___localFile___childrenImageSharp = 'data___page_image___localFile___childrenImageSharp',
  data___page_image___localFile___id = 'data___page_image___localFile___id',
  data___page_image___localFile___children = 'data___page_image___localFile___children',
  data___page_title___text = 'data___page_title___text',
  data___page_title___html = 'data___page_title___html',
  data___page_title___richText = 'data___page_title___richText',
  data___page_title___raw = 'data___page_title___raw',
  dataRaw = 'dataRaw',
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicLtvCalculatorFilterInput = {
  uid?: InputMaybe<StringQueryOperatorInput>;
  data?: InputMaybe<PrismicLtvCalculatorDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicLtvCalculatorGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicLtvCalculatorEdge>;
  nodes: Array<PrismicLtvCalculator>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicLtvCalculatorGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicLtvCalculatorGroupConnectionDistinctArgs = {
  field: PrismicLtvCalculatorFieldsEnum;
};


export type PrismicLtvCalculatorGroupConnectionMaxArgs = {
  field: PrismicLtvCalculatorFieldsEnum;
};


export type PrismicLtvCalculatorGroupConnectionMinArgs = {
  field: PrismicLtvCalculatorFieldsEnum;
};


export type PrismicLtvCalculatorGroupConnectionSumArgs = {
  field: PrismicLtvCalculatorFieldsEnum;
};


export type PrismicLtvCalculatorGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicLtvCalculatorFieldsEnum;
};

export type PrismicLtvCalculatorSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicLtvCalculatorFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicMarketingPage = Node & {
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  uid: Scalars['String'];
  data: PrismicMarketingPageDataType;
  dataRaw: Scalars['JSON'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicMarketingPageFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicMarketingPageLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicMarketingPageConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicMarketingPageEdge>;
  nodes: Array<PrismicMarketingPage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicMarketingPageGroupConnection>;
};


export type PrismicMarketingPageConnectionDistinctArgs = {
  field: PrismicMarketingPageFieldsEnum;
};


export type PrismicMarketingPageConnectionMaxArgs = {
  field: PrismicMarketingPageFieldsEnum;
};


export type PrismicMarketingPageConnectionMinArgs = {
  field: PrismicMarketingPageFieldsEnum;
};


export type PrismicMarketingPageConnectionSumArgs = {
  field: PrismicMarketingPageFieldsEnum;
};


export type PrismicMarketingPageConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicMarketingPageFieldsEnum;
};

export type PrismicMarketingPageDataBodyCardsSection = PrismicSliceType & {
  items: Array<PrismicMarketingPageDataBodyCardsSectionItem>;
  primary: PrismicMarketingPageDataBodyCardsSectionPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyCardsSectionItem = {
  card_body?: Maybe<Scalars['String']>;
  card_heading?: Maybe<Scalars['String']>;
  card_image?: Maybe<PrismicMarketingPageDataBodyCardsSectionItemsCardImageImageType>;
  card_link?: Maybe<PrismicLinkType>;
  card_link_label?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyCardsSectionItemsCardImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicMarketingPageDataBodyCardsSectionItemsCardImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyCardsSectionItemsCardImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyCardsSectionItemsCardImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyCardsSectionItemsCardImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicMarketingPageDataBodyCardsSectionPrimary = {
  background?: Maybe<Scalars['String']>;
  card_text_position?: Maybe<Scalars['String']>;
  description?: Maybe<PrismicStructuredTextType>;
  headline?: Maybe<PrismicStructuredTextType>;
  headline_position?: Maybe<Scalars['String']>;
  number_of_columns?: Maybe<Scalars['String']>;
  primary_cta_label?: Maybe<Scalars['String']>;
  primary_cta_link?: Maybe<PrismicLinkType>;
  secondary_cta_label?: Maybe<Scalars['String']>;
  secondary_cta_link?: Maybe<PrismicLinkType>;
  vertical_margin?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyCtaBanner = PrismicSliceType & {
  primary: PrismicMarketingPageDataBodyCtaBannerPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyCtaBannerPrimary = {
  background?: Maybe<Scalars['String']>;
  heading?: Maybe<PrismicStructuredTextType>;
  primary_cta_icon?: Maybe<Scalars['String']>;
  primary_cta_label?: Maybe<Scalars['String']>;
  primary_cta_link?: Maybe<PrismicLinkType>;
  secondary_cta_icon?: Maybe<Scalars['String']>;
  secondary_cta_label?: Maybe<Scalars['String']>;
  secondary_cta_link?: Maybe<PrismicLinkType>;
  vertical_margin?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyCustomerLogos = PrismicSliceType & {
  items: Array<PrismicMarketingPageDataBodyCustomerLogosItem>;
  primary: PrismicMarketingPageDataBodyCustomerLogosPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyCustomerLogosItem = {
  link?: Maybe<PrismicLinkType>;
  logo?: Maybe<PrismicMarketingPageDataBodyCustomerLogosItemsLogoImageType>;
};

export type PrismicMarketingPageDataBodyCustomerLogosItemsLogoImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicMarketingPageDataBodyCustomerLogosItemsLogoImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyCustomerLogosItemsLogoImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyCustomerLogosItemsLogoImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyCustomerLogosItemsLogoImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicMarketingPageDataBodyCustomerLogosPrimary = {
  eyebrow_headline?: Maybe<PrismicStructuredTextType>;
};

export type PrismicMarketingPageDataBodyFaq = PrismicSliceType & {
  items: Array<PrismicMarketingPageDataBodyFaqItem>;
  primary: PrismicMarketingPageDataBodyFaqPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyFaqItem = {
  answer?: Maybe<PrismicStructuredTextType>;
  question?: Maybe<PrismicStructuredTextType>;
};

export type PrismicMarketingPageDataBodyFaqPrimary = {
  cta_label?: Maybe<Scalars['String']>;
  cta_link?: Maybe<PrismicLinkType>;
  heading?: Maybe<PrismicStructuredTextType>;
};

export type PrismicMarketingPageDataBodyFullWidthImage = PrismicSliceType & {
  items: Array<PrismicMarketingPageDataBodyFullWidthImageItem>;
  primary: PrismicMarketingPageDataBodyFullWidthImagePrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyFullWidthImageItem = {
  list_item?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyFullWidthImagePrimary = {
  background?: Maybe<Scalars['String']>;
  cta_label?: Maybe<Scalars['String']>;
  cta_link?: Maybe<PrismicLinkType>;
  gradient_image?: Maybe<PrismicMarketingPageDataBodyFullWidthImagePrimaryGradientImageImageType>;
  heading?: Maybe<PrismicStructuredTextType>;
  image?: Maybe<PrismicMarketingPageDataBodyFullWidthImagePrimaryImageImageType>;
  mobile_gradient_image?: Maybe<PrismicMarketingPageDataBodyFullWidthImagePrimaryMobileGradientImageImageType>;
  mobile_image?: Maybe<PrismicMarketingPageDataBodyFullWidthImagePrimaryMobileImageImageType>;
  subheading?: Maybe<PrismicStructuredTextType>;
  subheading_position?: Maybe<Scalars['String']>;
  vertical_margin?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyFullWidthImagePrimaryGradientImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicMarketingPageDataBodyFullWidthImagePrimaryGradientImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyFullWidthImagePrimaryGradientImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyFullWidthImagePrimaryGradientImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyFullWidthImagePrimaryGradientImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicMarketingPageDataBodyFullWidthImagePrimaryImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicMarketingPageDataBodyFullWidthImagePrimaryImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyFullWidthImagePrimaryImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyFullWidthImagePrimaryImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyFullWidthImagePrimaryImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicMarketingPageDataBodyFullWidthImagePrimaryMobileGradientImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicMarketingPageDataBodyFullWidthImagePrimaryMobileGradientImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyFullWidthImagePrimaryMobileGradientImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyFullWidthImagePrimaryMobileGradientImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyFullWidthImagePrimaryMobileGradientImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicMarketingPageDataBodyFullWidthImagePrimaryMobileImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicMarketingPageDataBodyFullWidthImagePrimaryMobileImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyFullWidthImagePrimaryMobileImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyFullWidthImagePrimaryMobileImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyFullWidthImagePrimaryMobileImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicMarketingPageDataBodyInfoWithImage = PrismicSliceType & {
  items: Array<PrismicMarketingPageDataBodyInfoWithImageItem>;
  primary: PrismicMarketingPageDataBodyInfoWithImagePrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyInfoWithImageItem = {
  list_item?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyInfoWithImagePrimary = {
  background?: Maybe<Scalars['String']>;
  featured_image?: Maybe<PrismicMarketingPageDataBodyInfoWithImagePrimaryFeaturedImageImageType>;
  heading?: Maybe<PrismicStructuredTextType>;
  primary_link?: Maybe<PrismicLinkType>;
  primary_link_text?: Maybe<PrismicStructuredTextType>;
  subheading?: Maybe<PrismicStructuredTextType>;
  vertical_margin?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyInfoWithImagePrimaryFeaturedImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicMarketingPageDataBodyInfoWithImagePrimaryFeaturedImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyInfoWithImagePrimaryFeaturedImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyInfoWithImagePrimaryFeaturedImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyInfoWithImagePrimaryFeaturedImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicMarketingPageDataBodyLargeTitle = PrismicSliceType & {
  primary: PrismicMarketingPageDataBodyLargeTitlePrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyLargeTitlePrimary = {
  title?: Maybe<PrismicStructuredTextType>;
};

export type PrismicMarketingPageDataBodyMarketingPageHero = PrismicSliceType & {
  primary: PrismicMarketingPageDataBodyMarketingPageHeroPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyMarketingPageHeroPrimary = {
  eyebrow?: Maybe<PrismicStructuredTextType>;
  heading?: Maybe<PrismicStructuredTextType>;
  image?: Maybe<PrismicMarketingPageDataBodyMarketingPageHeroPrimaryImageImageType>;
  subheading?: Maybe<PrismicStructuredTextType>;
};

export type PrismicMarketingPageDataBodyMarketingPageHeroPrimaryImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicMarketingPageDataBodyMarketingPageHeroPrimaryImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyMarketingPageHeroPrimaryImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyMarketingPageHeroPrimaryImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyMarketingPageHeroPrimaryImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicMarketingPageDataBodyPartner = PrismicSliceType & {
  items: Array<PrismicMarketingPageDataBodyPartnerItem>;
  primary: PrismicMarketingPageDataBodyPartnerPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyPartnerItem = {
  logos?: Maybe<PrismicMarketingPageDataBodyPartnerItemsLogosImageType>;
};

export type PrismicMarketingPageDataBodyPartnerItemsLogosImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicMarketingPageDataBodyPartnerItemsLogosImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyPartnerItemsLogosImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyPartnerItemsLogosImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyPartnerItemsLogosImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicMarketingPageDataBodyPartnerPrimary = {
  card_customer_text?: Maybe<PrismicStructuredTextType>;
  card_subtitle?: Maybe<PrismicStructuredTextType>;
  card_title?: Maybe<PrismicStructuredTextType>;
  expiration_datetime?: Maybe<Scalars['Date']>;
  fine_print?: Maybe<PrismicStructuredTextType>;
  main_text?: Maybe<PrismicStructuredTextType>;
  primary_button_link?: Maybe<PrismicLinkType>;
  primary_button_text?: Maybe<PrismicStructuredTextType>;
  secondary_button_link?: Maybe<PrismicLinkType>;
  secondary_button_text?: Maybe<PrismicStructuredTextType>;
  text_after_expiration?: Maybe<PrismicStructuredTextType>;
};


export type PrismicMarketingPageDataBodyPartnerPrimaryExpiration_DatetimeArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyPricingCard = PrismicSliceType & {
  items: Array<PrismicMarketingPageDataBodyPricingCardItem>;
  primary: PrismicMarketingPageDataBodyPricingCardPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyPricingCardItem = {
  card_recommended_for?: Maybe<PrismicStructuredTextType>;
};

export type PrismicMarketingPageDataBodyPricingCardPrimary = {
  background?: Maybe<Scalars['String']>;
  button_link?: Maybe<PrismicLinkType>;
  button_text?: Maybe<PrismicStructuredTextType>;
  card_button_link?: Maybe<PrismicLinkType>;
  card_button_text?: Maybe<PrismicStructuredTextType>;
  card_heading?: Maybe<PrismicStructuredTextType>;
  card_price_per_month?: Maybe<Scalars['Float']>;
  card_price_subtitle?: Maybe<PrismicStructuredTextType>;
  description?: Maybe<PrismicStructuredTextType>;
  gradient_image?: Maybe<PrismicMarketingPageDataBodyPricingCardPrimaryGradientImageImageType>;
  heading?: Maybe<PrismicStructuredTextType>;
  mobile_gradient_image?: Maybe<PrismicMarketingPageDataBodyPricingCardPrimaryMobileGradientImageImageType>;
  more_text?: Maybe<PrismicStructuredTextType>;
  vertical_margin?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyPricingCardPrimaryGradientImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicMarketingPageDataBodyPricingCardPrimaryGradientImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyPricingCardPrimaryGradientImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyPricingCardPrimaryGradientImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyPricingCardPrimaryGradientImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicMarketingPageDataBodyPricingCardPrimaryMobileGradientImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicMarketingPageDataBodyPricingCardPrimaryMobileGradientImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyPricingCardPrimaryMobileGradientImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyPricingCardPrimaryMobileGradientImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyPricingCardPrimaryMobileGradientImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicMarketingPageDataBodyPricingCards = PrismicSliceType & {
  items: Array<PrismicMarketingPageDataBodyPricingCardsItem>;
  primary: PrismicMarketingPageDataBodyPricingCardsPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyPricingCardsItem = {
  cta_label?: Maybe<Scalars['String']>;
  cta_link?: Maybe<PrismicLinkType>;
  description?: Maybe<PrismicStructuredTextType>;
  heading?: Maybe<PrismicStructuredTextType>;
  monthly_payment?: Maybe<Scalars['String']>;
  yearly_payment?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyPricingCardsPrimary = {
  vertical_margin?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyPricingGrid = PrismicSliceType & {
  items: Array<PrismicMarketingPageDataBodyPricingGridItem>;
  primary: PrismicMarketingPageDataBodyPricingGridPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyPricingGridItem = {
  body?: Maybe<PrismicStructuredTextType>;
  heading?: Maybe<PrismicStructuredTextType>;
  image?: Maybe<PrismicMarketingPageDataBodyPricingGridItemsImageImageType>;
};

export type PrismicMarketingPageDataBodyPricingGridItemsImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicMarketingPageDataBodyPricingGridItemsImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyPricingGridItemsImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyPricingGridItemsImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyPricingGridItemsImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicMarketingPageDataBodyPricingGridPrimary = {
  background?: Maybe<Scalars['String']>;
  headline?: Maybe<PrismicStructuredTextType>;
  vertical_margin?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodySlicesType = PrismicMarketingPageDataBodyCardsSection | PrismicMarketingPageDataBodyCtaBanner | PrismicMarketingPageDataBodyCustomerLogos | PrismicMarketingPageDataBodyFaq | PrismicMarketingPageDataBodyFullWidthImage | PrismicMarketingPageDataBodyInfoWithImage | PrismicMarketingPageDataBodyLargeTitle | PrismicMarketingPageDataBodyMarketingPageHero | PrismicMarketingPageDataBodyPartner | PrismicMarketingPageDataBodyPricingCard | PrismicMarketingPageDataBodyPricingCards | PrismicMarketingPageDataBodyPricingGrid | PrismicMarketingPageDataBodyStackedInfoWithImage | PrismicMarketingPageDataBodyTestimonialCarousel | PrismicMarketingPageDataBodyWistiaVideo | PrismicMarketingPageDataBodyWistiaVideoAndTextSideBySide;

export type PrismicMarketingPageDataBodyStackedInfoWithImage = PrismicSliceType & {
  items: Array<PrismicMarketingPageDataBodyStackedInfoWithImageItem>;
  primary: PrismicMarketingPageDataBodyStackedInfoWithImagePrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyStackedInfoWithImageItem = {
  featured_image?: Maybe<PrismicMarketingPageDataBodyStackedInfoWithImageItemsFeaturedImageImageType>;
  heading?: Maybe<PrismicStructuredTextType>;
  list_item_1?: Maybe<Scalars['String']>;
  list_item_2?: Maybe<Scalars['String']>;
  list_item_3?: Maybe<Scalars['String']>;
  subheading?: Maybe<PrismicStructuredTextType>;
};

export type PrismicMarketingPageDataBodyStackedInfoWithImageItemsFeaturedImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicMarketingPageDataBodyStackedInfoWithImageItemsFeaturedImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyStackedInfoWithImageItemsFeaturedImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyStackedInfoWithImageItemsFeaturedImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyStackedInfoWithImageItemsFeaturedImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicMarketingPageDataBodyStackedInfoWithImagePrimary = {
  background?: Maybe<Scalars['String']>;
  description?: Maybe<PrismicStructuredTextType>;
  heading?: Maybe<PrismicStructuredTextType>;
  vertical_margin?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyTestimonialCarousel = PrismicSliceType & {
  items: Array<PrismicMarketingPageDataBodyTestimonialCarouselItem>;
  primary: PrismicMarketingPageDataBodyTestimonialCarouselPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyTestimonialCarouselItem = {
  author_name?: Maybe<Scalars['String']>;
  author_title?: Maybe<Scalars['String']>;
  image?: Maybe<PrismicMarketingPageDataBodyTestimonialCarouselItemsImageImageType>;
  quote?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyTestimonialCarouselItemsImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicMarketingPageDataBodyTestimonialCarouselItemsImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyTestimonialCarouselItemsImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyTestimonialCarouselItemsImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyTestimonialCarouselItemsImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicMarketingPageDataBodyTestimonialCarouselPrimary = {
  background?: Maybe<Scalars['String']>;
  heading?: Maybe<PrismicStructuredTextType>;
};

export type PrismicMarketingPageDataBodyWistiaVideo = PrismicSliceType & {
  primary: PrismicMarketingPageDataBodyWistiaVideoPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyWistiaVideoAndTextSideBySide = PrismicSliceType & {
  items: Array<PrismicMarketingPageDataBodyWistiaVideoAndTextSideBySideItem>;
  primary: PrismicMarketingPageDataBodyWistiaVideoAndTextSideBySidePrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicMarketingPageDataBodyWistiaVideoAndTextSideBySideItem = {
  green_check_list_item?: Maybe<PrismicStructuredTextType>;
};

export type PrismicMarketingPageDataBodyWistiaVideoAndTextSideBySidePrimary = {
  background?: Maybe<Scalars['String']>;
  description?: Maybe<PrismicStructuredTextType>;
  gradient_image?: Maybe<PrismicMarketingPageDataBodyWistiaVideoAndTextSideBySidePrimaryGradientImageImageType>;
  is_video_on_right?: Maybe<Scalars['Boolean']>;
  mobile_gradient_image?: Maybe<PrismicMarketingPageDataBodyWistiaVideoAndTextSideBySidePrimaryMobileGradientImageImageType>;
  title?: Maybe<PrismicStructuredTextType>;
  vertical_margin?: Maybe<Scalars['String']>;
  wistia_video_url?: Maybe<PrismicLinkType>;
};

export type PrismicMarketingPageDataBodyWistiaVideoAndTextSideBySidePrimaryGradientImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicMarketingPageDataBodyWistiaVideoAndTextSideBySidePrimaryGradientImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyWistiaVideoAndTextSideBySidePrimaryGradientImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyWistiaVideoAndTextSideBySidePrimaryGradientImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyWistiaVideoAndTextSideBySidePrimaryGradientImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicMarketingPageDataBodyWistiaVideoAndTextSideBySidePrimaryMobileGradientImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicMarketingPageDataBodyWistiaVideoAndTextSideBySidePrimaryMobileGradientImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyWistiaVideoAndTextSideBySidePrimaryMobileGradientImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyWistiaVideoAndTextSideBySidePrimaryMobileGradientImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataBodyWistiaVideoAndTextSideBySidePrimaryMobileGradientImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicMarketingPageDataBodyWistiaVideoPrimary = {
  video_link?: Maybe<PrismicLinkType>;
};

export type PrismicMarketingPageDataPageImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicMarketingPageDataPageImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataPageImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataPageImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicMarketingPageDataPageImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicMarketingPageDataPageImageImageTypeFilterInput = {
  alt?: InputMaybe<StringQueryOperatorInput>;
  copyright?: InputMaybe<StringQueryOperatorInput>;
  dimensions?: InputMaybe<PrismicImageDimensionsTypeFilterInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  fixed?: InputMaybe<ImgixFixedFilterInput>;
  fluid?: InputMaybe<ImgixFluidFilterInput>;
  gatsbyImageData?: InputMaybe<JsonQueryOperatorInput>;
  localFile?: InputMaybe<FileFilterInput>;
};

export type PrismicMarketingPageDataType = {
  body: Array<PrismicMarketingPageDataBodySlicesType>;
  page_description?: Maybe<PrismicStructuredTextType>;
  page_image?: Maybe<PrismicMarketingPageDataPageImageImageType>;
  page_title?: Maybe<PrismicStructuredTextType>;
};

export type PrismicMarketingPageDataTypeFilterInput = {
  page_description?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  page_image?: InputMaybe<PrismicMarketingPageDataPageImageImageTypeFilterInput>;
  page_title?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
};

export type PrismicMarketingPageEdge = {
  next?: Maybe<PrismicMarketingPage>;
  node: PrismicMarketingPage;
  previous?: Maybe<PrismicMarketingPage>;
};

export enum PrismicMarketingPageFieldsEnum {
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  uid = 'uid',
  data___page_description___text = 'data___page_description___text',
  data___page_description___html = 'data___page_description___html',
  data___page_description___richText = 'data___page_description___richText',
  data___page_description___raw = 'data___page_description___raw',
  data___page_image___alt = 'data___page_image___alt',
  data___page_image___copyright = 'data___page_image___copyright',
  data___page_image___dimensions___width = 'data___page_image___dimensions___width',
  data___page_image___dimensions___height = 'data___page_image___dimensions___height',
  data___page_image___url = 'data___page_image___url',
  data___page_image___fixed___base64 = 'data___page_image___fixed___base64',
  data___page_image___fixed___src = 'data___page_image___fixed___src',
  data___page_image___fixed___srcSet = 'data___page_image___fixed___srcSet',
  data___page_image___fixed___srcWebp = 'data___page_image___fixed___srcWebp',
  data___page_image___fixed___srcSetWebp = 'data___page_image___fixed___srcSetWebp',
  data___page_image___fixed___sizes = 'data___page_image___fixed___sizes',
  data___page_image___fixed___width = 'data___page_image___fixed___width',
  data___page_image___fixed___height = 'data___page_image___fixed___height',
  data___page_image___fluid___base64 = 'data___page_image___fluid___base64',
  data___page_image___fluid___src = 'data___page_image___fluid___src',
  data___page_image___fluid___srcSet = 'data___page_image___fluid___srcSet',
  data___page_image___fluid___srcWebp = 'data___page_image___fluid___srcWebp',
  data___page_image___fluid___srcSetWebp = 'data___page_image___fluid___srcSetWebp',
  data___page_image___fluid___sizes = 'data___page_image___fluid___sizes',
  data___page_image___fluid___aspectRatio = 'data___page_image___fluid___aspectRatio',
  data___page_image___gatsbyImageData = 'data___page_image___gatsbyImageData',
  data___page_image___localFile___sourceInstanceName = 'data___page_image___localFile___sourceInstanceName',
  data___page_image___localFile___absolutePath = 'data___page_image___localFile___absolutePath',
  data___page_image___localFile___relativePath = 'data___page_image___localFile___relativePath',
  data___page_image___localFile___extension = 'data___page_image___localFile___extension',
  data___page_image___localFile___size = 'data___page_image___localFile___size',
  data___page_image___localFile___prettySize = 'data___page_image___localFile___prettySize',
  data___page_image___localFile___modifiedTime = 'data___page_image___localFile___modifiedTime',
  data___page_image___localFile___accessTime = 'data___page_image___localFile___accessTime',
  data___page_image___localFile___changeTime = 'data___page_image___localFile___changeTime',
  data___page_image___localFile___birthTime = 'data___page_image___localFile___birthTime',
  data___page_image___localFile___root = 'data___page_image___localFile___root',
  data___page_image___localFile___dir = 'data___page_image___localFile___dir',
  data___page_image___localFile___base = 'data___page_image___localFile___base',
  data___page_image___localFile___ext = 'data___page_image___localFile___ext',
  data___page_image___localFile___name = 'data___page_image___localFile___name',
  data___page_image___localFile___relativeDirectory = 'data___page_image___localFile___relativeDirectory',
  data___page_image___localFile___dev = 'data___page_image___localFile___dev',
  data___page_image___localFile___mode = 'data___page_image___localFile___mode',
  data___page_image___localFile___nlink = 'data___page_image___localFile___nlink',
  data___page_image___localFile___uid = 'data___page_image___localFile___uid',
  data___page_image___localFile___gid = 'data___page_image___localFile___gid',
  data___page_image___localFile___rdev = 'data___page_image___localFile___rdev',
  data___page_image___localFile___ino = 'data___page_image___localFile___ino',
  data___page_image___localFile___atimeMs = 'data___page_image___localFile___atimeMs',
  data___page_image___localFile___mtimeMs = 'data___page_image___localFile___mtimeMs',
  data___page_image___localFile___ctimeMs = 'data___page_image___localFile___ctimeMs',
  data___page_image___localFile___atime = 'data___page_image___localFile___atime',
  data___page_image___localFile___mtime = 'data___page_image___localFile___mtime',
  data___page_image___localFile___ctime = 'data___page_image___localFile___ctime',
  data___page_image___localFile___birthtime = 'data___page_image___localFile___birthtime',
  data___page_image___localFile___birthtimeMs = 'data___page_image___localFile___birthtimeMs',
  data___page_image___localFile___blksize = 'data___page_image___localFile___blksize',
  data___page_image___localFile___blocks = 'data___page_image___localFile___blocks',
  data___page_image___localFile___publicURL = 'data___page_image___localFile___publicURL',
  data___page_image___localFile___childrenImageSharp = 'data___page_image___localFile___childrenImageSharp',
  data___page_image___localFile___id = 'data___page_image___localFile___id',
  data___page_image___localFile___children = 'data___page_image___localFile___children',
  data___page_title___text = 'data___page_title___text',
  data___page_title___html = 'data___page_title___html',
  data___page_title___richText = 'data___page_title___richText',
  data___page_title___raw = 'data___page_title___raw',
  dataRaw = 'dataRaw',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicMarketingPageFilterInput = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  uid?: InputMaybe<StringQueryOperatorInput>;
  data?: InputMaybe<PrismicMarketingPageDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicMarketingPageGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicMarketingPageEdge>;
  nodes: Array<PrismicMarketingPage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicMarketingPageGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicMarketingPageGroupConnectionDistinctArgs = {
  field: PrismicMarketingPageFieldsEnum;
};


export type PrismicMarketingPageGroupConnectionMaxArgs = {
  field: PrismicMarketingPageFieldsEnum;
};


export type PrismicMarketingPageGroupConnectionMinArgs = {
  field: PrismicMarketingPageFieldsEnum;
};


export type PrismicMarketingPageGroupConnectionSumArgs = {
  field: PrismicMarketingPageFieldsEnum;
};


export type PrismicMarketingPageGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicMarketingPageFieldsEnum;
};

export type PrismicMarketingPageSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicMarketingPageFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicNav = Node & {
  data: PrismicNavDataType;
  dataRaw: Scalars['JSON'];
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicNavFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicNavLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicNavConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicNavEdge>;
  nodes: Array<PrismicNav>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicNavGroupConnection>;
};


export type PrismicNavConnectionDistinctArgs = {
  field: PrismicNavFieldsEnum;
};


export type PrismicNavConnectionMaxArgs = {
  field: PrismicNavFieldsEnum;
};


export type PrismicNavConnectionMinArgs = {
  field: PrismicNavFieldsEnum;
};


export type PrismicNavConnectionSumArgs = {
  field: PrismicNavFieldsEnum;
};


export type PrismicNavConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicNavFieldsEnum;
};

export type PrismicNavDataLinksNavItem = PrismicSliceType & {
  items: Array<PrismicNavDataLinksNavItemItem>;
  primary: PrismicNavDataLinksNavItemPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicNavDataLinksNavItemItem = {
  sub_nav_description?: Maybe<Scalars['String']>;
  sub_nav_link?: Maybe<PrismicLinkType>;
  sub_nav_link_icon?: Maybe<Scalars['String']>;
  sub_nav_link_label?: Maybe<PrismicStructuredTextType>;
};

export type PrismicNavDataLinksNavItemPrimary = {
  label?: Maybe<PrismicStructuredTextType>;
  link?: Maybe<PrismicLinkType>;
  sub_nav_cta_link?: Maybe<PrismicLinkType>;
  sub_nav_cta_link_label?: Maybe<PrismicStructuredTextType>;
};

export type PrismicNavDataLinksSlicesType = PrismicNavDataLinksNavItem;

export type PrismicNavDataType = {
  doc_name?: Maybe<PrismicStructuredTextType>;
  is_in_beta?: Maybe<Scalars['Boolean']>;
  links: Array<PrismicNavDataLinksSlicesType>;
  primary_cta_label?: Maybe<Scalars['String']>;
  primary_cta_link?: Maybe<PrismicLinkType>;
  secondary_cta_label?: Maybe<Scalars['String']>;
  secondary_cta_link?: Maybe<PrismicLinkType>;
};

export type PrismicNavDataTypeFilterInput = {
  doc_name?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  is_in_beta?: InputMaybe<BooleanQueryOperatorInput>;
  primary_cta_label?: InputMaybe<StringQueryOperatorInput>;
  primary_cta_link?: InputMaybe<PrismicLinkTypeFilterInput>;
  secondary_cta_label?: InputMaybe<StringQueryOperatorInput>;
  secondary_cta_link?: InputMaybe<PrismicLinkTypeFilterInput>;
};

export type PrismicNavEdge = {
  next?: Maybe<PrismicNav>;
  node: PrismicNav;
  previous?: Maybe<PrismicNav>;
};

export enum PrismicNavFieldsEnum {
  data___doc_name___text = 'data___doc_name___text',
  data___doc_name___html = 'data___doc_name___html',
  data___doc_name___richText = 'data___doc_name___richText',
  data___doc_name___raw = 'data___doc_name___raw',
  data___is_in_beta = 'data___is_in_beta',
  data___primary_cta_label = 'data___primary_cta_label',
  data___primary_cta_link___link_type = 'data___primary_cta_link___link_type',
  data___primary_cta_link___isBroken = 'data___primary_cta_link___isBroken',
  data___primary_cta_link___url = 'data___primary_cta_link___url',
  data___primary_cta_link___target = 'data___primary_cta_link___target',
  data___primary_cta_link___size = 'data___primary_cta_link___size',
  data___primary_cta_link___id = 'data___primary_cta_link___id',
  data___primary_cta_link___type = 'data___primary_cta_link___type',
  data___primary_cta_link___tags = 'data___primary_cta_link___tags',
  data___primary_cta_link___lang = 'data___primary_cta_link___lang',
  data___primary_cta_link___slug = 'data___primary_cta_link___slug',
  data___primary_cta_link___uid = 'data___primary_cta_link___uid',
  data___primary_cta_link___localFile___sourceInstanceName = 'data___primary_cta_link___localFile___sourceInstanceName',
  data___primary_cta_link___localFile___absolutePath = 'data___primary_cta_link___localFile___absolutePath',
  data___primary_cta_link___localFile___relativePath = 'data___primary_cta_link___localFile___relativePath',
  data___primary_cta_link___localFile___extension = 'data___primary_cta_link___localFile___extension',
  data___primary_cta_link___localFile___size = 'data___primary_cta_link___localFile___size',
  data___primary_cta_link___localFile___prettySize = 'data___primary_cta_link___localFile___prettySize',
  data___primary_cta_link___localFile___modifiedTime = 'data___primary_cta_link___localFile___modifiedTime',
  data___primary_cta_link___localFile___accessTime = 'data___primary_cta_link___localFile___accessTime',
  data___primary_cta_link___localFile___changeTime = 'data___primary_cta_link___localFile___changeTime',
  data___primary_cta_link___localFile___birthTime = 'data___primary_cta_link___localFile___birthTime',
  data___primary_cta_link___localFile___root = 'data___primary_cta_link___localFile___root',
  data___primary_cta_link___localFile___dir = 'data___primary_cta_link___localFile___dir',
  data___primary_cta_link___localFile___base = 'data___primary_cta_link___localFile___base',
  data___primary_cta_link___localFile___ext = 'data___primary_cta_link___localFile___ext',
  data___primary_cta_link___localFile___name = 'data___primary_cta_link___localFile___name',
  data___primary_cta_link___localFile___relativeDirectory = 'data___primary_cta_link___localFile___relativeDirectory',
  data___primary_cta_link___localFile___dev = 'data___primary_cta_link___localFile___dev',
  data___primary_cta_link___localFile___mode = 'data___primary_cta_link___localFile___mode',
  data___primary_cta_link___localFile___nlink = 'data___primary_cta_link___localFile___nlink',
  data___primary_cta_link___localFile___uid = 'data___primary_cta_link___localFile___uid',
  data___primary_cta_link___localFile___gid = 'data___primary_cta_link___localFile___gid',
  data___primary_cta_link___localFile___rdev = 'data___primary_cta_link___localFile___rdev',
  data___primary_cta_link___localFile___ino = 'data___primary_cta_link___localFile___ino',
  data___primary_cta_link___localFile___atimeMs = 'data___primary_cta_link___localFile___atimeMs',
  data___primary_cta_link___localFile___mtimeMs = 'data___primary_cta_link___localFile___mtimeMs',
  data___primary_cta_link___localFile___ctimeMs = 'data___primary_cta_link___localFile___ctimeMs',
  data___primary_cta_link___localFile___atime = 'data___primary_cta_link___localFile___atime',
  data___primary_cta_link___localFile___mtime = 'data___primary_cta_link___localFile___mtime',
  data___primary_cta_link___localFile___ctime = 'data___primary_cta_link___localFile___ctime',
  data___primary_cta_link___localFile___birthtime = 'data___primary_cta_link___localFile___birthtime',
  data___primary_cta_link___localFile___birthtimeMs = 'data___primary_cta_link___localFile___birthtimeMs',
  data___primary_cta_link___localFile___blksize = 'data___primary_cta_link___localFile___blksize',
  data___primary_cta_link___localFile___blocks = 'data___primary_cta_link___localFile___blocks',
  data___primary_cta_link___localFile___publicURL = 'data___primary_cta_link___localFile___publicURL',
  data___primary_cta_link___localFile___childrenImageSharp = 'data___primary_cta_link___localFile___childrenImageSharp',
  data___primary_cta_link___localFile___id = 'data___primary_cta_link___localFile___id',
  data___primary_cta_link___localFile___children = 'data___primary_cta_link___localFile___children',
  data___primary_cta_link___raw = 'data___primary_cta_link___raw',
  data___secondary_cta_label = 'data___secondary_cta_label',
  data___secondary_cta_link___link_type = 'data___secondary_cta_link___link_type',
  data___secondary_cta_link___isBroken = 'data___secondary_cta_link___isBroken',
  data___secondary_cta_link___url = 'data___secondary_cta_link___url',
  data___secondary_cta_link___target = 'data___secondary_cta_link___target',
  data___secondary_cta_link___size = 'data___secondary_cta_link___size',
  data___secondary_cta_link___id = 'data___secondary_cta_link___id',
  data___secondary_cta_link___type = 'data___secondary_cta_link___type',
  data___secondary_cta_link___tags = 'data___secondary_cta_link___tags',
  data___secondary_cta_link___lang = 'data___secondary_cta_link___lang',
  data___secondary_cta_link___slug = 'data___secondary_cta_link___slug',
  data___secondary_cta_link___uid = 'data___secondary_cta_link___uid',
  data___secondary_cta_link___localFile___sourceInstanceName = 'data___secondary_cta_link___localFile___sourceInstanceName',
  data___secondary_cta_link___localFile___absolutePath = 'data___secondary_cta_link___localFile___absolutePath',
  data___secondary_cta_link___localFile___relativePath = 'data___secondary_cta_link___localFile___relativePath',
  data___secondary_cta_link___localFile___extension = 'data___secondary_cta_link___localFile___extension',
  data___secondary_cta_link___localFile___size = 'data___secondary_cta_link___localFile___size',
  data___secondary_cta_link___localFile___prettySize = 'data___secondary_cta_link___localFile___prettySize',
  data___secondary_cta_link___localFile___modifiedTime = 'data___secondary_cta_link___localFile___modifiedTime',
  data___secondary_cta_link___localFile___accessTime = 'data___secondary_cta_link___localFile___accessTime',
  data___secondary_cta_link___localFile___changeTime = 'data___secondary_cta_link___localFile___changeTime',
  data___secondary_cta_link___localFile___birthTime = 'data___secondary_cta_link___localFile___birthTime',
  data___secondary_cta_link___localFile___root = 'data___secondary_cta_link___localFile___root',
  data___secondary_cta_link___localFile___dir = 'data___secondary_cta_link___localFile___dir',
  data___secondary_cta_link___localFile___base = 'data___secondary_cta_link___localFile___base',
  data___secondary_cta_link___localFile___ext = 'data___secondary_cta_link___localFile___ext',
  data___secondary_cta_link___localFile___name = 'data___secondary_cta_link___localFile___name',
  data___secondary_cta_link___localFile___relativeDirectory = 'data___secondary_cta_link___localFile___relativeDirectory',
  data___secondary_cta_link___localFile___dev = 'data___secondary_cta_link___localFile___dev',
  data___secondary_cta_link___localFile___mode = 'data___secondary_cta_link___localFile___mode',
  data___secondary_cta_link___localFile___nlink = 'data___secondary_cta_link___localFile___nlink',
  data___secondary_cta_link___localFile___uid = 'data___secondary_cta_link___localFile___uid',
  data___secondary_cta_link___localFile___gid = 'data___secondary_cta_link___localFile___gid',
  data___secondary_cta_link___localFile___rdev = 'data___secondary_cta_link___localFile___rdev',
  data___secondary_cta_link___localFile___ino = 'data___secondary_cta_link___localFile___ino',
  data___secondary_cta_link___localFile___atimeMs = 'data___secondary_cta_link___localFile___atimeMs',
  data___secondary_cta_link___localFile___mtimeMs = 'data___secondary_cta_link___localFile___mtimeMs',
  data___secondary_cta_link___localFile___ctimeMs = 'data___secondary_cta_link___localFile___ctimeMs',
  data___secondary_cta_link___localFile___atime = 'data___secondary_cta_link___localFile___atime',
  data___secondary_cta_link___localFile___mtime = 'data___secondary_cta_link___localFile___mtime',
  data___secondary_cta_link___localFile___ctime = 'data___secondary_cta_link___localFile___ctime',
  data___secondary_cta_link___localFile___birthtime = 'data___secondary_cta_link___localFile___birthtime',
  data___secondary_cta_link___localFile___birthtimeMs = 'data___secondary_cta_link___localFile___birthtimeMs',
  data___secondary_cta_link___localFile___blksize = 'data___secondary_cta_link___localFile___blksize',
  data___secondary_cta_link___localFile___blocks = 'data___secondary_cta_link___localFile___blocks',
  data___secondary_cta_link___localFile___publicURL = 'data___secondary_cta_link___localFile___publicURL',
  data___secondary_cta_link___localFile___childrenImageSharp = 'data___secondary_cta_link___localFile___childrenImageSharp',
  data___secondary_cta_link___localFile___id = 'data___secondary_cta_link___localFile___id',
  data___secondary_cta_link___localFile___children = 'data___secondary_cta_link___localFile___children',
  data___secondary_cta_link___raw = 'data___secondary_cta_link___raw',
  dataRaw = 'dataRaw',
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicNavFilterInput = {
  data?: InputMaybe<PrismicNavDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicNavGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicNavEdge>;
  nodes: Array<PrismicNav>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicNavGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicNavGroupConnectionDistinctArgs = {
  field: PrismicNavFieldsEnum;
};


export type PrismicNavGroupConnectionMaxArgs = {
  field: PrismicNavFieldsEnum;
};


export type PrismicNavGroupConnectionMinArgs = {
  field: PrismicNavFieldsEnum;
};


export type PrismicNavGroupConnectionSumArgs = {
  field: PrismicNavFieldsEnum;
};


export type PrismicNavGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicNavFieldsEnum;
};

export type PrismicNavSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicNavFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicPartnerPage = Node & {
  uid: Scalars['String'];
  data: PrismicPartnerPageDataType;
  dataRaw: Scalars['JSON'];
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicPartnerPageFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicPartnerPageLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicPartnerPageConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicPartnerPageEdge>;
  nodes: Array<PrismicPartnerPage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicPartnerPageGroupConnection>;
};


export type PrismicPartnerPageConnectionDistinctArgs = {
  field: PrismicPartnerPageFieldsEnum;
};


export type PrismicPartnerPageConnectionMaxArgs = {
  field: PrismicPartnerPageFieldsEnum;
};


export type PrismicPartnerPageConnectionMinArgs = {
  field: PrismicPartnerPageFieldsEnum;
};


export type PrismicPartnerPageConnectionSumArgs = {
  field: PrismicPartnerPageFieldsEnum;
};


export type PrismicPartnerPageConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicPartnerPageFieldsEnum;
};

export type PrismicPartnerPageDataBodyCardsSection = PrismicSliceType & {
  items: Array<PrismicPartnerPageDataBodyCardsSectionItem>;
  primary: PrismicPartnerPageDataBodyCardsSectionPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicPartnerPageDataBodyCardsSectionItem = {
  card_body?: Maybe<Scalars['String']>;
  card_heading?: Maybe<Scalars['String']>;
  card_image?: Maybe<PrismicPartnerPageDataBodyCardsSectionItemsCardImageImageType>;
  card_link?: Maybe<PrismicLinkType>;
  card_link_label?: Maybe<Scalars['String']>;
};

export type PrismicPartnerPageDataBodyCardsSectionItemsCardImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicPartnerPageDataBodyCardsSectionItemsCardImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataBodyCardsSectionItemsCardImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataBodyCardsSectionItemsCardImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataBodyCardsSectionItemsCardImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicPartnerPageDataBodyCardsSectionPrimary = {
  background?: Maybe<Scalars['String']>;
  card_text_position?: Maybe<Scalars['String']>;
  description?: Maybe<PrismicStructuredTextType>;
  headline?: Maybe<PrismicStructuredTextType>;
  headline_position?: Maybe<Scalars['String']>;
  number_of_columns?: Maybe<Scalars['String']>;
  primary_cta_label?: Maybe<Scalars['String']>;
  primary_cta_link?: Maybe<PrismicLinkType>;
  secondary_cta_label?: Maybe<Scalars['String']>;
  secondary_cta_link?: Maybe<PrismicLinkType>;
  vertical_margin?: Maybe<Scalars['String']>;
};

export type PrismicPartnerPageDataBodyCustomerLogos = PrismicSliceType & {
  items: Array<PrismicPartnerPageDataBodyCustomerLogosItem>;
  primary: PrismicPartnerPageDataBodyCustomerLogosPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicPartnerPageDataBodyCustomerLogosItem = {
  link?: Maybe<PrismicLinkType>;
  logo?: Maybe<PrismicPartnerPageDataBodyCustomerLogosItemsLogoImageType>;
};

export type PrismicPartnerPageDataBodyCustomerLogosItemsLogoImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicPartnerPageDataBodyCustomerLogosItemsLogoImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataBodyCustomerLogosItemsLogoImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataBodyCustomerLogosItemsLogoImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataBodyCustomerLogosItemsLogoImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicPartnerPageDataBodyCustomerLogosPrimary = {
  eyebrow_headline?: Maybe<PrismicStructuredTextType>;
};

export type PrismicPartnerPageDataBodyPartner = PrismicSliceType & {
  items: Array<PrismicPartnerPageDataBodyPartnerItem>;
  primary: PrismicPartnerPageDataBodyPartnerPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicPartnerPageDataBodyPartnerItem = {
  logos?: Maybe<PrismicPartnerPageDataBodyPartnerItemsLogosImageType>;
};

export type PrismicPartnerPageDataBodyPartnerItemsLogosImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicPartnerPageDataBodyPartnerItemsLogosImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataBodyPartnerItemsLogosImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataBodyPartnerItemsLogosImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataBodyPartnerItemsLogosImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicPartnerPageDataBodyPartnerPrimary = {
  card_customer_text?: Maybe<PrismicStructuredTextType>;
  card_subtitle?: Maybe<PrismicStructuredTextType>;
  card_title?: Maybe<PrismicStructuredTextType>;
  expiration_datetime?: Maybe<Scalars['Date']>;
  fine_print?: Maybe<PrismicStructuredTextType>;
  main_text?: Maybe<PrismicStructuredTextType>;
  primary_button_link?: Maybe<PrismicLinkType>;
  primary_button_text?: Maybe<PrismicStructuredTextType>;
  secondary_button_link?: Maybe<PrismicLinkType>;
  secondary_button_text?: Maybe<PrismicStructuredTextType>;
  text_after_expiration?: Maybe<PrismicStructuredTextType>;
};


export type PrismicPartnerPageDataBodyPartnerPrimaryExpiration_DatetimeArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicPartnerPageDataBodySlicesType = PrismicPartnerPageDataBodyCardsSection | PrismicPartnerPageDataBodyCustomerLogos | PrismicPartnerPageDataBodyPartner | PrismicPartnerPageDataBodyTestimonialCarousel | PrismicPartnerPageDataBodyWistiaVideoAndTextSideBySide;

export type PrismicPartnerPageDataBodyTestimonialCarousel = PrismicSliceType & {
  items: Array<PrismicPartnerPageDataBodyTestimonialCarouselItem>;
  primary: PrismicPartnerPageDataBodyTestimonialCarouselPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicPartnerPageDataBodyTestimonialCarouselItem = {
  author_name?: Maybe<Scalars['String']>;
  author_title?: Maybe<Scalars['String']>;
  image?: Maybe<PrismicPartnerPageDataBodyTestimonialCarouselItemsImageImageType>;
  quote?: Maybe<Scalars['String']>;
};

export type PrismicPartnerPageDataBodyTestimonialCarouselItemsImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicPartnerPageDataBodyTestimonialCarouselItemsImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataBodyTestimonialCarouselItemsImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataBodyTestimonialCarouselItemsImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataBodyTestimonialCarouselItemsImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicPartnerPageDataBodyTestimonialCarouselPrimary = {
  background?: Maybe<Scalars['String']>;
  heading?: Maybe<PrismicStructuredTextType>;
};

export type PrismicPartnerPageDataBodyWistiaVideoAndTextSideBySide = PrismicSliceType & {
  items: Array<PrismicPartnerPageDataBodyWistiaVideoAndTextSideBySideItem>;
  primary: PrismicPartnerPageDataBodyWistiaVideoAndTextSideBySidePrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicPartnerPageDataBodyWistiaVideoAndTextSideBySideItem = {
  green_check_list_item?: Maybe<PrismicStructuredTextType>;
};

export type PrismicPartnerPageDataBodyWistiaVideoAndTextSideBySidePrimary = {
  background?: Maybe<Scalars['String']>;
  description?: Maybe<PrismicStructuredTextType>;
  gradient_image?: Maybe<PrismicPartnerPageDataBodyWistiaVideoAndTextSideBySidePrimaryGradientImageImageType>;
  is_video_on_right?: Maybe<Scalars['Boolean']>;
  mobile_gradient_image?: Maybe<PrismicPartnerPageDataBodyWistiaVideoAndTextSideBySidePrimaryMobileGradientImageImageType>;
  title?: Maybe<PrismicStructuredTextType>;
  vertical_margin?: Maybe<Scalars['String']>;
  wistia_video_url?: Maybe<PrismicLinkType>;
};

export type PrismicPartnerPageDataBodyWistiaVideoAndTextSideBySidePrimaryGradientImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicPartnerPageDataBodyWistiaVideoAndTextSideBySidePrimaryGradientImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataBodyWistiaVideoAndTextSideBySidePrimaryGradientImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataBodyWistiaVideoAndTextSideBySidePrimaryGradientImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataBodyWistiaVideoAndTextSideBySidePrimaryGradientImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicPartnerPageDataBodyWistiaVideoAndTextSideBySidePrimaryMobileGradientImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicPartnerPageDataBodyWistiaVideoAndTextSideBySidePrimaryMobileGradientImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataBodyWistiaVideoAndTextSideBySidePrimaryMobileGradientImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataBodyWistiaVideoAndTextSideBySidePrimaryMobileGradientImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataBodyWistiaVideoAndTextSideBySidePrimaryMobileGradientImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicPartnerPageDataPageImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicPartnerPageDataPageImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataPageImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataPageImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPartnerPageDataPageImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicPartnerPageDataPageImageImageTypeFilterInput = {
  alt?: InputMaybe<StringQueryOperatorInput>;
  copyright?: InputMaybe<StringQueryOperatorInput>;
  dimensions?: InputMaybe<PrismicImageDimensionsTypeFilterInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  fixed?: InputMaybe<ImgixFixedFilterInput>;
  fluid?: InputMaybe<ImgixFluidFilterInput>;
  gatsbyImageData?: InputMaybe<JsonQueryOperatorInput>;
  localFile?: InputMaybe<FileFilterInput>;
};

export type PrismicPartnerPageDataType = {
  body: Array<PrismicPartnerPageDataBodySlicesType>;
  page_description?: Maybe<PrismicStructuredTextType>;
  page_image?: Maybe<PrismicPartnerPageDataPageImageImageType>;
  page_title?: Maybe<PrismicStructuredTextType>;
};

export type PrismicPartnerPageDataTypeFilterInput = {
  page_description?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  page_image?: InputMaybe<PrismicPartnerPageDataPageImageImageTypeFilterInput>;
  page_title?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
};

export type PrismicPartnerPageEdge = {
  next?: Maybe<PrismicPartnerPage>;
  node: PrismicPartnerPage;
  previous?: Maybe<PrismicPartnerPage>;
};

export enum PrismicPartnerPageFieldsEnum {
  uid = 'uid',
  data___page_description___text = 'data___page_description___text',
  data___page_description___html = 'data___page_description___html',
  data___page_description___richText = 'data___page_description___richText',
  data___page_description___raw = 'data___page_description___raw',
  data___page_image___alt = 'data___page_image___alt',
  data___page_image___copyright = 'data___page_image___copyright',
  data___page_image___dimensions___width = 'data___page_image___dimensions___width',
  data___page_image___dimensions___height = 'data___page_image___dimensions___height',
  data___page_image___url = 'data___page_image___url',
  data___page_image___fixed___base64 = 'data___page_image___fixed___base64',
  data___page_image___fixed___src = 'data___page_image___fixed___src',
  data___page_image___fixed___srcSet = 'data___page_image___fixed___srcSet',
  data___page_image___fixed___srcWebp = 'data___page_image___fixed___srcWebp',
  data___page_image___fixed___srcSetWebp = 'data___page_image___fixed___srcSetWebp',
  data___page_image___fixed___sizes = 'data___page_image___fixed___sizes',
  data___page_image___fixed___width = 'data___page_image___fixed___width',
  data___page_image___fixed___height = 'data___page_image___fixed___height',
  data___page_image___fluid___base64 = 'data___page_image___fluid___base64',
  data___page_image___fluid___src = 'data___page_image___fluid___src',
  data___page_image___fluid___srcSet = 'data___page_image___fluid___srcSet',
  data___page_image___fluid___srcWebp = 'data___page_image___fluid___srcWebp',
  data___page_image___fluid___srcSetWebp = 'data___page_image___fluid___srcSetWebp',
  data___page_image___fluid___sizes = 'data___page_image___fluid___sizes',
  data___page_image___fluid___aspectRatio = 'data___page_image___fluid___aspectRatio',
  data___page_image___gatsbyImageData = 'data___page_image___gatsbyImageData',
  data___page_image___localFile___sourceInstanceName = 'data___page_image___localFile___sourceInstanceName',
  data___page_image___localFile___absolutePath = 'data___page_image___localFile___absolutePath',
  data___page_image___localFile___relativePath = 'data___page_image___localFile___relativePath',
  data___page_image___localFile___extension = 'data___page_image___localFile___extension',
  data___page_image___localFile___size = 'data___page_image___localFile___size',
  data___page_image___localFile___prettySize = 'data___page_image___localFile___prettySize',
  data___page_image___localFile___modifiedTime = 'data___page_image___localFile___modifiedTime',
  data___page_image___localFile___accessTime = 'data___page_image___localFile___accessTime',
  data___page_image___localFile___changeTime = 'data___page_image___localFile___changeTime',
  data___page_image___localFile___birthTime = 'data___page_image___localFile___birthTime',
  data___page_image___localFile___root = 'data___page_image___localFile___root',
  data___page_image___localFile___dir = 'data___page_image___localFile___dir',
  data___page_image___localFile___base = 'data___page_image___localFile___base',
  data___page_image___localFile___ext = 'data___page_image___localFile___ext',
  data___page_image___localFile___name = 'data___page_image___localFile___name',
  data___page_image___localFile___relativeDirectory = 'data___page_image___localFile___relativeDirectory',
  data___page_image___localFile___dev = 'data___page_image___localFile___dev',
  data___page_image___localFile___mode = 'data___page_image___localFile___mode',
  data___page_image___localFile___nlink = 'data___page_image___localFile___nlink',
  data___page_image___localFile___uid = 'data___page_image___localFile___uid',
  data___page_image___localFile___gid = 'data___page_image___localFile___gid',
  data___page_image___localFile___rdev = 'data___page_image___localFile___rdev',
  data___page_image___localFile___ino = 'data___page_image___localFile___ino',
  data___page_image___localFile___atimeMs = 'data___page_image___localFile___atimeMs',
  data___page_image___localFile___mtimeMs = 'data___page_image___localFile___mtimeMs',
  data___page_image___localFile___ctimeMs = 'data___page_image___localFile___ctimeMs',
  data___page_image___localFile___atime = 'data___page_image___localFile___atime',
  data___page_image___localFile___mtime = 'data___page_image___localFile___mtime',
  data___page_image___localFile___ctime = 'data___page_image___localFile___ctime',
  data___page_image___localFile___birthtime = 'data___page_image___localFile___birthtime',
  data___page_image___localFile___birthtimeMs = 'data___page_image___localFile___birthtimeMs',
  data___page_image___localFile___blksize = 'data___page_image___localFile___blksize',
  data___page_image___localFile___blocks = 'data___page_image___localFile___blocks',
  data___page_image___localFile___publicURL = 'data___page_image___localFile___publicURL',
  data___page_image___localFile___childrenImageSharp = 'data___page_image___localFile___childrenImageSharp',
  data___page_image___localFile___id = 'data___page_image___localFile___id',
  data___page_image___localFile___children = 'data___page_image___localFile___children',
  data___page_title___text = 'data___page_title___text',
  data___page_title___html = 'data___page_title___html',
  data___page_title___richText = 'data___page_title___richText',
  data___page_title___raw = 'data___page_title___raw',
  dataRaw = 'dataRaw',
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicPartnerPageFilterInput = {
  uid?: InputMaybe<StringQueryOperatorInput>;
  data?: InputMaybe<PrismicPartnerPageDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicPartnerPageGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicPartnerPageEdge>;
  nodes: Array<PrismicPartnerPage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicPartnerPageGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicPartnerPageGroupConnectionDistinctArgs = {
  field: PrismicPartnerPageFieldsEnum;
};


export type PrismicPartnerPageGroupConnectionMaxArgs = {
  field: PrismicPartnerPageFieldsEnum;
};


export type PrismicPartnerPageGroupConnectionMinArgs = {
  field: PrismicPartnerPageFieldsEnum;
};


export type PrismicPartnerPageGroupConnectionSumArgs = {
  field: PrismicPartnerPageFieldsEnum;
};


export type PrismicPartnerPageGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicPartnerPageFieldsEnum;
};

export type PrismicPartnerPageSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicPartnerPageFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicPricing = Node & {
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicPricingFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicPricingLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicPricingConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicPricingEdge>;
  nodes: Array<PrismicPricing>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicPricingGroupConnection>;
};


export type PrismicPricingConnectionDistinctArgs = {
  field: PrismicPricingFieldsEnum;
};


export type PrismicPricingConnectionMaxArgs = {
  field: PrismicPricingFieldsEnum;
};


export type PrismicPricingConnectionMinArgs = {
  field: PrismicPricingFieldsEnum;
};


export type PrismicPricingConnectionSumArgs = {
  field: PrismicPricingFieldsEnum;
};


export type PrismicPricingConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicPricingFieldsEnum;
};

export type PrismicPricingEdge = {
  next?: Maybe<PrismicPricing>;
  node: PrismicPricing;
  previous?: Maybe<PrismicPricing>;
};

export enum PrismicPricingFieldsEnum {
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicPricingFilterInput = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicPricingGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicPricingEdge>;
  nodes: Array<PrismicPricing>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicPricingGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicPricingGroupConnectionDistinctArgs = {
  field: PrismicPricingFieldsEnum;
};


export type PrismicPricingGroupConnectionMaxArgs = {
  field: PrismicPricingFieldsEnum;
};


export type PrismicPricingGroupConnectionMinArgs = {
  field: PrismicPricingFieldsEnum;
};


export type PrismicPricingGroupConnectionSumArgs = {
  field: PrismicPricingFieldsEnum;
};


export type PrismicPricingGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicPricingFieldsEnum;
};

export type PrismicPricingPage = Node & {
  uid: Scalars['String'];
  data: PrismicPricingPageDataType;
  dataRaw: Scalars['JSON'];
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicPricingPageFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicPricingPageLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicPricingPageConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicPricingPageEdge>;
  nodes: Array<PrismicPricingPage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicPricingPageGroupConnection>;
};


export type PrismicPricingPageConnectionDistinctArgs = {
  field: PrismicPricingPageFieldsEnum;
};


export type PrismicPricingPageConnectionMaxArgs = {
  field: PrismicPricingPageFieldsEnum;
};


export type PrismicPricingPageConnectionMinArgs = {
  field: PrismicPricingPageFieldsEnum;
};


export type PrismicPricingPageConnectionSumArgs = {
  field: PrismicPricingPageFieldsEnum;
};


export type PrismicPricingPageConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicPricingPageFieldsEnum;
};

export type PrismicPricingPageDataBodyCtaBanner = PrismicSliceType & {
  primary: PrismicPricingPageDataBodyCtaBannerPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicPricingPageDataBodyCtaBannerPrimary = {
  background?: Maybe<Scalars['String']>;
  heading?: Maybe<PrismicStructuredTextType>;
  primary_cta_icon?: Maybe<Scalars['String']>;
  primary_cta_label?: Maybe<Scalars['String']>;
  primary_cta_link?: Maybe<PrismicLinkType>;
  secondary_cta_icon?: Maybe<Scalars['String']>;
  secondary_cta_label?: Maybe<Scalars['String']>;
  secondary_cta_link?: Maybe<PrismicLinkType>;
  vertical_margin?: Maybe<Scalars['String']>;
};

export type PrismicPricingPageDataBodyPricingFaq = PrismicSliceType & {
  items: Array<PrismicPricingPageDataBodyPricingFaqItem>;
  primary: PrismicPricingPageDataBodyPricingFaqPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicPricingPageDataBodyPricingFaqItem = {
  answer?: Maybe<PrismicStructuredTextType>;
  question?: Maybe<PrismicStructuredTextType>;
};

export type PrismicPricingPageDataBodyPricingFaqPrimary = {
  cta_icon?: Maybe<Scalars['String']>;
  cta_label?: Maybe<PrismicStructuredTextType>;
  cta_link?: Maybe<PrismicLinkType>;
  title?: Maybe<PrismicStructuredTextType>;
};

export type PrismicPricingPageDataBodyPricingGrid = PrismicSliceType & {
  items: Array<PrismicPricingPageDataBodyPricingGridItem>;
  primary: PrismicPricingPageDataBodyPricingGridPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicPricingPageDataBodyPricingGridItem = {
  body?: Maybe<PrismicStructuredTextType>;
  heading?: Maybe<PrismicStructuredTextType>;
  image?: Maybe<PrismicPricingPageDataBodyPricingGridItemsImageImageType>;
};

export type PrismicPricingPageDataBodyPricingGridItemsImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicPricingPageDataBodyPricingGridItemsImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPricingPageDataBodyPricingGridItemsImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPricingPageDataBodyPricingGridItemsImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPricingPageDataBodyPricingGridItemsImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicPricingPageDataBodyPricingGridPrimary = {
  background?: Maybe<Scalars['String']>;
  headline?: Maybe<PrismicStructuredTextType>;
  vertical_margin?: Maybe<Scalars['String']>;
};

export type PrismicPricingPageDataBodyPricingPlanCategoryTitle = PrismicSliceType & {
  primary: PrismicPricingPageDataBodyPricingPlanCategoryTitlePrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicPricingPageDataBodyPricingPlanCategoryTitlePrimary = {
  category_title?: Maybe<PrismicStructuredTextType>;
};

export type PrismicPricingPageDataBodyPricingPlanTableRow = PrismicSliceType & {
  items: Array<PrismicPricingPageDataBodyPricingPlanTableRowItem>;
  primary: PrismicPricingPageDataBodyPricingPlanTableRowPrimary;
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicPricingPageDataBodyPricingPlanTableRowItem = {
  boolean?: Maybe<Scalars['Boolean']>;
  is_boolean?: Maybe<Scalars['Boolean']>;
  plan?: Maybe<PrismicLinkType>;
  text?: Maybe<PrismicStructuredTextType>;
};

export type PrismicPricingPageDataBodyPricingPlanTableRowPrimary = {
  title?: Maybe<PrismicStructuredTextType>;
  tooltip?: Maybe<PrismicStructuredTextType>;
};

export type PrismicPricingPageDataBodySlicesType = PrismicPricingPageDataBodyCtaBanner | PrismicPricingPageDataBodyPricingFaq | PrismicPricingPageDataBodyPricingGrid | PrismicPricingPageDataBodyPricingPlanCategoryTitle | PrismicPricingPageDataBodyPricingPlanTableRow;

export type PrismicPricingPageDataPageImageImageType = {
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  dimensions?: Maybe<PrismicImageDimensionsType>;
  /** A plain imgix URL with the URL and params applied. */
  url?: Maybe<Scalars['String']>;
  /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
  fixed?: Maybe<ImgixFixed>;
  /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
  fluid?: Maybe<ImgixFluid>;
  gatsbyImageData?: Maybe<Scalars['JSON']>;
  localFile?: Maybe<File>;
};


export type PrismicPricingPageDataPageImageImageTypeUrlArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPricingPageDataPageImageImageTypeFixedArgs = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPricingPageDataPageImageImageTypeFluidArgs = {
  imgixParams?: InputMaybe<ImgixParamsInput>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
};


export type PrismicPricingPageDataPageImageImageTypeGatsbyImageDataArgs = {
  layout?: InputMaybe<GatsbyImageLayout>;
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  aspectRatio?: InputMaybe<Scalars['Float']>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sizes?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  imgixParams?: InputMaybe<ImgixParamsInput>;
  placeholderImgixParams?: InputMaybe<ImgixParamsInput>;
  placeholder?: InputMaybe<ImgixPlaceholder>;
  widthTolerance?: InputMaybe<Scalars['Float']>;
  srcSetMinWidth?: InputMaybe<Scalars['Int']>;
  srcSetMaxWidth?: InputMaybe<Scalars['Int']>;
};

export type PrismicPricingPageDataPageImageImageTypeFilterInput = {
  alt?: InputMaybe<StringQueryOperatorInput>;
  copyright?: InputMaybe<StringQueryOperatorInput>;
  dimensions?: InputMaybe<PrismicImageDimensionsTypeFilterInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  fixed?: InputMaybe<ImgixFixedFilterInput>;
  fluid?: InputMaybe<ImgixFluidFilterInput>;
  gatsbyImageData?: InputMaybe<JsonQueryOperatorInput>;
  localFile?: InputMaybe<FileFilterInput>;
};

export type PrismicPricingPageDataType = {
  billing_label?: Maybe<PrismicStructuredTextType>;
  body: Array<PrismicPricingPageDataBodySlicesType>;
  default_billing_annual?: Maybe<Scalars['Boolean']>;
  page_description?: Maybe<PrismicStructuredTextType>;
  page_image?: Maybe<PrismicPricingPageDataPageImageImageType>;
  page_title?: Maybe<PrismicStructuredTextType>;
  title?: Maybe<PrismicStructuredTextType>;
};

export type PrismicPricingPageDataTypeFilterInput = {
  billing_label?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  default_billing_annual?: InputMaybe<BooleanQueryOperatorInput>;
  page_description?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  page_image?: InputMaybe<PrismicPricingPageDataPageImageImageTypeFilterInput>;
  page_title?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  title?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
};

export type PrismicPricingPageEdge = {
  next?: Maybe<PrismicPricingPage>;
  node: PrismicPricingPage;
  previous?: Maybe<PrismicPricingPage>;
};

export enum PrismicPricingPageFieldsEnum {
  uid = 'uid',
  data___billing_label___text = 'data___billing_label___text',
  data___billing_label___html = 'data___billing_label___html',
  data___billing_label___richText = 'data___billing_label___richText',
  data___billing_label___raw = 'data___billing_label___raw',
  data___default_billing_annual = 'data___default_billing_annual',
  data___page_description___text = 'data___page_description___text',
  data___page_description___html = 'data___page_description___html',
  data___page_description___richText = 'data___page_description___richText',
  data___page_description___raw = 'data___page_description___raw',
  data___page_image___alt = 'data___page_image___alt',
  data___page_image___copyright = 'data___page_image___copyright',
  data___page_image___dimensions___width = 'data___page_image___dimensions___width',
  data___page_image___dimensions___height = 'data___page_image___dimensions___height',
  data___page_image___url = 'data___page_image___url',
  data___page_image___fixed___base64 = 'data___page_image___fixed___base64',
  data___page_image___fixed___src = 'data___page_image___fixed___src',
  data___page_image___fixed___srcSet = 'data___page_image___fixed___srcSet',
  data___page_image___fixed___srcWebp = 'data___page_image___fixed___srcWebp',
  data___page_image___fixed___srcSetWebp = 'data___page_image___fixed___srcSetWebp',
  data___page_image___fixed___sizes = 'data___page_image___fixed___sizes',
  data___page_image___fixed___width = 'data___page_image___fixed___width',
  data___page_image___fixed___height = 'data___page_image___fixed___height',
  data___page_image___fluid___base64 = 'data___page_image___fluid___base64',
  data___page_image___fluid___src = 'data___page_image___fluid___src',
  data___page_image___fluid___srcSet = 'data___page_image___fluid___srcSet',
  data___page_image___fluid___srcWebp = 'data___page_image___fluid___srcWebp',
  data___page_image___fluid___srcSetWebp = 'data___page_image___fluid___srcSetWebp',
  data___page_image___fluid___sizes = 'data___page_image___fluid___sizes',
  data___page_image___fluid___aspectRatio = 'data___page_image___fluid___aspectRatio',
  data___page_image___gatsbyImageData = 'data___page_image___gatsbyImageData',
  data___page_image___localFile___sourceInstanceName = 'data___page_image___localFile___sourceInstanceName',
  data___page_image___localFile___absolutePath = 'data___page_image___localFile___absolutePath',
  data___page_image___localFile___relativePath = 'data___page_image___localFile___relativePath',
  data___page_image___localFile___extension = 'data___page_image___localFile___extension',
  data___page_image___localFile___size = 'data___page_image___localFile___size',
  data___page_image___localFile___prettySize = 'data___page_image___localFile___prettySize',
  data___page_image___localFile___modifiedTime = 'data___page_image___localFile___modifiedTime',
  data___page_image___localFile___accessTime = 'data___page_image___localFile___accessTime',
  data___page_image___localFile___changeTime = 'data___page_image___localFile___changeTime',
  data___page_image___localFile___birthTime = 'data___page_image___localFile___birthTime',
  data___page_image___localFile___root = 'data___page_image___localFile___root',
  data___page_image___localFile___dir = 'data___page_image___localFile___dir',
  data___page_image___localFile___base = 'data___page_image___localFile___base',
  data___page_image___localFile___ext = 'data___page_image___localFile___ext',
  data___page_image___localFile___name = 'data___page_image___localFile___name',
  data___page_image___localFile___relativeDirectory = 'data___page_image___localFile___relativeDirectory',
  data___page_image___localFile___dev = 'data___page_image___localFile___dev',
  data___page_image___localFile___mode = 'data___page_image___localFile___mode',
  data___page_image___localFile___nlink = 'data___page_image___localFile___nlink',
  data___page_image___localFile___uid = 'data___page_image___localFile___uid',
  data___page_image___localFile___gid = 'data___page_image___localFile___gid',
  data___page_image___localFile___rdev = 'data___page_image___localFile___rdev',
  data___page_image___localFile___ino = 'data___page_image___localFile___ino',
  data___page_image___localFile___atimeMs = 'data___page_image___localFile___atimeMs',
  data___page_image___localFile___mtimeMs = 'data___page_image___localFile___mtimeMs',
  data___page_image___localFile___ctimeMs = 'data___page_image___localFile___ctimeMs',
  data___page_image___localFile___atime = 'data___page_image___localFile___atime',
  data___page_image___localFile___mtime = 'data___page_image___localFile___mtime',
  data___page_image___localFile___ctime = 'data___page_image___localFile___ctime',
  data___page_image___localFile___birthtime = 'data___page_image___localFile___birthtime',
  data___page_image___localFile___birthtimeMs = 'data___page_image___localFile___birthtimeMs',
  data___page_image___localFile___blksize = 'data___page_image___localFile___blksize',
  data___page_image___localFile___blocks = 'data___page_image___localFile___blocks',
  data___page_image___localFile___publicURL = 'data___page_image___localFile___publicURL',
  data___page_image___localFile___childrenImageSharp = 'data___page_image___localFile___childrenImageSharp',
  data___page_image___localFile___id = 'data___page_image___localFile___id',
  data___page_image___localFile___children = 'data___page_image___localFile___children',
  data___page_title___text = 'data___page_title___text',
  data___page_title___html = 'data___page_title___html',
  data___page_title___richText = 'data___page_title___richText',
  data___page_title___raw = 'data___page_title___raw',
  data___title___text = 'data___title___text',
  data___title___html = 'data___title___html',
  data___title___richText = 'data___title___richText',
  data___title___raw = 'data___title___raw',
  dataRaw = 'dataRaw',
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicPricingPageFilterInput = {
  uid?: InputMaybe<StringQueryOperatorInput>;
  data?: InputMaybe<PrismicPricingPageDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicPricingPageGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicPricingPageEdge>;
  nodes: Array<PrismicPricingPage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicPricingPageGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicPricingPageGroupConnectionDistinctArgs = {
  field: PrismicPricingPageFieldsEnum;
};


export type PrismicPricingPageGroupConnectionMaxArgs = {
  field: PrismicPricingPageFieldsEnum;
};


export type PrismicPricingPageGroupConnectionMinArgs = {
  field: PrismicPricingPageFieldsEnum;
};


export type PrismicPricingPageGroupConnectionSumArgs = {
  field: PrismicPricingPageFieldsEnum;
};


export type PrismicPricingPageGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicPricingPageFieldsEnum;
};

export type PrismicPricingPageSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicPricingPageFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicPricingPlan = Node & {
  data: PrismicPricingPlanDataType;
  dataRaw: Scalars['JSON'];
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicPricingPlanFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicPricingPlanLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicPricingPlanConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicPricingPlanEdge>;
  nodes: Array<PrismicPricingPlan>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicPricingPlanGroupConnection>;
};


export type PrismicPricingPlanConnectionDistinctArgs = {
  field: PrismicPricingPlanFieldsEnum;
};


export type PrismicPricingPlanConnectionMaxArgs = {
  field: PrismicPricingPlanFieldsEnum;
};


export type PrismicPricingPlanConnectionMinArgs = {
  field: PrismicPricingPlanFieldsEnum;
};


export type PrismicPricingPlanConnectionSumArgs = {
  field: PrismicPricingPlanFieldsEnum;
};


export type PrismicPricingPlanConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicPricingPlanFieldsEnum;
};

export type PrismicPricingPlanDataType = {
  annual_cost?: Maybe<Scalars['Float']>;
  annual_range_maximum?: Maybe<Scalars['Float']>;
  annual_range_minimum?: Maybe<Scalars['Float']>;
  cta_link?: Maybe<PrismicLinkType>;
  cta_text?: Maybe<PrismicStructuredTextType>;
  monthly_cost?: Maybe<Scalars['Float']>;
  monthly_range_maximum?: Maybe<Scalars['Float']>;
  monthly_range_minimum?: Maybe<Scalars['Float']>;
  pricing_description?: Maybe<PrismicStructuredTextType>;
  pricing_description_tooltip?: Maybe<PrismicStructuredTextType>;
  pricing_text?: Maybe<PrismicStructuredTextType>;
  pricing_type?: Maybe<Scalars['String']>;
  recommended?: Maybe<Scalars['Boolean']>;
  recommended_for?: Maybe<PrismicStructuredTextType>;
  title?: Maybe<PrismicStructuredTextType>;
};

export type PrismicPricingPlanDataTypeFilterInput = {
  annual_cost?: InputMaybe<FloatQueryOperatorInput>;
  annual_range_maximum?: InputMaybe<FloatQueryOperatorInput>;
  annual_range_minimum?: InputMaybe<FloatQueryOperatorInput>;
  cta_link?: InputMaybe<PrismicLinkTypeFilterInput>;
  cta_text?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  monthly_cost?: InputMaybe<FloatQueryOperatorInput>;
  monthly_range_maximum?: InputMaybe<FloatQueryOperatorInput>;
  monthly_range_minimum?: InputMaybe<FloatQueryOperatorInput>;
  pricing_description?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  pricing_description_tooltip?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  pricing_text?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  pricing_type?: InputMaybe<StringQueryOperatorInput>;
  recommended?: InputMaybe<BooleanQueryOperatorInput>;
  recommended_for?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
  title?: InputMaybe<PrismicStructuredTextTypeFilterInput>;
};

export type PrismicPricingPlanEdge = {
  next?: Maybe<PrismicPricingPlan>;
  node: PrismicPricingPlan;
  previous?: Maybe<PrismicPricingPlan>;
};

export enum PrismicPricingPlanFieldsEnum {
  data___annual_cost = 'data___annual_cost',
  data___annual_range_maximum = 'data___annual_range_maximum',
  data___annual_range_minimum = 'data___annual_range_minimum',
  data___cta_link___link_type = 'data___cta_link___link_type',
  data___cta_link___isBroken = 'data___cta_link___isBroken',
  data___cta_link___url = 'data___cta_link___url',
  data___cta_link___target = 'data___cta_link___target',
  data___cta_link___size = 'data___cta_link___size',
  data___cta_link___id = 'data___cta_link___id',
  data___cta_link___type = 'data___cta_link___type',
  data___cta_link___tags = 'data___cta_link___tags',
  data___cta_link___lang = 'data___cta_link___lang',
  data___cta_link___slug = 'data___cta_link___slug',
  data___cta_link___uid = 'data___cta_link___uid',
  data___cta_link___localFile___sourceInstanceName = 'data___cta_link___localFile___sourceInstanceName',
  data___cta_link___localFile___absolutePath = 'data___cta_link___localFile___absolutePath',
  data___cta_link___localFile___relativePath = 'data___cta_link___localFile___relativePath',
  data___cta_link___localFile___extension = 'data___cta_link___localFile___extension',
  data___cta_link___localFile___size = 'data___cta_link___localFile___size',
  data___cta_link___localFile___prettySize = 'data___cta_link___localFile___prettySize',
  data___cta_link___localFile___modifiedTime = 'data___cta_link___localFile___modifiedTime',
  data___cta_link___localFile___accessTime = 'data___cta_link___localFile___accessTime',
  data___cta_link___localFile___changeTime = 'data___cta_link___localFile___changeTime',
  data___cta_link___localFile___birthTime = 'data___cta_link___localFile___birthTime',
  data___cta_link___localFile___root = 'data___cta_link___localFile___root',
  data___cta_link___localFile___dir = 'data___cta_link___localFile___dir',
  data___cta_link___localFile___base = 'data___cta_link___localFile___base',
  data___cta_link___localFile___ext = 'data___cta_link___localFile___ext',
  data___cta_link___localFile___name = 'data___cta_link___localFile___name',
  data___cta_link___localFile___relativeDirectory = 'data___cta_link___localFile___relativeDirectory',
  data___cta_link___localFile___dev = 'data___cta_link___localFile___dev',
  data___cta_link___localFile___mode = 'data___cta_link___localFile___mode',
  data___cta_link___localFile___nlink = 'data___cta_link___localFile___nlink',
  data___cta_link___localFile___uid = 'data___cta_link___localFile___uid',
  data___cta_link___localFile___gid = 'data___cta_link___localFile___gid',
  data___cta_link___localFile___rdev = 'data___cta_link___localFile___rdev',
  data___cta_link___localFile___ino = 'data___cta_link___localFile___ino',
  data___cta_link___localFile___atimeMs = 'data___cta_link___localFile___atimeMs',
  data___cta_link___localFile___mtimeMs = 'data___cta_link___localFile___mtimeMs',
  data___cta_link___localFile___ctimeMs = 'data___cta_link___localFile___ctimeMs',
  data___cta_link___localFile___atime = 'data___cta_link___localFile___atime',
  data___cta_link___localFile___mtime = 'data___cta_link___localFile___mtime',
  data___cta_link___localFile___ctime = 'data___cta_link___localFile___ctime',
  data___cta_link___localFile___birthtime = 'data___cta_link___localFile___birthtime',
  data___cta_link___localFile___birthtimeMs = 'data___cta_link___localFile___birthtimeMs',
  data___cta_link___localFile___blksize = 'data___cta_link___localFile___blksize',
  data___cta_link___localFile___blocks = 'data___cta_link___localFile___blocks',
  data___cta_link___localFile___publicURL = 'data___cta_link___localFile___publicURL',
  data___cta_link___localFile___childrenImageSharp = 'data___cta_link___localFile___childrenImageSharp',
  data___cta_link___localFile___id = 'data___cta_link___localFile___id',
  data___cta_link___localFile___children = 'data___cta_link___localFile___children',
  data___cta_link___raw = 'data___cta_link___raw',
  data___cta_text___text = 'data___cta_text___text',
  data___cta_text___html = 'data___cta_text___html',
  data___cta_text___richText = 'data___cta_text___richText',
  data___cta_text___raw = 'data___cta_text___raw',
  data___monthly_cost = 'data___monthly_cost',
  data___monthly_range_maximum = 'data___monthly_range_maximum',
  data___monthly_range_minimum = 'data___monthly_range_minimum',
  data___pricing_description___text = 'data___pricing_description___text',
  data___pricing_description___html = 'data___pricing_description___html',
  data___pricing_description___richText = 'data___pricing_description___richText',
  data___pricing_description___raw = 'data___pricing_description___raw',
  data___pricing_description_tooltip___text = 'data___pricing_description_tooltip___text',
  data___pricing_description_tooltip___html = 'data___pricing_description_tooltip___html',
  data___pricing_description_tooltip___richText = 'data___pricing_description_tooltip___richText',
  data___pricing_description_tooltip___raw = 'data___pricing_description_tooltip___raw',
  data___pricing_text___text = 'data___pricing_text___text',
  data___pricing_text___html = 'data___pricing_text___html',
  data___pricing_text___richText = 'data___pricing_text___richText',
  data___pricing_text___raw = 'data___pricing_text___raw',
  data___pricing_type = 'data___pricing_type',
  data___recommended = 'data___recommended',
  data___recommended_for___text = 'data___recommended_for___text',
  data___recommended_for___html = 'data___recommended_for___html',
  data___recommended_for___richText = 'data___recommended_for___richText',
  data___recommended_for___raw = 'data___recommended_for___raw',
  data___title___text = 'data___title___text',
  data___title___html = 'data___title___html',
  data___title___richText = 'data___title___richText',
  data___title___raw = 'data___title___raw',
  dataRaw = 'dataRaw',
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicPricingPlanFilterInput = {
  data?: InputMaybe<PrismicPricingPlanDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicPricingPlanGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicPricingPlanEdge>;
  nodes: Array<PrismicPricingPlan>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicPricingPlanGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicPricingPlanGroupConnectionDistinctArgs = {
  field: PrismicPricingPlanFieldsEnum;
};


export type PrismicPricingPlanGroupConnectionMaxArgs = {
  field: PrismicPricingPlanFieldsEnum;
};


export type PrismicPricingPlanGroupConnectionMinArgs = {
  field: PrismicPricingPlanFieldsEnum;
};


export type PrismicPricingPlanGroupConnectionSumArgs = {
  field: PrismicPricingPlanFieldsEnum;
};


export type PrismicPricingPlanGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicPricingPlanFieldsEnum;
};

export type PrismicPricingPlanSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicPricingPlanFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicPricingSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicPricingFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicSharedSliceType = {
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
  variation: Scalars['String'];
  version: Scalars['String'];
};

export type PrismicSliceType = {
  id: Scalars['ID'];
  slice_type: Scalars['String'];
  slice_label?: Maybe<Scalars['String']>;
};

export type PrismicStructuredTextQueryOperatorInput = {
  eq?: InputMaybe<Scalars['PrismicStructuredText']>;
  ne?: InputMaybe<Scalars['PrismicStructuredText']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['PrismicStructuredText']>>>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['PrismicStructuredText']>>>;
};

export type PrismicStructuredTextType = {
  text?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  richText: Scalars['PrismicStructuredText'];
  /** @deprecated This field has been renamed to `richText`. The `richText` field has the same value the `raw` field. */
  raw: Scalars['PrismicStructuredText'];
};

export type PrismicStructuredTextTypeFilterInput = {
  text?: InputMaybe<StringQueryOperatorInput>;
  html?: InputMaybe<StringQueryOperatorInput>;
  richText?: InputMaybe<PrismicStructuredTextQueryOperatorInput>;
  raw?: InputMaybe<PrismicStructuredTextQueryOperatorInput>;
};

export type PrismicTest1 = Node & {
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicTest1First_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicTest1Last_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicTest1Connection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicTest1Edge>;
  nodes: Array<PrismicTest1>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicTest1GroupConnection>;
};


export type PrismicTest1ConnectionDistinctArgs = {
  field: PrismicTest1FieldsEnum;
};


export type PrismicTest1ConnectionMaxArgs = {
  field: PrismicTest1FieldsEnum;
};


export type PrismicTest1ConnectionMinArgs = {
  field: PrismicTest1FieldsEnum;
};


export type PrismicTest1ConnectionSumArgs = {
  field: PrismicTest1FieldsEnum;
};


export type PrismicTest1ConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicTest1FieldsEnum;
};

export type PrismicTest1Edge = {
  next?: Maybe<PrismicTest1>;
  node: PrismicTest1;
  previous?: Maybe<PrismicTest1>;
};

export enum PrismicTest1FieldsEnum {
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicTest1FilterInput = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicTest1GroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicTest1Edge>;
  nodes: Array<PrismicTest1>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicTest1GroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicTest1GroupConnectionDistinctArgs = {
  field: PrismicTest1FieldsEnum;
};


export type PrismicTest1GroupConnectionMaxArgs = {
  field: PrismicTest1FieldsEnum;
};


export type PrismicTest1GroupConnectionMinArgs = {
  field: PrismicTest1FieldsEnum;
};


export type PrismicTest1GroupConnectionSumArgs = {
  field: PrismicTest1FieldsEnum;
};


export type PrismicTest1GroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicTest1FieldsEnum;
};

export type PrismicTest1SortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicTest1FieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicTestPage = Node & {
  prismicId: Scalars['ID'];
  alternate_languages: Array<PrismicAlternateLanguageType>;
  first_publication_date: Scalars['Date'];
  href: Scalars['String'];
  lang: Scalars['String'];
  last_publication_date: Scalars['Date'];
  tags: Array<Scalars['String']>;
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  _previewable: Scalars['ID'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type PrismicTestPageFirst_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};


export type PrismicTestPageLast_Publication_DateArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type PrismicTestPageConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicTestPageEdge>;
  nodes: Array<PrismicTestPage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicTestPageGroupConnection>;
};


export type PrismicTestPageConnectionDistinctArgs = {
  field: PrismicTestPageFieldsEnum;
};


export type PrismicTestPageConnectionMaxArgs = {
  field: PrismicTestPageFieldsEnum;
};


export type PrismicTestPageConnectionMinArgs = {
  field: PrismicTestPageFieldsEnum;
};


export type PrismicTestPageConnectionSumArgs = {
  field: PrismicTestPageFieldsEnum;
};


export type PrismicTestPageConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicTestPageFieldsEnum;
};

export type PrismicTestPageEdge = {
  next?: Maybe<PrismicTestPage>;
  node: PrismicTestPage;
  previous?: Maybe<PrismicTestPage>;
};

export enum PrismicTestPageFieldsEnum {
  prismicId = 'prismicId',
  alternate_languages = 'alternate_languages',
  alternate_languages___id = 'alternate_languages___id',
  alternate_languages___uid = 'alternate_languages___uid',
  alternate_languages___lang = 'alternate_languages___lang',
  alternate_languages___type = 'alternate_languages___type',
  alternate_languages___raw = 'alternate_languages___raw',
  first_publication_date = 'first_publication_date',
  href = 'href',
  lang = 'lang',
  last_publication_date = 'last_publication_date',
  tags = 'tags',
  type = 'type',
  url = 'url',
  _previewable = '_previewable',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicTestPageFilterInput = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicTestPageGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicTestPageEdge>;
  nodes: Array<PrismicTestPage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicTestPageGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicTestPageGroupConnectionDistinctArgs = {
  field: PrismicTestPageFieldsEnum;
};


export type PrismicTestPageGroupConnectionMaxArgs = {
  field: PrismicTestPageFieldsEnum;
};


export type PrismicTestPageGroupConnectionMinArgs = {
  field: PrismicTestPageFieldsEnum;
};


export type PrismicTestPageGroupConnectionSumArgs = {
  field: PrismicTestPageFieldsEnum;
};


export type PrismicTestPageGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicTestPageFieldsEnum;
};

export type PrismicTestPageSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicTestPageFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type PrismicTypePathType = Node & {
  kind: Scalars['String'];
  path: Array<Scalars['String']>;
  type: Scalars['String'];
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type PrismicTypePathTypeConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicTypePathTypeEdge>;
  nodes: Array<PrismicTypePathType>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicTypePathTypeGroupConnection>;
};


export type PrismicTypePathTypeConnectionDistinctArgs = {
  field: PrismicTypePathTypeFieldsEnum;
};


export type PrismicTypePathTypeConnectionMaxArgs = {
  field: PrismicTypePathTypeFieldsEnum;
};


export type PrismicTypePathTypeConnectionMinArgs = {
  field: PrismicTypePathTypeFieldsEnum;
};


export type PrismicTypePathTypeConnectionSumArgs = {
  field: PrismicTypePathTypeFieldsEnum;
};


export type PrismicTypePathTypeConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicTypePathTypeFieldsEnum;
};

export type PrismicTypePathTypeEdge = {
  next?: Maybe<PrismicTypePathType>;
  node: PrismicTypePathType;
  previous?: Maybe<PrismicTypePathType>;
};

export enum PrismicTypePathTypeFieldsEnum {
  kind = 'kind',
  path = 'path',
  type = 'type',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type PrismicTypePathTypeFilterInput = {
  kind?: InputMaybe<StringQueryOperatorInput>;
  path?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type PrismicTypePathTypeGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<PrismicTypePathTypeEdge>;
  nodes: Array<PrismicTypePathType>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<PrismicTypePathTypeGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type PrismicTypePathTypeGroupConnectionDistinctArgs = {
  field: PrismicTypePathTypeFieldsEnum;
};


export type PrismicTypePathTypeGroupConnectionMaxArgs = {
  field: PrismicTypePathTypeFieldsEnum;
};


export type PrismicTypePathTypeGroupConnectionMinArgs = {
  field: PrismicTypePathTypeFieldsEnum;
};


export type PrismicTypePathTypeGroupConnectionSumArgs = {
  field: PrismicTypePathTypeFieldsEnum;
};


export type PrismicTypePathTypeGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: PrismicTypePathTypeFieldsEnum;
};

export type PrismicTypePathTypeSortInput = {
  fields?: InputMaybe<Array<InputMaybe<PrismicTypePathTypeFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type Query = {
  file?: Maybe<File>;
  allFile: FileConnection;
  directory?: Maybe<Directory>;
  allDirectory: DirectoryConnection;
  site?: Maybe<Site>;
  allSite: SiteConnection;
  siteFunction?: Maybe<SiteFunction>;
  allSiteFunction: SiteFunctionConnection;
  sitePage?: Maybe<SitePage>;
  allSitePage: SitePageConnection;
  sitePlugin?: Maybe<SitePlugin>;
  allSitePlugin: SitePluginConnection;
  siteBuildMetadata?: Maybe<SiteBuildMetadata>;
  allSiteBuildMetadata: SiteBuildMetadataConnection;
  prismicEmbedType?: Maybe<PrismicEmbedType>;
  allPrismicEmbedType: PrismicEmbedTypeConnection;
  prismicTypePathType?: Maybe<PrismicTypePathType>;
  allPrismicTypePathType: PrismicTypePathTypeConnection;
  prismicBlog?: Maybe<PrismicBlog>;
  allPrismicBlog: PrismicBlogConnection;
  prismicDocs?: Maybe<PrismicDocs>;
  allPrismicDocs: PrismicDocsConnection;
  prismicDocsTemplateType?: Maybe<PrismicDocsTemplateType>;
  allPrismicDocsTemplateType: PrismicDocsTemplateTypeConnection;
  prismicDocsInner?: Maybe<PrismicDocsInner>;
  allPrismicDocsInner: PrismicDocsInnerConnection;
  prismicMarketingPage?: Maybe<PrismicMarketingPage>;
  allPrismicMarketingPage: PrismicMarketingPageConnection;
  prismicTestPage?: Maybe<PrismicTestPage>;
  allPrismicTestPage: PrismicTestPageConnection;
  prismicBlogSocialLinks?: Maybe<PrismicBlogSocialLinks>;
  allPrismicBlogSocialLinks: PrismicBlogSocialLinksConnection;
  prismicPricing?: Maybe<PrismicPricing>;
  allPrismicPricing: PrismicPricingConnection;
  prismicGrowthCalculator?: Maybe<PrismicGrowthCalculator>;
  allPrismicGrowthCalculator: PrismicGrowthCalculatorConnection;
  prismicTest1?: Maybe<PrismicTest1>;
  allPrismicTest1: PrismicTest1Connection;
  prismicBanner?: Maybe<PrismicBanner>;
  allPrismicBanner: PrismicBannerConnection;
  prismicAuthor?: Maybe<PrismicAuthor>;
  allPrismicAuthor: PrismicAuthorConnection;
  prismicBlogFeed?: Maybe<PrismicBlogFeed>;
  allPrismicBlogFeed: PrismicBlogFeedConnection;
  prismicPricingPlan?: Maybe<PrismicPricingPlan>;
  allPrismicPricingPlan: PrismicPricingPlanConnection;
  prismicDocsSitemap?: Maybe<PrismicDocsSitemap>;
  allPrismicDocsSitemap: PrismicDocsSitemapConnection;
  prismicAcademySitemap?: Maybe<PrismicAcademySitemap>;
  allPrismicAcademySitemap: PrismicAcademySitemapConnection;
  prismicFooter?: Maybe<PrismicFooter>;
  allPrismicFooter: PrismicFooterConnection;
  prismicLtvCalculator?: Maybe<PrismicLtvCalculator>;
  allPrismicLtvCalculator: PrismicLtvCalculatorConnection;
  prismicNav?: Maybe<PrismicNav>;
  allPrismicNav: PrismicNavConnection;
  prismicDocPage?: Maybe<PrismicDocPage>;
  allPrismicDocPage: PrismicDocPageConnection;
  prismicAcademyPage?: Maybe<PrismicAcademyPage>;
  allPrismicAcademyPage: PrismicAcademyPageConnection;
  prismicBlogPage?: Maybe<PrismicBlogPage>;
  allPrismicBlogPage: PrismicBlogPageConnection;
  prismicPricingPage?: Maybe<PrismicPricingPage>;
  allPrismicPricingPage: PrismicPricingPageConnection;
  prismicPartnerPage?: Maybe<PrismicPartnerPage>;
  allPrismicPartnerPage: PrismicPartnerPageConnection;
  prismicHomepage?: Maybe<PrismicHomepage>;
  allPrismicHomepage: PrismicHomepageConnection;
  imageSharp?: Maybe<ImageSharp>;
  allImageSharp: ImageSharpConnection;
};


export type QueryFileArgs = {
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  blksize?: InputMaybe<IntQueryOperatorInput>;
  blocks?: InputMaybe<IntQueryOperatorInput>;
  publicURL?: InputMaybe<StringQueryOperatorInput>;
  childrenImageSharp?: InputMaybe<ImageSharpFilterListInput>;
  childImageSharp?: InputMaybe<ImageSharpFilterInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllFileArgs = {
  filter?: InputMaybe<FileFilterInput>;
  sort?: InputMaybe<FileSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryDirectoryArgs = {
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllDirectoryArgs = {
  filter?: InputMaybe<DirectoryFilterInput>;
  sort?: InputMaybe<DirectorySortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QuerySiteArgs = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  siteMetadata?: InputMaybe<SiteSiteMetadataFilterInput>;
  port?: InputMaybe<IntQueryOperatorInput>;
  host?: InputMaybe<StringQueryOperatorInput>;
  flags?: InputMaybe<SiteFlagsFilterInput>;
  polyfill?: InputMaybe<BooleanQueryOperatorInput>;
  pathPrefix?: InputMaybe<StringQueryOperatorInput>;
  jsxRuntime?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllSiteArgs = {
  filter?: InputMaybe<SiteFilterInput>;
  sort?: InputMaybe<SiteSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QuerySiteFunctionArgs = {
  functionRoute?: InputMaybe<StringQueryOperatorInput>;
  pluginName?: InputMaybe<StringQueryOperatorInput>;
  originalAbsoluteFilePath?: InputMaybe<StringQueryOperatorInput>;
  originalRelativeFilePath?: InputMaybe<StringQueryOperatorInput>;
  relativeCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
  absoluteCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllSiteFunctionArgs = {
  filter?: InputMaybe<SiteFunctionFilterInput>;
  sort?: InputMaybe<SiteFunctionSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QuerySitePageArgs = {
  path?: InputMaybe<StringQueryOperatorInput>;
  component?: InputMaybe<StringQueryOperatorInput>;
  internalComponentName?: InputMaybe<StringQueryOperatorInput>;
  componentChunkName?: InputMaybe<StringQueryOperatorInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  pageContext?: InputMaybe<JsonQueryOperatorInput>;
  pluginCreator?: InputMaybe<SitePluginFilterInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllSitePageArgs = {
  filter?: InputMaybe<SitePageFilterInput>;
  sort?: InputMaybe<SitePageSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QuerySitePluginArgs = {
  resolve?: InputMaybe<StringQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  version?: InputMaybe<StringQueryOperatorInput>;
  nodeAPIs?: InputMaybe<StringQueryOperatorInput>;
  browserAPIs?: InputMaybe<StringQueryOperatorInput>;
  ssrAPIs?: InputMaybe<StringQueryOperatorInput>;
  pluginFilepath?: InputMaybe<StringQueryOperatorInput>;
  pluginOptions?: InputMaybe<JsonQueryOperatorInput>;
  packageJson?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllSitePluginArgs = {
  filter?: InputMaybe<SitePluginFilterInput>;
  sort?: InputMaybe<SitePluginSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QuerySiteBuildMetadataArgs = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllSiteBuildMetadataArgs = {
  filter?: InputMaybe<SiteBuildMetadataFilterInput>;
  sort?: InputMaybe<SiteBuildMetadataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicEmbedTypeArgs = {
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicEmbedTypeArgs = {
  filter?: InputMaybe<PrismicEmbedTypeFilterInput>;
  sort?: InputMaybe<PrismicEmbedTypeSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicTypePathTypeArgs = {
  kind?: InputMaybe<StringQueryOperatorInput>;
  path?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicTypePathTypeArgs = {
  filter?: InputMaybe<PrismicTypePathTypeFilterInput>;
  sort?: InputMaybe<PrismicTypePathTypeSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicBlogArgs = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicBlogArgs = {
  filter?: InputMaybe<PrismicBlogFilterInput>;
  sort?: InputMaybe<PrismicBlogSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicDocsArgs = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicDocsArgs = {
  filter?: InputMaybe<PrismicDocsFilterInput>;
  sort?: InputMaybe<PrismicDocsSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicDocsTemplateTypeArgs = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicDocsTemplateTypeArgs = {
  filter?: InputMaybe<PrismicDocsTemplateTypeFilterInput>;
  sort?: InputMaybe<PrismicDocsTemplateTypeSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicDocsInnerArgs = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicDocsInnerArgs = {
  filter?: InputMaybe<PrismicDocsInnerFilterInput>;
  sort?: InputMaybe<PrismicDocsInnerSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicMarketingPageArgs = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  uid?: InputMaybe<StringQueryOperatorInput>;
  data?: InputMaybe<PrismicMarketingPageDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicMarketingPageArgs = {
  filter?: InputMaybe<PrismicMarketingPageFilterInput>;
  sort?: InputMaybe<PrismicMarketingPageSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicTestPageArgs = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicTestPageArgs = {
  filter?: InputMaybe<PrismicTestPageFilterInput>;
  sort?: InputMaybe<PrismicTestPageSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicBlogSocialLinksArgs = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicBlogSocialLinksArgs = {
  filter?: InputMaybe<PrismicBlogSocialLinksFilterInput>;
  sort?: InputMaybe<PrismicBlogSocialLinksSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicPricingArgs = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicPricingArgs = {
  filter?: InputMaybe<PrismicPricingFilterInput>;
  sort?: InputMaybe<PrismicPricingSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicGrowthCalculatorArgs = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  uid?: InputMaybe<StringQueryOperatorInput>;
  data?: InputMaybe<PrismicGrowthCalculatorDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicGrowthCalculatorArgs = {
  filter?: InputMaybe<PrismicGrowthCalculatorFilterInput>;
  sort?: InputMaybe<PrismicGrowthCalculatorSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicTest1Args = {
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicTest1Args = {
  filter?: InputMaybe<PrismicTest1FilterInput>;
  sort?: InputMaybe<PrismicTest1SortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicBannerArgs = {
  data?: InputMaybe<PrismicBannerDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicBannerArgs = {
  filter?: InputMaybe<PrismicBannerFilterInput>;
  sort?: InputMaybe<PrismicBannerSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicAuthorArgs = {
  data?: InputMaybe<PrismicAuthorDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicAuthorArgs = {
  filter?: InputMaybe<PrismicAuthorFilterInput>;
  sort?: InputMaybe<PrismicAuthorSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicBlogFeedArgs = {
  data?: InputMaybe<PrismicBlogFeedDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicBlogFeedArgs = {
  filter?: InputMaybe<PrismicBlogFeedFilterInput>;
  sort?: InputMaybe<PrismicBlogFeedSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicPricingPlanArgs = {
  data?: InputMaybe<PrismicPricingPlanDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicPricingPlanArgs = {
  filter?: InputMaybe<PrismicPricingPlanFilterInput>;
  sort?: InputMaybe<PrismicPricingPlanSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicDocsSitemapArgs = {
  data?: InputMaybe<PrismicDocsSitemapDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicDocsSitemapArgs = {
  filter?: InputMaybe<PrismicDocsSitemapFilterInput>;
  sort?: InputMaybe<PrismicDocsSitemapSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicAcademySitemapArgs = {
  data?: InputMaybe<PrismicAcademySitemapDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicAcademySitemapArgs = {
  filter?: InputMaybe<PrismicAcademySitemapFilterInput>;
  sort?: InputMaybe<PrismicAcademySitemapSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicFooterArgs = {
  data?: InputMaybe<PrismicFooterDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicFooterArgs = {
  filter?: InputMaybe<PrismicFooterFilterInput>;
  sort?: InputMaybe<PrismicFooterSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicLtvCalculatorArgs = {
  uid?: InputMaybe<StringQueryOperatorInput>;
  data?: InputMaybe<PrismicLtvCalculatorDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicLtvCalculatorArgs = {
  filter?: InputMaybe<PrismicLtvCalculatorFilterInput>;
  sort?: InputMaybe<PrismicLtvCalculatorSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicNavArgs = {
  data?: InputMaybe<PrismicNavDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicNavArgs = {
  filter?: InputMaybe<PrismicNavFilterInput>;
  sort?: InputMaybe<PrismicNavSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicDocPageArgs = {
  uid?: InputMaybe<StringQueryOperatorInput>;
  data?: InputMaybe<PrismicDocPageDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicDocPageArgs = {
  filter?: InputMaybe<PrismicDocPageFilterInput>;
  sort?: InputMaybe<PrismicDocPageSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicAcademyPageArgs = {
  uid?: InputMaybe<StringQueryOperatorInput>;
  data?: InputMaybe<PrismicAcademyPageDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicAcademyPageArgs = {
  filter?: InputMaybe<PrismicAcademyPageFilterInput>;
  sort?: InputMaybe<PrismicAcademyPageSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicBlogPageArgs = {
  uid?: InputMaybe<StringQueryOperatorInput>;
  data?: InputMaybe<PrismicBlogPageDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicBlogPageArgs = {
  filter?: InputMaybe<PrismicBlogPageFilterInput>;
  sort?: InputMaybe<PrismicBlogPageSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicPricingPageArgs = {
  uid?: InputMaybe<StringQueryOperatorInput>;
  data?: InputMaybe<PrismicPricingPageDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicPricingPageArgs = {
  filter?: InputMaybe<PrismicPricingPageFilterInput>;
  sort?: InputMaybe<PrismicPricingPageSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicPartnerPageArgs = {
  uid?: InputMaybe<StringQueryOperatorInput>;
  data?: InputMaybe<PrismicPartnerPageDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicPartnerPageArgs = {
  filter?: InputMaybe<PrismicPartnerPageFilterInput>;
  sort?: InputMaybe<PrismicPartnerPageSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryPrismicHomepageArgs = {
  data?: InputMaybe<PrismicHomepageDataTypeFilterInput>;
  dataRaw?: InputMaybe<JsonQueryOperatorInput>;
  prismicId?: InputMaybe<IdQueryOperatorInput>;
  alternate_languages?: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>;
  first_publication_date?: InputMaybe<DateQueryOperatorInput>;
  href?: InputMaybe<StringQueryOperatorInput>;
  lang?: InputMaybe<StringQueryOperatorInput>;
  last_publication_date?: InputMaybe<DateQueryOperatorInput>;
  tags?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  _previewable?: InputMaybe<IdQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllPrismicHomepageArgs = {
  filter?: InputMaybe<PrismicHomepageFilterInput>;
  sort?: InputMaybe<PrismicHomepageSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryImageSharpArgs = {
  fixed?: InputMaybe<ImageSharpFixedFilterInput>;
  fluid?: InputMaybe<ImageSharpFluidFilterInput>;
  gatsbyImageData?: InputMaybe<JsonQueryOperatorInput>;
  original?: InputMaybe<ImageSharpOriginalFilterInput>;
  resize?: InputMaybe<ImageSharpResizeFilterInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};


export type QueryAllImageSharpArgs = {
  filter?: InputMaybe<ImageSharpFilterInput>;
  sort?: InputMaybe<ImageSharpSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type Site = Node & {
  buildTime?: Maybe<Scalars['Date']>;
  siteMetadata?: Maybe<SiteSiteMetadata>;
  port?: Maybe<Scalars['Int']>;
  host?: Maybe<Scalars['String']>;
  flags?: Maybe<SiteFlags>;
  polyfill?: Maybe<Scalars['Boolean']>;
  pathPrefix?: Maybe<Scalars['String']>;
  jsxRuntime?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type SiteBuildTimeArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SiteBuildMetadata = Node & {
  buildTime?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};


export type SiteBuildMetadataBuildTimeArgs = {
  formatString?: InputMaybe<Scalars['String']>;
  fromNow?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type SiteBuildMetadataConnection = {
  totalCount: Scalars['Int'];
  edges: Array<SiteBuildMetadataEdge>;
  nodes: Array<SiteBuildMetadata>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SiteBuildMetadataGroupConnection>;
};


export type SiteBuildMetadataConnectionDistinctArgs = {
  field: SiteBuildMetadataFieldsEnum;
};


export type SiteBuildMetadataConnectionMaxArgs = {
  field: SiteBuildMetadataFieldsEnum;
};


export type SiteBuildMetadataConnectionMinArgs = {
  field: SiteBuildMetadataFieldsEnum;
};


export type SiteBuildMetadataConnectionSumArgs = {
  field: SiteBuildMetadataFieldsEnum;
};


export type SiteBuildMetadataConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: SiteBuildMetadataFieldsEnum;
};

export type SiteBuildMetadataEdge = {
  next?: Maybe<SiteBuildMetadata>;
  node: SiteBuildMetadata;
  previous?: Maybe<SiteBuildMetadata>;
};

export enum SiteBuildMetadataFieldsEnum {
  buildTime = 'buildTime',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type SiteBuildMetadataFilterInput = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type SiteBuildMetadataGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<SiteBuildMetadataEdge>;
  nodes: Array<SiteBuildMetadata>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SiteBuildMetadataGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type SiteBuildMetadataGroupConnectionDistinctArgs = {
  field: SiteBuildMetadataFieldsEnum;
};


export type SiteBuildMetadataGroupConnectionMaxArgs = {
  field: SiteBuildMetadataFieldsEnum;
};


export type SiteBuildMetadataGroupConnectionMinArgs = {
  field: SiteBuildMetadataFieldsEnum;
};


export type SiteBuildMetadataGroupConnectionSumArgs = {
  field: SiteBuildMetadataFieldsEnum;
};


export type SiteBuildMetadataGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: SiteBuildMetadataFieldsEnum;
};

export type SiteBuildMetadataSortInput = {
  fields?: InputMaybe<Array<InputMaybe<SiteBuildMetadataFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type SiteConnection = {
  totalCount: Scalars['Int'];
  edges: Array<SiteEdge>;
  nodes: Array<Site>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SiteGroupConnection>;
};


export type SiteConnectionDistinctArgs = {
  field: SiteFieldsEnum;
};


export type SiteConnectionMaxArgs = {
  field: SiteFieldsEnum;
};


export type SiteConnectionMinArgs = {
  field: SiteFieldsEnum;
};


export type SiteConnectionSumArgs = {
  field: SiteFieldsEnum;
};


export type SiteConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: SiteFieldsEnum;
};

export type SiteEdge = {
  next?: Maybe<Site>;
  node: Site;
  previous?: Maybe<Site>;
};

export enum SiteFieldsEnum {
  buildTime = 'buildTime',
  siteMetadata___title = 'siteMetadata___title',
  siteMetadata___description = 'siteMetadata___description',
  siteMetadata___author = 'siteMetadata___author',
  siteMetadata___siteUrl = 'siteMetadata___siteUrl',
  port = 'port',
  host = 'host',
  flags___DEV_SSR = 'flags___DEV_SSR',
  polyfill = 'polyfill',
  pathPrefix = 'pathPrefix',
  jsxRuntime = 'jsxRuntime',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type SiteFilterInput = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  siteMetadata?: InputMaybe<SiteSiteMetadataFilterInput>;
  port?: InputMaybe<IntQueryOperatorInput>;
  host?: InputMaybe<StringQueryOperatorInput>;
  flags?: InputMaybe<SiteFlagsFilterInput>;
  polyfill?: InputMaybe<BooleanQueryOperatorInput>;
  pathPrefix?: InputMaybe<StringQueryOperatorInput>;
  jsxRuntime?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type SiteFlags = {
  DEV_SSR?: Maybe<Scalars['Boolean']>;
};

export type SiteFlagsFilterInput = {
  DEV_SSR?: InputMaybe<BooleanQueryOperatorInput>;
};

export type SiteFunction = Node & {
  functionRoute: Scalars['String'];
  pluginName: Scalars['String'];
  originalAbsoluteFilePath: Scalars['String'];
  originalRelativeFilePath: Scalars['String'];
  relativeCompiledFilePath: Scalars['String'];
  absoluteCompiledFilePath: Scalars['String'];
  matchPath?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type SiteFunctionConnection = {
  totalCount: Scalars['Int'];
  edges: Array<SiteFunctionEdge>;
  nodes: Array<SiteFunction>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SiteFunctionGroupConnection>;
};


export type SiteFunctionConnectionDistinctArgs = {
  field: SiteFunctionFieldsEnum;
};


export type SiteFunctionConnectionMaxArgs = {
  field: SiteFunctionFieldsEnum;
};


export type SiteFunctionConnectionMinArgs = {
  field: SiteFunctionFieldsEnum;
};


export type SiteFunctionConnectionSumArgs = {
  field: SiteFunctionFieldsEnum;
};


export type SiteFunctionConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: SiteFunctionFieldsEnum;
};

export type SiteFunctionEdge = {
  next?: Maybe<SiteFunction>;
  node: SiteFunction;
  previous?: Maybe<SiteFunction>;
};

export enum SiteFunctionFieldsEnum {
  functionRoute = 'functionRoute',
  pluginName = 'pluginName',
  originalAbsoluteFilePath = 'originalAbsoluteFilePath',
  originalRelativeFilePath = 'originalRelativeFilePath',
  relativeCompiledFilePath = 'relativeCompiledFilePath',
  absoluteCompiledFilePath = 'absoluteCompiledFilePath',
  matchPath = 'matchPath',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type SiteFunctionFilterInput = {
  functionRoute?: InputMaybe<StringQueryOperatorInput>;
  pluginName?: InputMaybe<StringQueryOperatorInput>;
  originalAbsoluteFilePath?: InputMaybe<StringQueryOperatorInput>;
  originalRelativeFilePath?: InputMaybe<StringQueryOperatorInput>;
  relativeCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
  absoluteCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type SiteFunctionGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<SiteFunctionEdge>;
  nodes: Array<SiteFunction>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SiteFunctionGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type SiteFunctionGroupConnectionDistinctArgs = {
  field: SiteFunctionFieldsEnum;
};


export type SiteFunctionGroupConnectionMaxArgs = {
  field: SiteFunctionFieldsEnum;
};


export type SiteFunctionGroupConnectionMinArgs = {
  field: SiteFunctionFieldsEnum;
};


export type SiteFunctionGroupConnectionSumArgs = {
  field: SiteFunctionFieldsEnum;
};


export type SiteFunctionGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: SiteFunctionFieldsEnum;
};

export type SiteFunctionSortInput = {
  fields?: InputMaybe<Array<InputMaybe<SiteFunctionFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type SiteGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<SiteEdge>;
  nodes: Array<Site>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SiteGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type SiteGroupConnectionDistinctArgs = {
  field: SiteFieldsEnum;
};


export type SiteGroupConnectionMaxArgs = {
  field: SiteFieldsEnum;
};


export type SiteGroupConnectionMinArgs = {
  field: SiteFieldsEnum;
};


export type SiteGroupConnectionSumArgs = {
  field: SiteFieldsEnum;
};


export type SiteGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: SiteFieldsEnum;
};

export type SitePage = Node & {
  path: Scalars['String'];
  component: Scalars['String'];
  internalComponentName: Scalars['String'];
  componentChunkName: Scalars['String'];
  matchPath?: Maybe<Scalars['String']>;
  pageContext?: Maybe<Scalars['JSON']>;
  pluginCreator?: Maybe<SitePlugin>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type SitePageConnection = {
  totalCount: Scalars['Int'];
  edges: Array<SitePageEdge>;
  nodes: Array<SitePage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SitePageGroupConnection>;
};


export type SitePageConnectionDistinctArgs = {
  field: SitePageFieldsEnum;
};


export type SitePageConnectionMaxArgs = {
  field: SitePageFieldsEnum;
};


export type SitePageConnectionMinArgs = {
  field: SitePageFieldsEnum;
};


export type SitePageConnectionSumArgs = {
  field: SitePageFieldsEnum;
};


export type SitePageConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: SitePageFieldsEnum;
};

export type SitePageEdge = {
  next?: Maybe<SitePage>;
  node: SitePage;
  previous?: Maybe<SitePage>;
};

export enum SitePageFieldsEnum {
  path = 'path',
  component = 'component',
  internalComponentName = 'internalComponentName',
  componentChunkName = 'componentChunkName',
  matchPath = 'matchPath',
  pageContext = 'pageContext',
  pluginCreator___resolve = 'pluginCreator___resolve',
  pluginCreator___name = 'pluginCreator___name',
  pluginCreator___version = 'pluginCreator___version',
  pluginCreator___nodeAPIs = 'pluginCreator___nodeAPIs',
  pluginCreator___browserAPIs = 'pluginCreator___browserAPIs',
  pluginCreator___ssrAPIs = 'pluginCreator___ssrAPIs',
  pluginCreator___pluginFilepath = 'pluginCreator___pluginFilepath',
  pluginCreator___pluginOptions = 'pluginCreator___pluginOptions',
  pluginCreator___packageJson = 'pluginCreator___packageJson',
  pluginCreator___id = 'pluginCreator___id',
  pluginCreator___parent___id = 'pluginCreator___parent___id',
  pluginCreator___parent___parent___id = 'pluginCreator___parent___parent___id',
  pluginCreator___parent___parent___children = 'pluginCreator___parent___parent___children',
  pluginCreator___parent___children = 'pluginCreator___parent___children',
  pluginCreator___parent___children___id = 'pluginCreator___parent___children___id',
  pluginCreator___parent___children___children = 'pluginCreator___parent___children___children',
  pluginCreator___parent___internal___content = 'pluginCreator___parent___internal___content',
  pluginCreator___parent___internal___contentDigest = 'pluginCreator___parent___internal___contentDigest',
  pluginCreator___parent___internal___description = 'pluginCreator___parent___internal___description',
  pluginCreator___parent___internal___fieldOwners = 'pluginCreator___parent___internal___fieldOwners',
  pluginCreator___parent___internal___ignoreType = 'pluginCreator___parent___internal___ignoreType',
  pluginCreator___parent___internal___mediaType = 'pluginCreator___parent___internal___mediaType',
  pluginCreator___parent___internal___owner = 'pluginCreator___parent___internal___owner',
  pluginCreator___parent___internal___type = 'pluginCreator___parent___internal___type',
  pluginCreator___children = 'pluginCreator___children',
  pluginCreator___children___id = 'pluginCreator___children___id',
  pluginCreator___children___parent___id = 'pluginCreator___children___parent___id',
  pluginCreator___children___parent___children = 'pluginCreator___children___parent___children',
  pluginCreator___children___children = 'pluginCreator___children___children',
  pluginCreator___children___children___id = 'pluginCreator___children___children___id',
  pluginCreator___children___children___children = 'pluginCreator___children___children___children',
  pluginCreator___children___internal___content = 'pluginCreator___children___internal___content',
  pluginCreator___children___internal___contentDigest = 'pluginCreator___children___internal___contentDigest',
  pluginCreator___children___internal___description = 'pluginCreator___children___internal___description',
  pluginCreator___children___internal___fieldOwners = 'pluginCreator___children___internal___fieldOwners',
  pluginCreator___children___internal___ignoreType = 'pluginCreator___children___internal___ignoreType',
  pluginCreator___children___internal___mediaType = 'pluginCreator___children___internal___mediaType',
  pluginCreator___children___internal___owner = 'pluginCreator___children___internal___owner',
  pluginCreator___children___internal___type = 'pluginCreator___children___internal___type',
  pluginCreator___internal___content = 'pluginCreator___internal___content',
  pluginCreator___internal___contentDigest = 'pluginCreator___internal___contentDigest',
  pluginCreator___internal___description = 'pluginCreator___internal___description',
  pluginCreator___internal___fieldOwners = 'pluginCreator___internal___fieldOwners',
  pluginCreator___internal___ignoreType = 'pluginCreator___internal___ignoreType',
  pluginCreator___internal___mediaType = 'pluginCreator___internal___mediaType',
  pluginCreator___internal___owner = 'pluginCreator___internal___owner',
  pluginCreator___internal___type = 'pluginCreator___internal___type',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type SitePageFilterInput = {
  path?: InputMaybe<StringQueryOperatorInput>;
  component?: InputMaybe<StringQueryOperatorInput>;
  internalComponentName?: InputMaybe<StringQueryOperatorInput>;
  componentChunkName?: InputMaybe<StringQueryOperatorInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  pageContext?: InputMaybe<JsonQueryOperatorInput>;
  pluginCreator?: InputMaybe<SitePluginFilterInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type SitePageGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<SitePageEdge>;
  nodes: Array<SitePage>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SitePageGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type SitePageGroupConnectionDistinctArgs = {
  field: SitePageFieldsEnum;
};


export type SitePageGroupConnectionMaxArgs = {
  field: SitePageFieldsEnum;
};


export type SitePageGroupConnectionMinArgs = {
  field: SitePageFieldsEnum;
};


export type SitePageGroupConnectionSumArgs = {
  field: SitePageFieldsEnum;
};


export type SitePageGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: SitePageFieldsEnum;
};

export type SitePageSortInput = {
  fields?: InputMaybe<Array<InputMaybe<SitePageFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type SitePlugin = Node & {
  resolve?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  nodeAPIs?: Maybe<Array<Maybe<Scalars['String']>>>;
  browserAPIs?: Maybe<Array<Maybe<Scalars['String']>>>;
  ssrAPIs?: Maybe<Array<Maybe<Scalars['String']>>>;
  pluginFilepath?: Maybe<Scalars['String']>;
  pluginOptions?: Maybe<Scalars['JSON']>;
  packageJson?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  parent?: Maybe<Node>;
  children: Array<Node>;
  internal: Internal;
};

export type SitePluginConnection = {
  totalCount: Scalars['Int'];
  edges: Array<SitePluginEdge>;
  nodes: Array<SitePlugin>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SitePluginGroupConnection>;
};


export type SitePluginConnectionDistinctArgs = {
  field: SitePluginFieldsEnum;
};


export type SitePluginConnectionMaxArgs = {
  field: SitePluginFieldsEnum;
};


export type SitePluginConnectionMinArgs = {
  field: SitePluginFieldsEnum;
};


export type SitePluginConnectionSumArgs = {
  field: SitePluginFieldsEnum;
};


export type SitePluginConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: SitePluginFieldsEnum;
};

export type SitePluginEdge = {
  next?: Maybe<SitePlugin>;
  node: SitePlugin;
  previous?: Maybe<SitePlugin>;
};

export enum SitePluginFieldsEnum {
  resolve = 'resolve',
  name = 'name',
  version = 'version',
  nodeAPIs = 'nodeAPIs',
  browserAPIs = 'browserAPIs',
  ssrAPIs = 'ssrAPIs',
  pluginFilepath = 'pluginFilepath',
  pluginOptions = 'pluginOptions',
  packageJson = 'packageJson',
  id = 'id',
  parent___id = 'parent___id',
  parent___parent___id = 'parent___parent___id',
  parent___parent___parent___id = 'parent___parent___parent___id',
  parent___parent___parent___children = 'parent___parent___parent___children',
  parent___parent___children = 'parent___parent___children',
  parent___parent___children___id = 'parent___parent___children___id',
  parent___parent___children___children = 'parent___parent___children___children',
  parent___parent___internal___content = 'parent___parent___internal___content',
  parent___parent___internal___contentDigest = 'parent___parent___internal___contentDigest',
  parent___parent___internal___description = 'parent___parent___internal___description',
  parent___parent___internal___fieldOwners = 'parent___parent___internal___fieldOwners',
  parent___parent___internal___ignoreType = 'parent___parent___internal___ignoreType',
  parent___parent___internal___mediaType = 'parent___parent___internal___mediaType',
  parent___parent___internal___owner = 'parent___parent___internal___owner',
  parent___parent___internal___type = 'parent___parent___internal___type',
  parent___children = 'parent___children',
  parent___children___id = 'parent___children___id',
  parent___children___parent___id = 'parent___children___parent___id',
  parent___children___parent___children = 'parent___children___parent___children',
  parent___children___children = 'parent___children___children',
  parent___children___children___id = 'parent___children___children___id',
  parent___children___children___children = 'parent___children___children___children',
  parent___children___internal___content = 'parent___children___internal___content',
  parent___children___internal___contentDigest = 'parent___children___internal___contentDigest',
  parent___children___internal___description = 'parent___children___internal___description',
  parent___children___internal___fieldOwners = 'parent___children___internal___fieldOwners',
  parent___children___internal___ignoreType = 'parent___children___internal___ignoreType',
  parent___children___internal___mediaType = 'parent___children___internal___mediaType',
  parent___children___internal___owner = 'parent___children___internal___owner',
  parent___children___internal___type = 'parent___children___internal___type',
  parent___internal___content = 'parent___internal___content',
  parent___internal___contentDigest = 'parent___internal___contentDigest',
  parent___internal___description = 'parent___internal___description',
  parent___internal___fieldOwners = 'parent___internal___fieldOwners',
  parent___internal___ignoreType = 'parent___internal___ignoreType',
  parent___internal___mediaType = 'parent___internal___mediaType',
  parent___internal___owner = 'parent___internal___owner',
  parent___internal___type = 'parent___internal___type',
  children = 'children',
  children___id = 'children___id',
  children___parent___id = 'children___parent___id',
  children___parent___parent___id = 'children___parent___parent___id',
  children___parent___parent___children = 'children___parent___parent___children',
  children___parent___children = 'children___parent___children',
  children___parent___children___id = 'children___parent___children___id',
  children___parent___children___children = 'children___parent___children___children',
  children___parent___internal___content = 'children___parent___internal___content',
  children___parent___internal___contentDigest = 'children___parent___internal___contentDigest',
  children___parent___internal___description = 'children___parent___internal___description',
  children___parent___internal___fieldOwners = 'children___parent___internal___fieldOwners',
  children___parent___internal___ignoreType = 'children___parent___internal___ignoreType',
  children___parent___internal___mediaType = 'children___parent___internal___mediaType',
  children___parent___internal___owner = 'children___parent___internal___owner',
  children___parent___internal___type = 'children___parent___internal___type',
  children___children = 'children___children',
  children___children___id = 'children___children___id',
  children___children___parent___id = 'children___children___parent___id',
  children___children___parent___children = 'children___children___parent___children',
  children___children___children = 'children___children___children',
  children___children___children___id = 'children___children___children___id',
  children___children___children___children = 'children___children___children___children',
  children___children___internal___content = 'children___children___internal___content',
  children___children___internal___contentDigest = 'children___children___internal___contentDigest',
  children___children___internal___description = 'children___children___internal___description',
  children___children___internal___fieldOwners = 'children___children___internal___fieldOwners',
  children___children___internal___ignoreType = 'children___children___internal___ignoreType',
  children___children___internal___mediaType = 'children___children___internal___mediaType',
  children___children___internal___owner = 'children___children___internal___owner',
  children___children___internal___type = 'children___children___internal___type',
  children___internal___content = 'children___internal___content',
  children___internal___contentDigest = 'children___internal___contentDigest',
  children___internal___description = 'children___internal___description',
  children___internal___fieldOwners = 'children___internal___fieldOwners',
  children___internal___ignoreType = 'children___internal___ignoreType',
  children___internal___mediaType = 'children___internal___mediaType',
  children___internal___owner = 'children___internal___owner',
  children___internal___type = 'children___internal___type',
  internal___content = 'internal___content',
  internal___contentDigest = 'internal___contentDigest',
  internal___description = 'internal___description',
  internal___fieldOwners = 'internal___fieldOwners',
  internal___ignoreType = 'internal___ignoreType',
  internal___mediaType = 'internal___mediaType',
  internal___owner = 'internal___owner',
  internal___type = 'internal___type'
}

export type SitePluginFilterInput = {
  resolve?: InputMaybe<StringQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  version?: InputMaybe<StringQueryOperatorInput>;
  nodeAPIs?: InputMaybe<StringQueryOperatorInput>;
  browserAPIs?: InputMaybe<StringQueryOperatorInput>;
  ssrAPIs?: InputMaybe<StringQueryOperatorInput>;
  pluginFilepath?: InputMaybe<StringQueryOperatorInput>;
  pluginOptions?: InputMaybe<JsonQueryOperatorInput>;
  packageJson?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  internal?: InputMaybe<InternalFilterInput>;
};

export type SitePluginGroupConnection = {
  totalCount: Scalars['Int'];
  edges: Array<SitePluginEdge>;
  nodes: Array<SitePlugin>;
  pageInfo: PageInfo;
  distinct: Array<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
  group: Array<SitePluginGroupConnection>;
  field: Scalars['String'];
  fieldValue?: Maybe<Scalars['String']>;
};


export type SitePluginGroupConnectionDistinctArgs = {
  field: SitePluginFieldsEnum;
};


export type SitePluginGroupConnectionMaxArgs = {
  field: SitePluginFieldsEnum;
};


export type SitePluginGroupConnectionMinArgs = {
  field: SitePluginFieldsEnum;
};


export type SitePluginGroupConnectionSumArgs = {
  field: SitePluginFieldsEnum;
};


export type SitePluginGroupConnectionGroupArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  field: SitePluginFieldsEnum;
};

export type SitePluginSortInput = {
  fields?: InputMaybe<Array<InputMaybe<SitePluginFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export type SiteSiteMetadata = {
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  author?: Maybe<Scalars['String']>;
  siteUrl?: Maybe<Scalars['String']>;
};

export type SiteSiteMetadataFilterInput = {
  title?: InputMaybe<StringQueryOperatorInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  author?: InputMaybe<StringQueryOperatorInput>;
  siteUrl?: InputMaybe<StringQueryOperatorInput>;
};

export type SiteSortInput = {
  fields?: InputMaybe<Array<InputMaybe<SiteFieldsEnum>>>;
  order?: InputMaybe<Array<InputMaybe<SortOrderEnum>>>;
};

export enum SortOrderEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type StringQueryOperatorInput = {
  eq?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['String']>;
  glob?: InputMaybe<Scalars['String']>;
};

export type TransformOptions = {
  grayscale?: InputMaybe<Scalars['Boolean']>;
  duotone?: InputMaybe<DuotoneGradient>;
  rotate?: InputMaybe<Scalars['Int']>;
  trim?: InputMaybe<Scalars['Float']>;
  cropFocus?: InputMaybe<ImageCropFocus>;
  fit?: InputMaybe<ImageFit>;
};

export type WebPOptions = {
  quality?: InputMaybe<Scalars['Int']>;
};

export type PrismicAcademyPageFragmentFragment = { _previewable: string, url?: Maybe<string>, uid: string, type: string, id: string, prismicId: string, lang: string, alternate_languages: Array<{ id?: Maybe<string>, type?: Maybe<string>, lang?: Maybe<string>, uid?: Maybe<string> }>, data: { title?: Maybe<{ text?: Maybe<string> }>, body: Array<{ id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background_image_position?: Maybe<string>, image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { rich_text?: Maybe<{ richText: any }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { text?: Maybe<{ text?: Maybe<string> }>, heading?: Maybe<{ text?: Maybe<string> }> } }>, metadata_image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string> }>, metadata_description?: Maybe<{ text?: Maybe<string> }>, metadata_title?: Maybe<{ text?: Maybe<string> }> } };

export type PrismicAcademySitemapFragmentFragment = { _previewable: string, data: { top_level_pages?: Maybe<Array<Maybe<{ doc_page?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, body: Array<{ id: string, primary: { name?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ doc_page?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }> }> } };

export type PrismicBannerFragmentFragment = { type: string, data: { show?: Maybe<boolean>, text?: Maybe<{ richText: any }> } };

export type PrismicAuthorFragmentFragment = { id: string, prismicId: string, data: { first_name?: Maybe<{ text?: Maybe<string> }>, last_name?: Maybe<{ text?: Maybe<string> }>, position?: Maybe<{ text?: Maybe<string> }>, picture?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string> }> } };

export type PrismicBlogPageFragmentFragment = { _previewable: string, url?: Maybe<string>, uid: string, type: string, id: string, prismicId: string, lang: string, last_publication_date: any, first_publication_date: any, tags: Array<string>, alternate_languages: Array<{ id?: Maybe<string>, type?: Maybe<string>, lang?: Maybe<string>, uid?: Maybe<string> }>, data: { publish_date?: Maybe<any>, title?: Maybe<{ text?: Maybe<string> }>, subtitle?: Maybe<{ text?: Maybe<string> }>, metadata_image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }>, authors?: Maybe<Array<Maybe<{ author?: Maybe<{ id?: Maybe<string>, uid?: Maybe<string> }> }>>>, body: Array<{ id: string, slice_type: string, slice_label?: Maybe<string>, primary: { image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string> }>, caption?: Maybe<{ text?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { embed?: Maybe<{ id: string }>, caption?: Maybe<{ text?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }>, caption?: Maybe<{ text?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { content?: Maybe<{ richText: any, text?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { caption?: Maybe<{ richText: any }> }, items: Array<{ image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> }> } | { id: string, slice_label?: Maybe<string>, slice_type: string }> } };

export type PrismicBlogFeedFragmentFragment = { data: { metadata_title?: Maybe<{ text?: Maybe<string> }>, metadata_image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string> }>, metadata_description?: Maybe<{ text?: Maybe<string> }>, featured_article_2?: Maybe<{ id?: Maybe<string> }>, featured_article_1?: Maybe<{ id?: Maybe<string> }> } };

export type PrismicDocPageFragmentFragment = { _previewable: string, url?: Maybe<string>, uid: string, type: string, id: string, prismicId: string, lang: string, alternate_languages: Array<{ id?: Maybe<string>, type?: Maybe<string>, lang?: Maybe<string>, uid?: Maybe<string> }>, data: { title?: Maybe<{ text?: Maybe<string> }>, body: Array<{ id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background_image_position?: Maybe<string>, image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { rich_text?: Maybe<{ richText: any }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { text?: Maybe<{ text?: Maybe<string> }>, heading?: Maybe<{ text?: Maybe<string> }> } }>, metadata_image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string> }>, metadata_description?: Maybe<{ text?: Maybe<string> }>, metadata_title?: Maybe<{ text?: Maybe<string> }> } };

export type PrismicDocsSitemapFragmentFragment = { _previewable: string, data: { top_level_pages?: Maybe<Array<Maybe<{ doc_page?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, body: Array<{ id: string, primary: { name?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ doc_page?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }> }> } };

export type FooterFragmentFragment = { type: string, data: { cta_button_label?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_button_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, column1_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column1_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column2_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column2_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column3_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column3_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>> } };

export type NavFragmentFragment = { _previewable: string, type: string, data: { is_in_beta?: Maybe<boolean>, primary_cta_label?: Maybe<string>, secondary_cta_label?: Maybe<string>, primary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, secondary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, links: Array<{ id: string, slice_label?: Maybe<string>, slice_type: string, primary: { label?: Maybe<{ text?: Maybe<string> }>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, sub_nav_cta_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }, items: Array<{ sub_nav_description?: Maybe<string>, sub_nav_link_icon?: Maybe<string>, sub_nav_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }> }> } };

export type PrismicPricingPageFragmentFragment = { _previewable: string, id: string, prismicId: string, type: string, url?: Maybe<string>, lang: string, alternate_languages: Array<{ id?: Maybe<string>, lang?: Maybe<string>, type?: Maybe<string> }>, data: { default_billing_annual?: Maybe<boolean>, page_title?: Maybe<{ text?: Maybe<string> }>, page_image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }>, page_description?: Maybe<{ text?: Maybe<string> }>, title?: Maybe<{ text?: Maybe<string> }>, billing_label?: Maybe<{ text?: Maybe<string> }>, body: Array<{ id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background?: Maybe<string>, primary_cta_icon?: Maybe<string>, primary_cta_label?: Maybe<string>, secondary_cta_icon?: Maybe<string>, secondary_cta_label?: Maybe<string>, vertical_margin?: Maybe<string>, heading?: Maybe<{ text?: Maybe<string> }>, primary_cta_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, secondary_cta_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { cta_icon?: Maybe<string>, title?: Maybe<{ text?: Maybe<string> }>, cta_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, cta_label?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ question?: Maybe<{ text?: Maybe<string> }>, answer?: Maybe<{ richText: any }> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background?: Maybe<string>, vertical_margin?: Maybe<string>, headline?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ body?: Maybe<{ text?: Maybe<string> }>, heading?: Maybe<{ text?: Maybe<string> }>, image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { category_title?: Maybe<{ text?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { title?: Maybe<{ text?: Maybe<string> }>, tooltip?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ is_boolean?: Maybe<boolean>, boolean?: Maybe<boolean>, plan?: Maybe<{ id?: Maybe<string> }>, text?: Maybe<{ richText: any }> }> }> } };

export type PrismicPricingPlanFragmentFragment = { id: string, prismicId: string, type: string, data: { pricing_type?: Maybe<string>, monthly_cost?: Maybe<number>, annual_cost?: Maybe<number>, monthly_range_minimum?: Maybe<number>, monthly_range_maximum?: Maybe<number>, annual_range_minimum?: Maybe<number>, annual_range_maximum?: Maybe<number>, recommended?: Maybe<boolean>, title?: Maybe<{ text?: Maybe<string> }>, pricing_text?: Maybe<{ text?: Maybe<string> }>, cta_text?: Maybe<{ text?: Maybe<string> }>, cta_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, pricing_description?: Maybe<{ text?: Maybe<string> }>, pricing_description_tooltip?: Maybe<{ text?: Maybe<string> }>, recommended_for?: Maybe<{ richText: any }> } };

export type Unnamed_1_QueryVariables = Exact<{ [key: string]: never; }>;


export type Unnamed_1_Query = { site?: Maybe<{ siteMetadata?: Maybe<{ title?: Maybe<string>, description?: Maybe<string>, author?: Maybe<string> }> }> };

export type PrismicMarketingCardsSectionFragmentFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { vertical_margin?: Maybe<string>, background?: Maybe<string>, headline_position?: Maybe<string>, number_of_columns?: Maybe<string>, card_text_position?: Maybe<string>, primary_cta_label?: Maybe<string>, secondary_cta_label?: Maybe<string>, headline?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, description?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, primary_cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }>, secondary_cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> }, items: Array<{ card_heading?: Maybe<string>, card_body?: Maybe<string>, card_link_label?: Maybe<string>, card_image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ width: number, height: number }> }>, card_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> }> };

export type PrismicPartnerCardsSectionFragmentFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { vertical_margin?: Maybe<string>, background?: Maybe<string>, headline_position?: Maybe<string>, number_of_columns?: Maybe<string>, card_text_position?: Maybe<string>, primary_cta_label?: Maybe<string>, secondary_cta_label?: Maybe<string>, headline?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, description?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, primary_cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }>, secondary_cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> }, items: Array<{ card_heading?: Maybe<string>, card_body?: Maybe<string>, card_link_label?: Maybe<string>, card_image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ width: number, height: number }> }>, card_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> }> };

export type PrismicMarketingCustomerLogosFragmentFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { eyebrow_headline?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }> }, items: Array<{ logo?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ width: number, height: number }> }>, link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> }> };

export type PrismicPartnerCustomerLogosFragmentFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { eyebrow_headline?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }> }, items: Array<{ logo?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ width: number, height: number }> }>, link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> }> };

export type FullWidthImageFragmentFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { vertical_margin?: Maybe<string>, background?: Maybe<string>, subheading_position?: Maybe<string>, cta_label?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }>, image?: Maybe<{ alt?: Maybe<string>, copyright?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ height: number, width: number }> }>, gradient_image?: Maybe<{ alt?: Maybe<string>, copyright?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ height: number, width: number }> }>, mobile_image?: Maybe<{ alt?: Maybe<string>, copyright?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ height: number, width: number }> }>, mobile_gradient_image?: Maybe<{ alt?: Maybe<string>, copyright?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ height: number, width: number }> }> }, items: Array<{ list_item?: Maybe<string> }> };

export type PrismicHomepageInfoWithImageFragmentFragment = { id: string, slice_label?: Maybe<string>, slice_type: string, primary: { vertical_margin?: Maybe<string>, background?: Maybe<string>, featured_image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string> }>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, primary_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, primary_link_text?: Maybe<{ richText: any }> }, items: Array<{ list_item?: Maybe<string> }> };

export type PrismicMarketingPageInfoWithImageFragmentFragment = { id: string, slice_label?: Maybe<string>, slice_type: string, primary: { vertical_margin?: Maybe<string>, background?: Maybe<string>, featured_image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string> }>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, primary_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, primary_link_text?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ list_item?: Maybe<string> }> };

export type PrismicMarketingPartnerFragmentFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, items: Array<{ logos?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> }>, primary: { expiration_datetime?: Maybe<any>, card_customer_text?: Maybe<{ text?: Maybe<string> }>, card_subtitle?: Maybe<{ text?: Maybe<string> }>, card_title?: Maybe<{ text?: Maybe<string> }>, text_after_expiration?: Maybe<{ richText: any }>, fine_print?: Maybe<{ richText: any }>, main_text?: Maybe<{ richText: any }>, primary_button_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, primary_button_text?: Maybe<{ text?: Maybe<string> }>, secondary_button_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, secondary_button_text?: Maybe<{ text?: Maybe<string> }> } };

export type PrismicPartnerFragmentFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, items: Array<{ logos?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> }>, primary: { expiration_datetime?: Maybe<any>, card_customer_text?: Maybe<{ text?: Maybe<string> }>, card_subtitle?: Maybe<{ text?: Maybe<string> }>, card_title?: Maybe<{ text?: Maybe<string> }>, text_after_expiration?: Maybe<{ richText: any }>, fine_print?: Maybe<{ richText: any }>, main_text?: Maybe<{ richText: any }>, primary_button_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, primary_button_text?: Maybe<{ text?: Maybe<string> }>, secondary_button_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, secondary_button_text?: Maybe<{ text?: Maybe<string> }> } };

export type MarketingPricingCardFragmentFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background?: Maybe<string>, vertical_margin?: Maybe<string>, card_price_per_month?: Maybe<number>, gradient_image?: Maybe<{ url?: Maybe<string> }>, mobile_gradient_image?: Maybe<{ url?: Maybe<string> }>, heading?: Maybe<{ richText: any, text?: Maybe<string> }>, description?: Maybe<{ richText: any, text?: Maybe<string> }>, button_text?: Maybe<{ text?: Maybe<string> }>, button_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, more_text?: Maybe<{ richText: any }>, card_heading?: Maybe<{ richText: any, text?: Maybe<string> }>, card_price_subtitle?: Maybe<{ richText: any, text?: Maybe<string> }>, card_button_text?: Maybe<{ text?: Maybe<string> }>, card_button_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }> }, items: Array<{ card_recommended_for?: Maybe<{ text?: Maybe<string> }> }> };

export type PricingFaqSliceFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { cta_icon?: Maybe<string>, title?: Maybe<{ text?: Maybe<string> }>, cta_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, cta_label?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ question?: Maybe<{ text?: Maybe<string> }>, answer?: Maybe<{ richText: any }> }> };

export type PricingGridPricingSliceFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background?: Maybe<string>, vertical_margin?: Maybe<string>, headline?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ body?: Maybe<{ text?: Maybe<string> }>, heading?: Maybe<{ text?: Maybe<string> }>, image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> }> };

export type PricingGridMarketingSliceFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background?: Maybe<string>, vertical_margin?: Maybe<string>, headline?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ body?: Maybe<{ text?: Maybe<string> }>, heading?: Maybe<{ text?: Maybe<string> }>, image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> }> };

export type SideBySideImagesSliceFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { caption?: Maybe<{ richText: any }> }, items: Array<{ image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> }> };

export type StackedInfoWithImageFragmentFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { vertical_margin?: Maybe<string>, background?: Maybe<string>, heading?: Maybe<{ text?: Maybe<string> }>, description?: Maybe<{ richText: any, html?: Maybe<string>, text?: Maybe<string> }> }, items: Array<{ list_item_1?: Maybe<string>, list_item_2?: Maybe<string>, list_item_3?: Maybe<string>, featured_image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }>, heading?: Maybe<{ text?: Maybe<string> }>, subheading?: Maybe<{ text?: Maybe<string>, richText: any }> }> };

export type PrismicMarketingTestimonialCarouselFragmentFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background?: Maybe<string>, heading?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ author_name?: Maybe<string>, author_title?: Maybe<string>, quote?: Maybe<string>, image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> }> };

export type PrismicHomepageTestimonialCarouselFragmentFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background?: Maybe<string>, heading?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ author_name?: Maybe<string>, author_title?: Maybe<string>, quote?: Maybe<string>, image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> }> };

export type PrismicPartnerTestimonialCarouselFragmentFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background?: Maybe<string>, heading?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ author_name?: Maybe<string>, author_title?: Maybe<string>, quote?: Maybe<string>, image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> }> };

export type TextWithReferencesSliceFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { text?: Maybe<{ richText: any }> }, items: Array<{ references?: Maybe<{ richText: any }> }> };

export type TextWithReferencesLtvSliceFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { text?: Maybe<{ richText: any }> }, items: Array<{ references?: Maybe<{ richText: any }> }> };

export type PrismicMarketingWistiaVideoAndTextSideBySideFragmentFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background?: Maybe<string>, vertical_margin?: Maybe<string>, is_video_on_right?: Maybe<boolean>, gradient_image?: Maybe<{ url?: Maybe<string> }>, mobile_gradient_image?: Maybe<{ url?: Maybe<string> }>, wistia_video_url?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, title?: Maybe<{ richText: any }>, description?: Maybe<{ richText: any }> }, items: Array<{ green_check_list_item?: Maybe<{ richText: any }> }> };

export type PrismicPartnerWistiaVideoAndTextSideBySideFragmentFragment = { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background?: Maybe<string>, vertical_margin?: Maybe<string>, is_video_on_right?: Maybe<boolean>, gradient_image?: Maybe<{ url?: Maybe<string> }>, mobile_gradient_image?: Maybe<{ url?: Maybe<string> }>, wistia_video_url?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, title?: Maybe<{ richText: any }>, description?: Maybe<{ richText: any }> }, items: Array<{ green_check_list_item?: Maybe<{ richText: any }> }> };

export type NotFoundPageQueryVariables = Exact<{
  lang?: Maybe<Scalars['String']>;
}>;


export type NotFoundPageQuery = { prismicNav?: Maybe<{ _previewable: string, type: string, data: { is_in_beta?: Maybe<boolean>, primary_cta_label?: Maybe<string>, secondary_cta_label?: Maybe<string>, primary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, secondary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, links: Array<{ id: string, slice_label?: Maybe<string>, slice_type: string, primary: { label?: Maybe<{ text?: Maybe<string> }>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, sub_nav_cta_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }, items: Array<{ sub_nav_description?: Maybe<string>, sub_nav_link_icon?: Maybe<string>, sub_nav_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }> }> } }>, prismicFooter?: Maybe<{ type: string, data: { cta_button_label?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_button_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, column1_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column1_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column2_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column2_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column3_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column3_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>> } }>, prismicBanner?: Maybe<{ type: string, data: { show?: Maybe<boolean>, text?: Maybe<{ richText: any }> } }> };

export type AcademyIndexQueryQueryVariables = Exact<{
  lang?: Maybe<Scalars['String']>;
}>;


export type AcademyIndexQueryQuery = { prismicAcademySitemap?: Maybe<{ data: { top_level_pages?: Maybe<Array<Maybe<{ doc_page?: Maybe<{ url?: Maybe<string> }> }>>>, body: Array<{ id: string, items: Array<{ doc_page?: Maybe<{ url?: Maybe<string> }> }> }> } }> };

export type DocIndexQueryQueryVariables = Exact<{
  lang?: Maybe<Scalars['String']>;
}>;


export type DocIndexQueryQuery = { prismicDocsSitemap?: Maybe<{ data: { top_level_pages?: Maybe<Array<Maybe<{ doc_page?: Maybe<{ url?: Maybe<string> }> }>>>, body: Array<{ id: string, items: Array<{ doc_page?: Maybe<{ url?: Maybe<string> }> }> }> } }> };

export type LtvCalculatorQueryVariables = Exact<{
  lang?: Maybe<Scalars['String']>;
}>;


export type LtvCalculatorQuery = { prismicLtvCalculator?: Maybe<{ _previewable: string, id: string, prismicId: string, type: string, data: { page_title?: Maybe<{ text?: Maybe<string> }>, page_description?: Maybe<{ text?: Maybe<string> }>, page_image?: Maybe<{ url?: Maybe<string> }>, body: Array<{ id: string, slice_type: string, slice_label?: Maybe<string>, primary: { text?: Maybe<{ richText: any }> }, items: Array<{ references?: Maybe<{ richText: any }> }> }> } }>, prismicNav?: Maybe<{ _previewable: string, type: string, data: { is_in_beta?: Maybe<boolean>, primary_cta_label?: Maybe<string>, secondary_cta_label?: Maybe<string>, primary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, secondary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, links: Array<{ id: string, slice_label?: Maybe<string>, slice_type: string, primary: { label?: Maybe<{ text?: Maybe<string> }>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, sub_nav_cta_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }, items: Array<{ sub_nav_description?: Maybe<string>, sub_nav_link_icon?: Maybe<string>, sub_nav_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }> }> } }>, prismicFooter?: Maybe<{ type: string, data: { cta_button_label?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_button_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, column1_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column1_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column2_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column2_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column3_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column3_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>> } }>, prismicBanner?: Maybe<{ type: string, data: { show?: Maybe<boolean>, text?: Maybe<{ richText: any }> } }> };

export type GrowthCalculatorQueryVariables = Exact<{
  lang?: Maybe<Scalars['String']>;
}>;


export type GrowthCalculatorQuery = { prismicGrowthCalculator?: Maybe<{ _previewable: string, id: string, prismicId: string, type: string, data: { page_title?: Maybe<{ text?: Maybe<string> }>, page_description?: Maybe<{ text?: Maybe<string> }>, page_image?: Maybe<{ url?: Maybe<string> }>, body: Array<{ id: string, slice_type: string, slice_label?: Maybe<string>, primary: { text?: Maybe<{ richText: any }> }, items: Array<{ references?: Maybe<{ richText: any }> }> }> } }>, prismicNav?: Maybe<{ _previewable: string, type: string, data: { is_in_beta?: Maybe<boolean>, primary_cta_label?: Maybe<string>, secondary_cta_label?: Maybe<string>, primary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, secondary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, links: Array<{ id: string, slice_label?: Maybe<string>, slice_type: string, primary: { label?: Maybe<{ text?: Maybe<string> }>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, sub_nav_cta_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }, items: Array<{ sub_nav_description?: Maybe<string>, sub_nav_link_icon?: Maybe<string>, sub_nav_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }> }> } }>, prismicFooter?: Maybe<{ type: string, data: { cta_button_label?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_button_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, column1_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column1_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column2_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column2_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column3_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column3_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>> } }>, prismicBanner?: Maybe<{ type: string, data: { show?: Maybe<boolean>, text?: Maybe<{ richText: any }> } }> };

export type AcademyPageTemplateQueryVariables = Exact<{
  uid?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
}>;


export type AcademyPageTemplateQuery = { prismicAcademyPage?: Maybe<{ _previewable: string, url?: Maybe<string>, uid: string, type: string, id: string, prismicId: string, lang: string, alternate_languages: Array<{ id?: Maybe<string>, type?: Maybe<string>, lang?: Maybe<string>, uid?: Maybe<string> }>, data: { title?: Maybe<{ text?: Maybe<string> }>, body: Array<{ id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background_image_position?: Maybe<string>, image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { rich_text?: Maybe<{ richText: any }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { text?: Maybe<{ text?: Maybe<string> }>, heading?: Maybe<{ text?: Maybe<string> }> } }>, metadata_image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string> }>, metadata_description?: Maybe<{ text?: Maybe<string> }>, metadata_title?: Maybe<{ text?: Maybe<string> }> } }>, prismicFooter?: Maybe<{ type: string, data: { cta_button_label?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_button_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, column1_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column1_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column2_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column2_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column3_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column3_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>> } }>, prismicBanner?: Maybe<{ type: string, data: { show?: Maybe<boolean>, text?: Maybe<{ richText: any }> } }> };

export type BlogFeedTemplateQueryVariables = Exact<{
  lang?: Maybe<Scalars['String']>;
}>;


export type BlogFeedTemplateQuery = { prismicBlogFeed?: Maybe<{ data: { metadata_title?: Maybe<{ text?: Maybe<string> }>, metadata_image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string> }>, metadata_description?: Maybe<{ text?: Maybe<string> }>, featured_article_2?: Maybe<{ id?: Maybe<string> }>, featured_article_1?: Maybe<{ id?: Maybe<string> }> } }>, prismicNav?: Maybe<{ _previewable: string, type: string, data: { is_in_beta?: Maybe<boolean>, primary_cta_label?: Maybe<string>, secondary_cta_label?: Maybe<string>, primary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, secondary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, links: Array<{ id: string, slice_label?: Maybe<string>, slice_type: string, primary: { label?: Maybe<{ text?: Maybe<string> }>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, sub_nav_cta_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }, items: Array<{ sub_nav_description?: Maybe<string>, sub_nav_link_icon?: Maybe<string>, sub_nav_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }> }> } }>, prismicFooter?: Maybe<{ type: string, data: { cta_button_label?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_button_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, column1_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column1_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column2_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column2_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column3_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column3_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>> } }>, prismicBanner?: Maybe<{ type: string, data: { show?: Maybe<boolean>, text?: Maybe<{ richText: any }> } }> };

export type BlogPageTemplateQueryVariables = Exact<{
  uid?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
}>;


export type BlogPageTemplateQuery = { prismicBlogPage?: Maybe<{ _previewable: string, url?: Maybe<string>, uid: string, type: string, id: string, prismicId: string, lang: string, last_publication_date: any, first_publication_date: any, tags: Array<string>, alternate_languages: Array<{ id?: Maybe<string>, type?: Maybe<string>, lang?: Maybe<string>, uid?: Maybe<string> }>, data: { publish_date?: Maybe<any>, title?: Maybe<{ text?: Maybe<string> }>, subtitle?: Maybe<{ text?: Maybe<string> }>, metadata_image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }>, authors?: Maybe<Array<Maybe<{ author?: Maybe<{ id?: Maybe<string>, uid?: Maybe<string> }> }>>>, body: Array<{ id: string, slice_type: string, slice_label?: Maybe<string>, primary: { image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string> }>, caption?: Maybe<{ text?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { embed?: Maybe<{ id: string }>, caption?: Maybe<{ text?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }>, caption?: Maybe<{ text?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { content?: Maybe<{ richText: any, text?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { caption?: Maybe<{ richText: any }> }, items: Array<{ image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> }> } | { id: string, slice_label?: Maybe<string>, slice_type: string }> } }>, prismicNav?: Maybe<{ _previewable: string, type: string, data: { is_in_beta?: Maybe<boolean>, primary_cta_label?: Maybe<string>, secondary_cta_label?: Maybe<string>, primary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, secondary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, links: Array<{ id: string, slice_label?: Maybe<string>, slice_type: string, primary: { label?: Maybe<{ text?: Maybe<string> }>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, sub_nav_cta_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }, items: Array<{ sub_nav_description?: Maybe<string>, sub_nav_link_icon?: Maybe<string>, sub_nav_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }> }> } }>, prismicFooter?: Maybe<{ type: string, data: { cta_button_label?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_button_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, column1_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column1_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column2_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column2_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column3_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column3_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>> } }>, prismicBanner?: Maybe<{ type: string, data: { show?: Maybe<boolean>, text?: Maybe<{ richText: any }> } }> };

export type DocPageTemplateQueryVariables = Exact<{
  uid?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
}>;


export type DocPageTemplateQuery = { prismicDocPage?: Maybe<{ _previewable: string, url?: Maybe<string>, uid: string, type: string, id: string, prismicId: string, lang: string, alternate_languages: Array<{ id?: Maybe<string>, type?: Maybe<string>, lang?: Maybe<string>, uid?: Maybe<string> }>, data: { title?: Maybe<{ text?: Maybe<string> }>, body: Array<{ id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background_image_position?: Maybe<string>, image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { rich_text?: Maybe<{ richText: any }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { text?: Maybe<{ text?: Maybe<string> }>, heading?: Maybe<{ text?: Maybe<string> }> } }>, metadata_image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string> }>, metadata_description?: Maybe<{ text?: Maybe<string> }>, metadata_title?: Maybe<{ text?: Maybe<string> }> } }>, prismicFooter?: Maybe<{ type: string, data: { cta_button_label?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_button_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, column1_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column1_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column2_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column2_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column3_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column3_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>> } }>, prismicBanner?: Maybe<{ type: string, data: { show?: Maybe<boolean>, text?: Maybe<{ richText: any }> } }> };

export type HomepageTemplateQueryVariables = Exact<{
  lang?: Maybe<Scalars['String']>;
}>;


export type HomepageTemplateQuery = { prismicHomepage?: Maybe<{ _previewable: string, url?: Maybe<string>, type: string, id: string, lang: string, alternate_languages: Array<{ id?: Maybe<string>, type?: Maybe<string>, lang?: Maybe<string> }>, data: { page_title?: Maybe<{ text?: Maybe<string> }>, page_description?: Maybe<{ text?: Maybe<string> }>, page_image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string>, dimensions?: Maybe<{ width: number, height: number }> }>, body: Array<{ id: string, slice_type: string, slice_label?: Maybe<string>, primary: { vertical_margin?: Maybe<string>, background?: Maybe<string>, headline_position?: Maybe<string>, number_of_columns?: Maybe<string>, card_text_position?: Maybe<string>, primary_cta_label?: Maybe<string>, secondary_cta_label?: Maybe<string>, headline?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, description?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, primary_cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }>, secondary_cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> }, items: Array<{ card_heading?: Maybe<string>, card_body?: Maybe<string>, card_link_label?: Maybe<string>, card_image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ width: number, height: number }> }>, card_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { vertical_margin?: Maybe<string>, background?: Maybe<string>, primary_cta_label?: Maybe<string>, primary_cta_icon?: Maybe<string>, secondary_cta_label?: Maybe<string>, secondary_cta_icon?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, primary_cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }>, secondary_cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { eyebrow_headline?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }> }, items: Array<{ logo?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ width: number, height: number }> }>, link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { vertical_margin?: Maybe<string>, background?: Maybe<string>, subheading_position?: Maybe<string>, cta_label?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }>, image?: Maybe<{ alt?: Maybe<string>, copyright?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ height: number, width: number }> }>, gradient_image?: Maybe<{ alt?: Maybe<string>, copyright?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ height: number, width: number }> }>, mobile_image?: Maybe<{ alt?: Maybe<string>, copyright?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ height: number, width: number }> }>, mobile_gradient_image?: Maybe<{ alt?: Maybe<string>, copyright?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ height: number, width: number }> }> }, items: Array<{ list_item?: Maybe<string> }> } | { id: string, slice_label?: Maybe<string>, slice_type: string, primary: { section_title?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, text?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }>, cta_text?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, video_link?: Maybe<{ url?: Maybe<string> }> } } | { id: string, slice_label?: Maybe<string>, slice_type: string, primary: { vertical_margin?: Maybe<string>, background?: Maybe<string>, featured_image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string> }>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, primary_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, primary_link_text?: Maybe<{ richText: any }> }, items: Array<{ list_item?: Maybe<string> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { vertical_margin?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, mobile_image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ width: number, height: number }> }> }, items: Array<{ tab_label?: Maybe<string>, iframe_src?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background?: Maybe<string>, heading?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ author_name?: Maybe<string>, author_title?: Maybe<string>, quote?: Maybe<string>, image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { video_link?: Maybe<{ url?: Maybe<string> }> } }> } }>, prismicNav?: Maybe<{ _previewable: string, type: string, data: { is_in_beta?: Maybe<boolean>, primary_cta_label?: Maybe<string>, secondary_cta_label?: Maybe<string>, primary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, secondary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, links: Array<{ id: string, slice_label?: Maybe<string>, slice_type: string, primary: { label?: Maybe<{ text?: Maybe<string> }>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, sub_nav_cta_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }, items: Array<{ sub_nav_description?: Maybe<string>, sub_nav_link_icon?: Maybe<string>, sub_nav_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }> }> } }>, prismicFooter?: Maybe<{ type: string, data: { cta_button_label?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_button_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, column1_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column1_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column2_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column2_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column3_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column3_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>> } }>, prismicBanner?: Maybe<{ type: string, data: { show?: Maybe<boolean>, text?: Maybe<{ richText: any }> } }> };

export type MarketingPageTemplateQueryVariables = Exact<{
  uid?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
}>;


export type MarketingPageTemplateQuery = { prismicMarketingPage?: Maybe<{ _previewable: string, url?: Maybe<string>, type: string, uid: string, id: string, lang: string, alternate_languages: Array<{ id?: Maybe<string>, type?: Maybe<string>, lang?: Maybe<string> }>, data: { page_title?: Maybe<{ text?: Maybe<string> }>, page_description?: Maybe<{ text?: Maybe<string> }>, page_image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string>, dimensions?: Maybe<{ width: number, height: number }> }>, body: Array<{ id: string, slice_type: string, slice_label?: Maybe<string>, primary: { vertical_margin?: Maybe<string>, background?: Maybe<string>, headline_position?: Maybe<string>, number_of_columns?: Maybe<string>, card_text_position?: Maybe<string>, primary_cta_label?: Maybe<string>, secondary_cta_label?: Maybe<string>, headline?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, description?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, primary_cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }>, secondary_cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> }, items: Array<{ card_heading?: Maybe<string>, card_body?: Maybe<string>, card_link_label?: Maybe<string>, card_image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ width: number, height: number }> }>, card_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { vertical_margin?: Maybe<string>, primary_cta_label?: Maybe<string>, primary_cta_icon?: Maybe<string>, secondary_cta_label?: Maybe<string>, secondary_cta_icon?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, primary_cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }>, secondary_cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { eyebrow_headline?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }> }, items: Array<{ logo?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ width: number, height: number }> }>, link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { cta_label?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> }, items: Array<{ question?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, answer?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { vertical_margin?: Maybe<string>, background?: Maybe<string>, subheading_position?: Maybe<string>, cta_label?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }>, image?: Maybe<{ alt?: Maybe<string>, copyright?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ height: number, width: number }> }>, gradient_image?: Maybe<{ alt?: Maybe<string>, copyright?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ height: number, width: number }> }>, mobile_image?: Maybe<{ alt?: Maybe<string>, copyright?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ height: number, width: number }> }>, mobile_gradient_image?: Maybe<{ alt?: Maybe<string>, copyright?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ height: number, width: number }> }> }, items: Array<{ list_item?: Maybe<string> }> } | { id: string, slice_label?: Maybe<string>, slice_type: string, primary: { vertical_margin?: Maybe<string>, background?: Maybe<string>, featured_image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string> }>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, primary_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, primary_link_text?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ list_item?: Maybe<string> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { title?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }> } } | { id: string, slice_label?: Maybe<string>, slice_type: string, primary: { eyebrow?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ width: number, height: number }> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, items: Array<{ logos?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> }>, primary: { expiration_datetime?: Maybe<any>, card_customer_text?: Maybe<{ text?: Maybe<string> }>, card_subtitle?: Maybe<{ text?: Maybe<string> }>, card_title?: Maybe<{ text?: Maybe<string> }>, text_after_expiration?: Maybe<{ richText: any }>, fine_print?: Maybe<{ richText: any }>, main_text?: Maybe<{ richText: any }>, primary_button_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, primary_button_text?: Maybe<{ text?: Maybe<string> }>, secondary_button_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, secondary_button_text?: Maybe<{ text?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background?: Maybe<string>, vertical_margin?: Maybe<string>, card_price_per_month?: Maybe<number>, gradient_image?: Maybe<{ url?: Maybe<string> }>, mobile_gradient_image?: Maybe<{ url?: Maybe<string> }>, heading?: Maybe<{ richText: any, text?: Maybe<string> }>, description?: Maybe<{ richText: any, text?: Maybe<string> }>, button_text?: Maybe<{ text?: Maybe<string> }>, button_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, more_text?: Maybe<{ richText: any }>, card_heading?: Maybe<{ richText: any, text?: Maybe<string> }>, card_price_subtitle?: Maybe<{ richText: any, text?: Maybe<string> }>, card_button_text?: Maybe<{ text?: Maybe<string> }>, card_button_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }> }, items: Array<{ card_recommended_for?: Maybe<{ text?: Maybe<string> }> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { vertical_margin?: Maybe<string> }, items: Array<{ cta_label?: Maybe<string>, monthly_payment?: Maybe<string>, yearly_payment?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, description?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background?: Maybe<string>, vertical_margin?: Maybe<string>, headline?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ body?: Maybe<{ text?: Maybe<string> }>, heading?: Maybe<{ text?: Maybe<string> }>, image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { vertical_margin?: Maybe<string>, background?: Maybe<string>, heading?: Maybe<{ text?: Maybe<string> }>, description?: Maybe<{ richText: any, html?: Maybe<string>, text?: Maybe<string> }> }, items: Array<{ list_item_1?: Maybe<string>, list_item_2?: Maybe<string>, list_item_3?: Maybe<string>, featured_image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }>, heading?: Maybe<{ text?: Maybe<string> }>, subheading?: Maybe<{ text?: Maybe<string>, richText: any }> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background?: Maybe<string>, heading?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ author_name?: Maybe<string>, author_title?: Maybe<string>, quote?: Maybe<string>, image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { video_link?: Maybe<{ url?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background?: Maybe<string>, vertical_margin?: Maybe<string>, is_video_on_right?: Maybe<boolean>, gradient_image?: Maybe<{ url?: Maybe<string> }>, mobile_gradient_image?: Maybe<{ url?: Maybe<string> }>, wistia_video_url?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, title?: Maybe<{ richText: any }>, description?: Maybe<{ richText: any }> }, items: Array<{ green_check_list_item?: Maybe<{ richText: any }> }> }> } }>, prismicNav?: Maybe<{ _previewable: string, type: string, data: { is_in_beta?: Maybe<boolean>, primary_cta_label?: Maybe<string>, secondary_cta_label?: Maybe<string>, primary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, secondary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, links: Array<{ id: string, slice_label?: Maybe<string>, slice_type: string, primary: { label?: Maybe<{ text?: Maybe<string> }>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, sub_nav_cta_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }, items: Array<{ sub_nav_description?: Maybe<string>, sub_nav_link_icon?: Maybe<string>, sub_nav_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }> }> } }>, prismicFooter?: Maybe<{ type: string, data: { cta_button_label?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_button_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, column1_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column1_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column2_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column2_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column3_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column3_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>> } }>, prismicBanner?: Maybe<{ type: string, data: { show?: Maybe<boolean>, text?: Maybe<{ richText: any }> } }> };

export type PartnerPageTemplateQueryVariables = Exact<{
  uid?: Maybe<Scalars['String']>;
  lang?: Maybe<Scalars['String']>;
}>;


export type PartnerPageTemplateQuery = { prismicPartnerPage?: Maybe<{ _previewable: string, url?: Maybe<string>, type: string, uid: string, id: string, lang: string, alternate_languages: Array<{ id?: Maybe<string>, type?: Maybe<string>, lang?: Maybe<string> }>, data: { page_title?: Maybe<{ text?: Maybe<string> }>, page_description?: Maybe<{ text?: Maybe<string> }>, page_image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string>, dimensions?: Maybe<{ width: number, height: number }> }>, body: Array<{ id: string, slice_type: string, slice_label?: Maybe<string>, primary: { vertical_margin?: Maybe<string>, background?: Maybe<string>, headline_position?: Maybe<string>, number_of_columns?: Maybe<string>, card_text_position?: Maybe<string>, primary_cta_label?: Maybe<string>, secondary_cta_label?: Maybe<string>, headline?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, description?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, primary_cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }>, secondary_cta_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> }, items: Array<{ card_heading?: Maybe<string>, card_body?: Maybe<string>, card_link_label?: Maybe<string>, card_image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ width: number, height: number }> }>, card_link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { eyebrow_headline?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }> }, items: Array<{ logo?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string>, dimensions?: Maybe<{ width: number, height: number }> }>, link?: Maybe<{ url?: Maybe<string>, type?: Maybe<string>, uid?: Maybe<string> }> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, items: Array<{ logos?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> }>, primary: { expiration_datetime?: Maybe<any>, card_customer_text?: Maybe<{ text?: Maybe<string> }>, card_subtitle?: Maybe<{ text?: Maybe<string> }>, card_title?: Maybe<{ text?: Maybe<string> }>, text_after_expiration?: Maybe<{ richText: any }>, fine_print?: Maybe<{ richText: any }>, main_text?: Maybe<{ richText: any }>, primary_button_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, primary_button_text?: Maybe<{ text?: Maybe<string> }>, secondary_button_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, secondary_button_text?: Maybe<{ text?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background?: Maybe<string>, heading?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ author_name?: Maybe<string>, author_title?: Maybe<string>, quote?: Maybe<string>, image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background?: Maybe<string>, vertical_margin?: Maybe<string>, is_video_on_right?: Maybe<boolean>, gradient_image?: Maybe<{ url?: Maybe<string> }>, mobile_gradient_image?: Maybe<{ url?: Maybe<string> }>, wistia_video_url?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, title?: Maybe<{ richText: any }>, description?: Maybe<{ richText: any }> }, items: Array<{ green_check_list_item?: Maybe<{ richText: any }> }> }> } }>, prismicNav?: Maybe<{ _previewable: string, type: string, data: { is_in_beta?: Maybe<boolean>, primary_cta_label?: Maybe<string>, secondary_cta_label?: Maybe<string>, primary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, secondary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, links: Array<{ id: string, slice_label?: Maybe<string>, slice_type: string, primary: { label?: Maybe<{ text?: Maybe<string> }>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, sub_nav_cta_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }, items: Array<{ sub_nav_description?: Maybe<string>, sub_nav_link_icon?: Maybe<string>, sub_nav_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }> }> } }>, prismicFooter?: Maybe<{ type: string, data: { cta_button_label?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_button_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, column1_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column1_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column2_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column2_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column3_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column3_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>> } }>, prismicBanner?: Maybe<{ type: string, data: { show?: Maybe<boolean>, text?: Maybe<{ richText: any }> } }> };

export type PricingTemplateQueryVariables = Exact<{
  lang?: Maybe<Scalars['String']>;
}>;


export type PricingTemplateQuery = { prismicPricingPage?: Maybe<{ _previewable: string, id: string, prismicId: string, type: string, url?: Maybe<string>, lang: string, alternate_languages: Array<{ id?: Maybe<string>, lang?: Maybe<string>, type?: Maybe<string> }>, data: { default_billing_annual?: Maybe<boolean>, page_title?: Maybe<{ text?: Maybe<string> }>, page_image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }>, page_description?: Maybe<{ text?: Maybe<string> }>, title?: Maybe<{ text?: Maybe<string> }>, billing_label?: Maybe<{ text?: Maybe<string> }>, body: Array<{ id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background?: Maybe<string>, primary_cta_icon?: Maybe<string>, primary_cta_label?: Maybe<string>, secondary_cta_icon?: Maybe<string>, secondary_cta_label?: Maybe<string>, vertical_margin?: Maybe<string>, heading?: Maybe<{ text?: Maybe<string> }>, primary_cta_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, secondary_cta_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { cta_icon?: Maybe<string>, title?: Maybe<{ text?: Maybe<string> }>, cta_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, cta_label?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ question?: Maybe<{ text?: Maybe<string> }>, answer?: Maybe<{ richText: any }> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background?: Maybe<string>, vertical_margin?: Maybe<string>, headline?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ body?: Maybe<{ text?: Maybe<string> }>, heading?: Maybe<{ text?: Maybe<string> }>, image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> }> } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { category_title?: Maybe<{ text?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { title?: Maybe<{ text?: Maybe<string> }>, tooltip?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ is_boolean?: Maybe<boolean>, boolean?: Maybe<boolean>, plan?: Maybe<{ id?: Maybe<string> }>, text?: Maybe<{ richText: any }> }> }> } }>, prismicNav?: Maybe<{ _previewable: string, type: string, data: { is_in_beta?: Maybe<boolean>, primary_cta_label?: Maybe<string>, secondary_cta_label?: Maybe<string>, primary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, secondary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, links: Array<{ id: string, slice_label?: Maybe<string>, slice_type: string, primary: { label?: Maybe<{ text?: Maybe<string> }>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, sub_nav_cta_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }, items: Array<{ sub_nav_description?: Maybe<string>, sub_nav_link_icon?: Maybe<string>, sub_nav_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }> }> } }>, prismicFooter?: Maybe<{ type: string, data: { cta_button_label?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_button_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, column1_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column1_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column2_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column2_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column3_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column3_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>> } }>, prismicBanner?: Maybe<{ type: string, data: { show?: Maybe<boolean>, text?: Maybe<{ richText: any }> } }> };

export type PrivacyPolicyQueryQueryVariables = Exact<{
  lang?: Maybe<Scalars['String']>;
}>;


export type PrivacyPolicyQueryQuery = { prismicNav?: Maybe<{ _previewable: string, type: string, data: { is_in_beta?: Maybe<boolean>, primary_cta_label?: Maybe<string>, secondary_cta_label?: Maybe<string>, primary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, secondary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, links: Array<{ id: string, slice_label?: Maybe<string>, slice_type: string, primary: { label?: Maybe<{ text?: Maybe<string> }>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, sub_nav_cta_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }, items: Array<{ sub_nav_description?: Maybe<string>, sub_nav_link_icon?: Maybe<string>, sub_nav_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }> }> } }>, prismicFooter?: Maybe<{ type: string, data: { cta_button_label?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_button_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, column1_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column1_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column2_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column2_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column3_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column3_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>> } }> };

export type TermsOfServiceQueryQueryVariables = Exact<{
  lang?: Maybe<Scalars['String']>;
}>;


export type TermsOfServiceQueryQuery = { prismicNav?: Maybe<{ _previewable: string, type: string, data: { is_in_beta?: Maybe<boolean>, primary_cta_label?: Maybe<string>, secondary_cta_label?: Maybe<string>, primary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, secondary_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, links: Array<{ id: string, slice_label?: Maybe<string>, slice_type: string, primary: { label?: Maybe<{ text?: Maybe<string> }>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, sub_nav_cta_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_cta_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }, items: Array<{ sub_nav_description?: Maybe<string>, sub_nav_link_icon?: Maybe<string>, sub_nav_link_label?: Maybe<{ text?: Maybe<string> }>, sub_nav_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }> }> } }>, prismicFooter?: Maybe<{ type: string, data: { cta_button_label?: Maybe<string>, heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, subheading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, cta_button_link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }>, column1_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column1_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column2_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column2_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, column3_heading?: Maybe<{ html?: Maybe<string>, richText: any, text?: Maybe<string> }>, column3_links?: Maybe<Array<Maybe<{ link_label?: Maybe<string>, link?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>> } }> };

export type UseAllPrismicAcademyPageQueryVariables = Exact<{ [key: string]: never; }>;


export type UseAllPrismicAcademyPageQuery = { allPrismicAcademyPage: { nodes: Array<{ _previewable: string, url?: Maybe<string>, uid: string, type: string, id: string, prismicId: string, lang: string, alternate_languages: Array<{ id?: Maybe<string>, type?: Maybe<string>, lang?: Maybe<string>, uid?: Maybe<string> }>, data: { title?: Maybe<{ text?: Maybe<string> }>, body: Array<{ id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background_image_position?: Maybe<string>, image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { rich_text?: Maybe<{ richText: any }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { text?: Maybe<{ text?: Maybe<string> }>, heading?: Maybe<{ text?: Maybe<string> }> } }>, metadata_image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string> }>, metadata_description?: Maybe<{ text?: Maybe<string> }>, metadata_title?: Maybe<{ text?: Maybe<string> }> } }> } };

export type UseAllPrismicAuthorQueryVariables = Exact<{ [key: string]: never; }>;


export type UseAllPrismicAuthorQuery = { allPrismicAuthor: { nodes: Array<{ id: string, prismicId: string, data: { first_name?: Maybe<{ text?: Maybe<string> }>, last_name?: Maybe<{ text?: Maybe<string> }>, position?: Maybe<{ text?: Maybe<string> }>, picture?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string> }> } }> } };

export type UseAllPrismicBlogPageQueryVariables = Exact<{ [key: string]: never; }>;


export type UseAllPrismicBlogPageQuery = { allPrismicBlogPage: { nodes: Array<{ _previewable: string, url?: Maybe<string>, uid: string, type: string, id: string, prismicId: string, lang: string, last_publication_date: any, first_publication_date: any, tags: Array<string>, alternate_languages: Array<{ id?: Maybe<string>, type?: Maybe<string>, lang?: Maybe<string>, uid?: Maybe<string> }>, data: { publish_date?: Maybe<any>, title?: Maybe<{ text?: Maybe<string> }>, subtitle?: Maybe<{ text?: Maybe<string> }>, metadata_image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }>, authors?: Maybe<Array<Maybe<{ author?: Maybe<{ id?: Maybe<string>, uid?: Maybe<string> }> }>>>, body: Array<{ id: string, slice_type: string, slice_label?: Maybe<string>, primary: { image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string> }>, caption?: Maybe<{ text?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { embed?: Maybe<{ id: string }>, caption?: Maybe<{ text?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }>, caption?: Maybe<{ text?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { content?: Maybe<{ richText: any, text?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { caption?: Maybe<{ richText: any }> }, items: Array<{ image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> }> } | { id: string, slice_label?: Maybe<string>, slice_type: string }> } }> } };

export type UseAllPrismicDocPageQueryVariables = Exact<{ [key: string]: never; }>;


export type UseAllPrismicDocPageQuery = { allPrismicDocPage: { nodes: Array<{ _previewable: string, url?: Maybe<string>, uid: string, type: string, id: string, prismicId: string, lang: string, alternate_languages: Array<{ id?: Maybe<string>, type?: Maybe<string>, lang?: Maybe<string>, uid?: Maybe<string> }>, data: { title?: Maybe<{ text?: Maybe<string> }>, body: Array<{ id: string, slice_type: string, slice_label?: Maybe<string>, primary: { background_image_position?: Maybe<string>, image?: Maybe<{ url?: Maybe<string>, alt?: Maybe<string> }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { rich_text?: Maybe<{ richText: any }> } } | { id: string, slice_type: string, slice_label?: Maybe<string>, primary: { text?: Maybe<{ text?: Maybe<string> }>, heading?: Maybe<{ text?: Maybe<string> }> } }>, metadata_image?: Maybe<{ alt?: Maybe<string>, url?: Maybe<string> }>, metadata_description?: Maybe<{ text?: Maybe<string> }>, metadata_title?: Maybe<{ text?: Maybe<string> }> } }> } };

export type UseAllPrismicPricingPlanQueryVariables = Exact<{ [key: string]: never; }>;


export type UseAllPrismicPricingPlanQuery = { allPrismicPricingPlan: { nodes: Array<{ id: string, prismicId: string, type: string, data: { pricing_type?: Maybe<string>, monthly_cost?: Maybe<number>, annual_cost?: Maybe<number>, monthly_range_minimum?: Maybe<number>, monthly_range_maximum?: Maybe<number>, annual_range_minimum?: Maybe<number>, annual_range_maximum?: Maybe<number>, recommended?: Maybe<boolean>, title?: Maybe<{ text?: Maybe<string> }>, pricing_text?: Maybe<{ text?: Maybe<string> }>, cta_text?: Maybe<{ text?: Maybe<string> }>, cta_link?: Maybe<{ link_type?: Maybe<PrismicLinkTypeEnum>, url?: Maybe<string>, uid?: Maybe<string> }>, pricing_description?: Maybe<{ text?: Maybe<string> }>, pricing_description_tooltip?: Maybe<{ text?: Maybe<string> }>, recommended_for?: Maybe<{ richText: any }> } }> } };

export type UsePrismicAcademySitemapQueryVariables = Exact<{ [key: string]: never; }>;


export type UsePrismicAcademySitemapQuery = { prismicAcademySitemap?: Maybe<{ _previewable: string, data: { top_level_pages?: Maybe<Array<Maybe<{ doc_page?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, body: Array<{ id: string, primary: { name?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ doc_page?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }> }> } }> };

export type UsePrismicSitemapQueryVariables = Exact<{ [key: string]: never; }>;


export type UsePrismicSitemapQuery = { prismicDocsSitemap?: Maybe<{ _previewable: string, data: { top_level_pages?: Maybe<Array<Maybe<{ doc_page?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }>>>, body: Array<{ id: string, primary: { name?: Maybe<{ text?: Maybe<string> }> }, items: Array<{ doc_page?: Maybe<{ id?: Maybe<string>, url?: Maybe<string> }> }> }> } }> };
